/** Shared case module translation keys (merged into locale vocabs). */
export const caseI18nEn = {
  CASE_DOCUMENT: {
    ASSIGNED: 'Assigned',
  },
  CASE_LISTING: {
    FILTER: 'Filter',
    TITLE_WITH_CURRENT_VEHICLE_COUNT: 'Vehicles in Service: {{count}}{{repeatWorkSuffix}}',
    TITLE_WITH_TOTAL_CASE_COUNT: 'Total Case Count: {{count}}',
    ACTIVE_REPEAT_WORK_SUFFIX: ' ({{count}} repeat work order)',
    SUBTITLE: 'View, filter, and manage vehicles in service.',
    CREATE_CASE: 'Create Vehicle Registration',
    COLUMN_CASE: 'Case',
    COLUMN_PLATE: 'Plate',
    COLUMN_CUSTOMER: 'Customer',
    COLUMN_VEHICLE: 'Vehicle information',
    COLUMN_SERVICE_DURATION: 'Time in service',
    COLUMN_VEHICLE_SORT: 'Sort by vehicle',
    COLUMN_RECORD_TYPE: 'Record Type',
    COLUMN_STATUS: 'Status',
    COLUMN_CREATED_DATE: 'Vehicle Entry Date',
    VIEW_RECORD: 'Open record',
    EDIT: 'Edit',
    DELETE: 'Delete',
    DELETE_CONFIRM_TITLE: 'Delete case',
    DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete {{caseNo}}? This action will remove the case from the list.',
    DELETE_CONFIRM_ACTION: 'Delete',
    DELETE_CANCEL: 'Cancel',
    DELETE_FAILED: 'Case could not be deleted.',
    DELETE_REQUEST_CONFIRM_TITLE: 'Request case deletion',
    DELETE_REQUEST_CONFIRM_MESSAGE: 'Request administrator approval to delete {{caseNo}}?',
    DELETE_REQUEST_ACTION: 'Request deletion',
    DELETE_REQUEST_FAILED: 'The deletion request could not be completed.',
    DELETE_REQUEST_ALREADY_PENDING: 'A deletion request is already pending for this case.',
    DELETE_REQUEST_PENDING: 'Deletion request pending',
    DELETE_REQUEST_REVIEW_REQUIRED: 'Deletion review required',
    UNREAD_DELETION_REQUEST_ALERT: 'There are unread deletion requests.',
    DELETE_REQUEST_PENDING_TITLE: 'Deletion request pending',
    DELETE_REQUEST_PENDING_MESSAGE: '{{user}} requested deletion at {{dateTime}}.',
    DELETE_REQUEST_WITHDRAW: 'Withdraw request',
    DELETE_REQUEST_REVIEW_TITLE: 'Review deletion request',
    DELETE_REQUEST_REVIEW_MESSAGE: '{{user}} requested deletion at {{dateTime}}.',
    DELETE_REQUEST_REJECT: 'Reject',
    DELETE_REQUEST_CONFIRM_ACTION: 'Confirm deletion',
    LOADING: 'Loading cases...',
    LOAD_ERROR: 'Cases could not be loaded.',
    EMPTY_STATE: 'No cases found',
    STATUS_NEW: 'Registered',
    STATUS_ASSIGNED: 'Waiting in Queue',
    STATUS_WAITING: 'Waiting',
    STATUS_IN_PROGRESS: 'In Progress',
    STATUS_DONE: 'Done',
    STATUS_IN_SERVICE: 'In service',
    STATUS_PARTS_PENDING: 'Parts Pending',
    STATUS_READY: 'Ready for delivery',
    STATUS_DELIVERED: 'Delivered',
    COLUMN_INVOICE_ISSUED: 'Historical invoice issued',
    COLUMN_INVOICE_STATUS: 'Invoice Status',
    INVOICE_STATUS_NOT_ISSUED: 'Not issued',
    INVOICE_STATUS_ISSUED: 'Invoice issued',
    INVOICE_STATUS_COLLECTED: 'Invoice collected',
    FILTER_INVOICE_ISSUED: 'Show historically issued billing',
    INVOICE_ISSUED_YES: 'Yes',
    INVOICE_ISSUED_NO: 'No',
    RECORD_TYPE_DAMAGE: 'Damage',
    RECORD_TYPE_MECHANICAL: 'Mechanical',
    OWNER_INDIVIDUAL: 'Individual',
    OWNER_CORPORATE: 'Corporate',
    PROJECT_DAMAGE_OPS: 'Damage Operations',
    PROJECT_PERIODIC_MAINTENANCE: 'Periodic Maintenance',
    FILTER_APPLY: 'Apply',
    FILTER_CLEAR: 'Clear',
    FILTER_CANCEL: 'Cancel',
    FILTER_ALL: 'All',
    ENTRY_ALL: 'All',
    ENTRY_MAIN: 'Main',
    ENTRY_REPEAT: 'Repeat',
    ENTRY_TYPE: 'Entry type',
    DAMAGE_TYPE: 'Damage type',
    PLATE_SEARCH_LABEL: 'Plate search:',
    WORK_ORDER_SEARCH_LABEL: 'Work order search:',
    FILTER_PLATE_PLACEHOLDER: 'Filter by plate',
    FILTER_CREATED_FROM: 'Vehicle entry start',
    FILTER_CREATED_TO: 'Vehicle entry end',
    COLUMN_PLATE_SORT: 'Sort by plate',
    COLUMN_WORK_ORDER_NUMBERS: 'Work order numbers',
    COLUMN_CUSTOMER_SORT: 'Sort by customer',
    COLUMN_CREATED_DATE_SORT: 'Sort by vehicle entry date',
    DISPLAY_DELIVERED: 'Display delivered',
    REPORT_DOWNLOAD: 'Export List',
    REPORT_DOWNLOADING: 'Preparing report...',
    REPORT_DOWNLOAD_ERROR: 'The report could not be downloaded. Please try again.',
  },
  CASE_DETAIL: {
    BACK_TO_FILES: 'Back to files',
    CLOSE: 'Close',
    LOADING: 'Loading case...',
    LOAD_ERROR: 'Case could not be loaded.',
    IN_SERVICE: 'In service',
    STATUS_PENDING: 'Pending',
    STATUS_REGISTERED: 'Registered',
    STATUS_ASSIGNED: 'Waiting in queue',
    STATUS_IN_SERVICE: 'In service',
    STATUS_READY: 'Ready for delivery',
    STATUS_DELIVERED: 'Delivered',
    TAB_OVERVIEW: 'Overview',
    TAB_DAMAGE_INSURANCE: 'Damage & Insurance Information',
    ACCIDENT_PARTIES_TITLE: 'Counterparties',
    ACCIDENT_SINGLE_VEHICLE: 'Single-vehicle traffic accident',
    ACCIDENT_PARTY_DOCUMENT_COUNT: 'documents',
    ACCIDENT_PARTY_NO_DOCUMENTS: 'No documents',
    ACCIDENT_VEHICLES_SUFFIX: 'vehicles',
    TAB_DAMAGE_MAP: 'Appraisal',
    TAB_WORK_ORDER: 'Work Order',
    TAB_PHOTOS: 'Photos',
    TAB_DOCUMENTS: 'Documents',
    TAB_OFFICIAL_FORMS: 'Official Forms',
    TAB_BILLING: 'Invoice',
    BILLING_SAVE: 'Save',
    BILLING_SAVING: 'Saving...',
    BILLING_EXPORT_INVOICE: 'Generate Invoice',
    BILLING_BASE_LABOR: 'Base Labor',
    BILLING_PART_TOTAL: 'Parts Total',
    BILLING_EXTRA_SERVICES: 'Extra Services',
    BILLING_ITEM_COUNT: '{{count}} items',
    BILLING_ACTIVE_ROWS: '{{count}} active rows',
    BILLING_ACTIVE: '{{count}} active',
    BILLING_REGISTERED_LABOR: 'Registered Labor',
    BILLING_EMPTY_LABOR: 'No registered labor amount yet.',
    BILLING_REGISTERED_PARTS: 'Registered Parts',
    BILLING_PART_LINE_DEFAULT: 'Part line item',
    BILLING_EMPTY_PARTS: 'No priced part items yet.',
    BILLING_SUMMARY_REGISTERED_LABOR: 'Registered labor',
    BILLING_SUMMARY_REGISTERED_PART: 'Registered parts',
    BILLING_SUMMARY_EXTRA_BILLABLE: 'Extra amount billable to customer',
    BILLING_SUBTOTAL: 'Subtotal',
    BILLING_VAT_RATE: 'VAT Rate',
    BILLING_VAT: 'VAT',
    BILLING_GRAND_TOTAL: 'Grand Total',
    BILLING_DISCOUNT_RATE: 'Discount %',
    BILLING_DISCOUNT_AMOUNT: 'Discount amount',
    BILLING_NET_AMOUNT: 'Net amount',
    BILLING_ITEM_DISCOUNTS: 'Line discounts',
    BILLING_FINAL_DISCOUNT: 'Final discount',
    BILLING_FINAL_DISCOUNT_AMOUNT: 'Final discount amount',
    BILLING_TAX_BASE: 'VAT base',
    BILLING_NET_SUBTOTAL: 'Net subtotal',
    BILLING_TOTAL_TITLE: 'Total',
    BILLING_SECTION_LABOR: 'Labors',
    BILLING_SECTION_PARTS: 'Parts',
    BILLING_SECTION_EXTRA: 'Extra services & labor',
    BILLING_COL_WORK_ORDER: 'Work order',
    BILLING_COL_PART: 'Part',
    BILLING_COL_GROSS: 'Gross',
    BILLING_COL_DISCOUNT: 'Discount',
    BILLING_COL_NET: 'Net',
    BILLING_EXTRA_SERVICE_ENTRIES: 'Extra service and labor entries',
    BILLING_COL_SERVICE: 'Service',
    BILLING_COL_RESULT: 'Result / Notes',
    BILLING_COL_AMOUNT: 'Amount',
    BILLING_COL_BILLABLE: 'Bill to Customer',
    BILLING_COL_REASON: 'Reason',
    BILLING_PLACEHOLDER_RESULT: 'Result or note',
    BILLING_PLACEHOLDER_AMOUNT: 'Amount: 0.00',
    BILLING_PLACEHOLDER_BILLABLE: 'Billable: 0.00',
    BILLING_PLACEHOLDER_REASON: 'Invoice reason',
    BILLING_REMOVE_ROW: 'Remove row',
    BILLING_PLACEHOLDER_NEW_SERVICE: 'New service or extra labor name',
    BILLING_ADD_LINE: 'Add Line',
    BILLING_BASE_AMOUNT: 'Base price',
    BILLING_CANCEL: 'Cancel',
    BILLING_CONFIRM_ADD: 'Add',
    BILLING_SERVICE_DAMAGE_LABOR: 'Damage labor',
    BILLING_SERVICE_BREAKDOWN_REPAIR: 'Breakdown repair',
    BILLING_SERVICE_RENTAL_CAR: 'Rental car',
    BILLING_SERVICE_DAMAGE_PARTS: 'Damage parts',
    BILLING_SAVE_SUCCESS: 'Billing information saved.',
    BILLING_SAVE_ERROR: 'Billing information could not be saved.',
    BILLING_LOCKED: 'Accounting is locked after payment or delivery.',
    INVOICE_ISSUED: 'Invoice Issued',
    INVOICE_NOT_ISSUED: 'Invoice Not Issued',
    INVOICE_ISSUED_AT: 'Issued: {{value}}',
    INVOICE_ISSUED_UPDATING: 'Updating',
    INVOICE_ISSUED_PREREQUISITE: 'Available after all work orders have been completed and approved.',
    INVOICE_ISSUED_PERMISSION_REQUIRED: 'You do not have permission to update this invoice status.',
    INVOICE_ISSUED_SAVE_ERROR: 'Invoice status could not be updated.',
    INVOICE_COLLECTED: 'Invoice Collected',
    INVOICE_NOT_COLLECTED: 'Invoice Not Collected',
    INVOICE_COLLECTED_AT: 'Collected: {{value}}',
    INVOICE_COLLECTED_UPDATING: 'Updating',
    INVOICE_COLLECTED_PREREQUISITE: 'Available after the invoice has been issued.',
    INVOICE_COLLECTED_SAVE_ERROR: 'Invoice collection status could not be updated.',
    INVOICE_COLLECTION_METHOD_TITLE: 'Record Invoice Collection',
    INVOICE_COLLECTION_METHOD_PROMPT: 'Select the payment method.',
    INVOICE_COLLECTION_PAYMENT_METHOD: 'Payment method: {{value}}',
    INVOICE_COLLECTION_PAYMENT_METHOD_1: 'Credit Card',
    INVOICE_COLLECTION_PAYMENT_METHOD_2: 'Cash',
    INVOICE_COLLECTION_PAYMENT_METHOD_3: 'Bank Transfer',
    INVOICE_COLLECTION_CANCEL: 'Cancel',
    INVOICE_COLLECTION_CONFIRM: 'Confirm Collection',
    INVOICE_COLLECTION_CLEAR_TITLE: 'Clear invoice collection?',
    INVOICE_COLLECTION_CLEAR_MESSAGE: 'This removes the invoice collection timestamp and payment method.',
    INVOICE_COLLECTION_CLEAR_CONFIRM: 'Clear Collection',
    INVOICE_ISSUED_COLLECTION_MUST_BE_CLEARED: 'Clear invoice collection before removing the issued mark.',
    BILLING_INVOICE_ISSUED_LOCKED: 'Accounting entries cannot be changed while the invoice is issued.',
    BILLING_LEGACY_TITLE: 'Legacy accounting calculation',
    BILLING_LEGACY_HINT: 'This record keeps its original total until you explicitly convert it to dynamic per-line pricing.',
    BILLING_CONVERT_ACTION: 'Convert to Dynamic Pricing',
    BILLING_CONVERT_TITLE: 'Convert accounting calculation?',
    BILLING_CONVERT_MESSAGE: 'The existing total is {{oldTotal}}. The converted per-line total will be {{newTotal}} (difference: {{difference}}). This conversion cannot be undone from this screen.',
    BILLING_CONVERT_CONFIRM: 'Convert and Save',
    BILLING_ADJUSTMENT_COUNT: '{{count}} adjustments',
    BILLING_ADJUSTMENT_LABEL: 'Adjustment description',
    BILLING_TYPE_PERCENT_DISCOUNT: 'Percentage discount',
    BILLING_TYPE_PERCENT_TAX: 'Percentage tax',
    BILLING_ADD_ADJUSTMENT: 'Add adjustment',
    BILLING_REMOVE_ADJUSTMENT: 'Remove adjustment',
    BILLING_MOVE_UP: 'Move adjustment up',
    BILLING_MOVE_DOWN: 'Move adjustment down',
    BILLING_TOTAL_DISCOUNTS: 'Total discounts',
    BILLING_TOTAL_TAXES: 'Total taxes',
    BILLING_DEFAULT_TAX_LABEL: 'VAT',
    BILLING_LEGACY_LINE_DISCOUNT: 'Legacy line discount',
    BILLING_LEGACY_FINAL_DISCOUNT: 'Legacy final discount',
    BILLING_ADJUSTMENT_VALIDATION_ERROR: 'Enter a description and a valid non-negative value for every adjustment. Percentage values cannot exceed 100.',
    DOCUMENT_LOAD_ERROR: 'Document could not be loaded.',
    DOCUMENT_UPLOAD_ERROR: 'Upload failed. Please try again.',
    TAB_DELIVERY: 'Delivery & Signature',
    TAB_TIMESTAMPS: 'Update Timestamps',
    TIMESTAMPS_TITLE: 'Update Timestamps',
    TIMESTAMPS_HINT: 'All times are edited in Turkey time.',
    TIMESTAMPS_LOADING: 'Loading timestamps...',
    TIMESTAMPS_LOAD_ERROR: 'Timestamps could not be loaded.',
    TIMESTAMPS_SAVE: 'Save timestamps',
    TIMESTAMPS_SAVING: 'Saving...',
    TIMESTAMPS_SAVE_ERROR: 'Timestamps could not be saved.',
    TIMESTAMPS_CONFLICT_ERROR: 'The record has changed. Reload the timestamps before saving again.',
    TIMESTAMPS_VALIDATION_ERROR: 'Check the entered dates and times. The collection date cannot be cleared or precede invoice issuance.',
    TIMESTAMPS_COLLECTION_DATE_REQUIRED: 'Enter both the collection date and time. An existing collection date cannot be cleared.',
    TIMESTAMPS_COLLECTION_BEFORE_ISSUE: 'The collection time cannot be earlier than the invoice issue time.',
    TIMESTAMPS_CASE: 'Case',
    TIMESTAMPS_CASE_CREATED: 'Created at',
    TIMESTAMPS_CASE_AND_VEHICLE_REGISTERED: 'Case and vehicle registered at',
    TIMESTAMPS_INVOICE_ISSUED: 'Historical invoice issued at',
    TIMESTAMPS_INVOICE_COLLECTED: 'Historical invoice collected at',
    TIMESTAMPS_CASE_DELIVERED: 'Case delivered at',
    TIMESTAMPS_SIGNATURE: 'Delivery Signature',
    TIMESTAMPS_SIGNATURE_SIGNED: 'Signed at',
    TIMESTAMPS_STATUS_HISTORY: 'Status History',
    TIMESTAMPS_EMPTY_EVENTS: 'No timestamped events were found.',
    TIMESTAMPS_EVENTS: 'Events',
    TIMESTAMPS_WORK_ORDERS: 'Work Orders',
    TIMESTAMPS_WORK_ORDER_CREATED: 'Created at',
    TIMESTAMPS_ADDITIONAL_WORK_ORDER_CREATED: 'Additional work order created at',
    TIMESTAMPS_REPEAT_WORK_ORDER_CREATED: 'Repeat work order created at',
    TIMESTAMPS_ADDITIONAL_APPROVED: 'Additional work approved at',
    TIMESTAMPS_EXPECTED_DELIVERY: 'Delivery appointment',
    TIMESTAMPS_WORK_ORDER_DELIVERED: 'Delivered at',
    TIMESTAMPS_REPEAT_WORK_ORDER_DELIVERED: 'Repeat work order delivered at',
    EXPECTED_DELIVERY_STATUS: 'Delivery appointment',
    EXPECTED_DELIVERY_DAYS_LEFT: '{{count}} days left',
    EXPECTED_DELIVERY_DAYS_AGO: '{{count}} days ago',
    EXPECTED_DELIVERY_TODAY: 'Today',
    VEHICLE_CUSTOMER_INFO: 'Vehicle, Customer & Registered Owner',
    REGISTERED_OWNER_SAME_AS_CUSTOMER: 'Same as the customer',
    LABEL_BRAND_MODEL: 'Brand / Model',
    LABEL_MODEL_YEAR: 'Model Year',
    LABEL_MILEAGE: 'Mileage',
    REGISTRATION_SIGNATURE_TITLE: 'Registration Signature',
    REGISTRATION_SIGNATURE_META: 'Captured on {{date}} by {{user}}',
    VIEW_SIGNATURE: 'View signature',
    LABEL_PLATE: 'Plate',
    LABEL_CUSTOMER_TYPE: 'Customer Type',
    LABEL_CUSTOMER: 'Customer',
    LABEL_PHONE: 'Phone',
    ACCIDENT_PARTY_NAME: 'Name / Surname',
    STATUS_HISTORY: 'Status History',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    DELIVERY_READINESS: 'Delivery Readiness Check',
    QUICK_ACCESS: 'Quick Access',
    PHOTOS: 'Photos',
    PHOTO_COUNT: '{{count}} photos',
    DOCUMENTS_MISSING: 'Documents missing: {{groups}}',
    DOCUMENT_SET_COMPLETE: 'Document set complete',
    DOCUMENTS: 'Documents',
    DOCUMENT_COUNT: '{{count}} documents',
    FILE_CHAT: 'File Chat',
    MESSAGE_COUNT: '{{count}} messages',
    CHAT_LOADING: 'Loading messages...',
    CHAT_EMPTY: 'No messages yet.',
    CHAT_LOAD_ERROR: 'Messages could not be loaded.',
    CHAT_SEND_ERROR: 'Message could not be sent.',
    CHAT_PARTICIPANT: 'Participant',
    WORK_ORDER_TODO: 'Work order',
    WORK_ORDER: 'Work order',
    ANALYST_NOTES: 'Analyst notes',
    REPEAT_WORK_ORDER_NOTES: 'Work repeat notes',
    ADD_ANALYST_NOTES: 'Add note',
    EDIT_ANALYST_NOTES: 'Edit note',
    ANALYST_NOTES_PLACEHOLDER: 'Add an analyst note',
    ANALYST_NOTES_SAVE: 'Save',
    ANALYST_NOTES_SAVING: 'Saving...',
    ANALYST_NOTES_SAVE_ERROR: 'Analyst notes could not be saved. Please try again.',
    WORK_PROCESS: 'Process',
    RESPONSIBILITY: 'Responsibility',
    WORKSHOP: 'Workshop',
    NEXT_STEP: 'Next step:',
    SPARE_PARTS: 'Spare parts',
    PARTS_READY_COUNT: '{{ready}} of {{total}} ready',
    PART_STATUS_0: 'Unavailable',
    PART_STATUS_1: 'Available',
    PART_STATUS_2: 'Ordered',
    ADD_SPARE_PART: 'Add spare part',
    DELETE_SPARE_PART: 'Delete spare part',
    DELETE_SPARE_PART_CONFIRM_TITLE: 'Delete spare part?',
    DELETE_SPARE_PART_CONFIRM_MESSAGE: 'Remove {{part}} from {{workOrder}}? This cannot be undone.',
    DELETE_SPARE_PART_ERROR: 'The spare part could not be deleted. Please try again.',
    SAVE_PART_CHANGES: 'Save changes',
    WORK_PHOTOS: 'Work photos',
    REMOVE_PHOTO: 'Remove photo',
    NO_WORK_ORDERS: 'No work orders have been created yet.',
    WORKFLOW_PARTS: 'Spare Parts',
    WORKFLOW_WORK_STARTED: 'Work Started',
    WORKFLOW_WORK_COMPLETED: 'Work Completed',
    WORKFLOW_WORK_APPROVED: 'Work Approved',
    WORKFLOW_COMPLETE: 'Work is complete.',
    NEXT_REVIEW_PARTS: 'Review the required spare parts.',
    NEXT_AWAIT_PARTS: 'Wait for ordered spare parts to arrive.',
    NEXT_ASSIGN_TECHNICIAN: 'Assign a matching technician.',
    NEXT_START_WORK: 'Start the assigned work.',
    NEXT_COMPLETE_WORK: 'Complete the work and add after photos.',
    NEXT_REVIEW_WORK: 'Review the technician completion.',
    PART_NAME: 'Part name',
    PART_QUANTITY: 'Quantity',
    PART_UNIT_COST: 'Unit cost',
    PART_SALE_PRICE: 'Sale price',
    PART_NAME_REQUIRED: 'Enter a part name.',
    PART_QUANTITY_INVALID: 'Quantity must be a whole number of at least 1.',
    ADD: 'Add Part',
    DOCUMENT_MANAGEMENT: 'Document Management',
    MANDATORY_DOCUMENTS_TITLE: 'Mandatory Documents',
    MANDATORY_DOCUMENTS_COMPLETION: 'document groups complete',
    UPDATE_MANDATORY_DOCUMENTS: 'Update Mandatory Documents',
    EDIT_DELIVERY_REQUIREMENTS: 'Edit delivery requirements',
    DELIVERY_REQUIREMENTS_TITLE: 'Required for final delivery',
    REQUIREMENT_MODAL_CANCEL: 'Cancel',
    REQUIREMENT_MODAL_SAVE: 'Save',
    DELIVERY_DOCUMENT_14: 'Alcohol report',
    DELIVERY_DOCUMENT_19: 'Signature circular',
    DELIVERY_DOCUMENT_25: 'Invoice',
    DELIVERY_DOCUMENT_38: 'Driver identity copy',
    DELIVERY_DOCUMENT_39: 'Vehicle owner identity copy',
    DELIVERY_DOCUMENT_40: 'Professional identity copy',
    DELIVERY_DOCUMENT_41: 'Disability / guardianship document',
    DELIVERY_DOCUMENT_42: 'Witness and statement document',
    DELIVERY_DOCUMENT_43: 'MASAK document',
    DELIVERY_DOCUMENT_44: 'Undertaking document',
    DELIVERY_DOCUMENT_45: 'Release document',
    DELIVERY_DOCUMENT_46: 'VAT payment / reflection invoice',
    DELIVERY_DOCUMENT_47: 'Other document',
    ASSOCIATED_DOCUMENTS_TITLE: 'Additional Documents',
    UPDATE_ADDITIONAL_DOCUMENTS: 'Update Additional Documents',
    ASSOCIATED_DOCUMENTS_EMPTY: 'No files have been added yet.',
    DAMAGE_ANALYSIS_PHOTOS_TITLE: 'Damage Analysis Photos',
    WORK_ORDER_PHOTOS_TITLE: 'Work Order Photos',
    DELIVERY_PHOTOS_TITLE: 'Delivery Photos',
    DOCUMENT_ASSIGNMENT_EDIT: 'Edit documents',
    DOCUMENT_ASSIGNMENT_EXIT_EDIT: 'Close edit mode',
    DOCUMENT_ASSIGNMENT_SEARCH_TITLE: 'Search / select media files',
    DOCUMENT_ASSIGNMENT_SEARCH_HINT: 'Find incoming WhatsApp or manually uploaded media files, then assign them to the case document groups.',
    DOCUMENT_ASSIGNMENT_SEARCH_LABEL: 'Phone / uploader search',
    DOCUMENT_ASSIGNMENT_SEARCH_PLACEHOLDER: 'Type at least 3 phone digits',
    DOCUMENT_ASSIGNMENT_REFRESH: 'Refresh',
    DOCUMENT_ASSIGNMENT_UPLOAD: 'Upload media',
    DOCUMENT_ASSIGNMENT_LOADING: 'Loading documents',
    DOCUMENT_ASSIGNMENT_LOAD_ERROR: 'Documents could not be loaded. Please try again.',
    DOCUMENT_ASSIGNMENT_EMPTY: 'No incoming documents yet',
    DOCUMENT_ASSIGNMENT_EMPTY_HINT: 'Documents from WhatsApp or manual upload will be listed here.',
    DOCUMENT_ASSIGNMENT_COUNT_SUFFIX: 'documents',
    DOCUMENT_ASSIGNMENT_MANUAL_UPLOADS: 'Manual Uploads',
    DOCUMENT_ASSIGNMENT_SELECTED: 'Selected',
    DOCUMENT_ASSIGNMENT_ASSIGNED: 'Assigned',
    DOCUMENT_ASSIGNMENT_SLOT_TITLE: 'Assign documents',
    DOCUMENT_ASSIGNMENT_SLOT_HINT: 'Select a document from the search area, then assign it to a document group below or on the counterparty screen.',
    DOCUMENT_DROP_UPLOADING: 'Uploading and assigning...',
    DOCUMENT_DROP_UPLOAD_ERROR: 'Files could not be uploaded. Please try again.',
    DOCUMENT_BROWSER_DROP_UPLOADING: 'Uploading files...',
    DOCUMENT_ASSIGNMENT_EMPTY_SLOT: 'Empty',
    DOCUMENT_ASSIGNMENT_DROP_HERE: 'Select a document and assign it here',
    DOCUMENT_ASSIGNMENT_SELECT_FIRST: 'Select a photo first',
    DOCUMENT_ASSIGNMENT_ASSIGN_SELECTED: 'Assign selected',
    DOCUMENT_ASSIGNMENT_REMOVE: 'Remove assigned document',
    DOCUMENT_ASSIGNMENT_SAVE: 'Save changes',
    DOCUMENT_ASSIGNMENT_SAVING: 'Saving...',
    DOCUMENT_ASSIGNMENT_SAVE_SUCCESS: 'Document assignments saved.',
    DOCUMENT_ASSIGNMENT_SAVE_ERROR: 'Document assignments could not be saved.',
    ADDITIONAL_DOCUMENTS_TITLE: 'Additional Documents',
    ADDITIONAL_DOCUMENTS_HINT: 'Supporting documents uploaded for this case.',
    ADDITIONAL_DOCUMENTS_EMPTY: 'No additional documents have been uploaded yet.',
    ADDITIONAL_DOCUMENT_EDIT: 'Edit additional documents',
    ADDITIONAL_DOCUMENT_EXIT_EDIT: 'Close additional document editing',
    ADDITIONAL_DOCUMENT_EXISTING_TITLE: 'Existing documents',
    ADDITIONAL_DOCUMENT_ADD_TITLE: 'Add documents',
    ADDITIONAL_DOCUMENT_TYPE_LABEL: 'Document type',
    ADDITIONAL_DOCUMENT_TYPE_PLACEHOLDER: 'Select a document type',
    ADDITIONAL_DOCUMENT_TYPE_NO_RESULTS: 'No matching document type',
    ADDITIONAL_DOCUMENT_DROP_TITLE: 'Drop files here or click to choose',
    ADDITIONAL_DOCUMENT_DROP_HINT: 'Image, PDF, DOC, DOCX or TXT',
    ADDITIONAL_DOCUMENT_PENDING_TITLE: 'Pending uploads',
    ADDITIONAL_DOCUMENT_PENDING_DELETION: 'Pending deletion',
    ADDITIONAL_DOCUMENT_DELETE: 'Delete document',
    ADDITIONAL_DOCUMENT_UNDO_DELETE: 'Undo deletion',
    ADDITIONAL_DOCUMENT_REMOVE_PENDING: 'Remove pending upload',
    ADDITIONAL_DOCUMENT_SAVE: 'Save changes',
    ADDITIONAL_DOCUMENT_SAVING: 'Saving...',
    ADDITIONAL_DOCUMENT_ACCIDENT_REPORT: 'Accident Report',
    ADDITIONAL_DOCUMENT_STATEMENT_REPORT: 'Statement Report',
    ADDITIONAL_DOCUMENT_WITNESS_ASSESSMENT_REPORT: 'Witness Assessment Report',
    ADDITIONAL_DOCUMENT_ALCOHOL_REPORT: 'Alcohol Report',
    ADDITIONAL_DOCUMENT_METEOROLOGY_REPORT: 'Meteorology Report',
    ADDITIONAL_DOCUMENT_IDENTITY_DOCUMENT: 'Identity Document',
    ADDITIONAL_DOCUMENT_TAX_CERTIFICATE: 'Tax Certificate',
    ADDITIONAL_DOCUMENT_SIGNATURE_CIRCULAR: 'Signature Circular',
    ADDITIONAL_DOCUMENT_ENDORSEMENT: 'Endorsement',
    ADDITIONAL_DOCUMENT_TRADE_REGISTRY_GAZETTE: 'Trade Registry Gazette',
    ADDITIONAL_DOCUMENT_RETURNED_PART_DELIVERY_FORM: 'Returned Part Delivery Form',
    ADDITIONAL_DOCUMENT_AUTO_KING_ASSESSMENT_FORM: 'Auto King Bumper Repair and Damage Assessment Form',
    ADDITIONAL_DOCUMENT_CHASSIS_NUMBER_PHOTO: 'Chassis Photo',
    ADDITIONAL_DOCUMENT_INVOICE: 'Invoice',
    ADDITIONAL_DOCUMENT_TOWING_INVOICE: 'Towing Invoice',
    ADDITIONAL_DOCUMENT_HOMER_WARRANTY_CERTIFICATE: 'Homer Warranty Certificate',
    ADDITIONAL_DOCUMENT_PART_OFFER_FORM: 'Part Offer Form',
    ADDITIONAL_DOCUMENT_HLD_INVOICE: 'HLD Invoice',
    ADDITIONAL_DOCUMENT_HOMER_REFLECTION_INVOICE: 'Homer Reflection Invoice',
    ADDITIONAL_DOCUMENT_SERVICE_INVOICE: 'Service Invoice',
    ADDITIONAL_DOCUMENT_SERVICE_CUSTOMER_INVOICE: 'Service Customer Invoice',
    ADDITIONAL_DOCUMENT_ACTUAL_SERVICE_INVOICE: 'Actual Service Invoice',
    CASE_DOCUMENT_SUMMARY_TITLE: 'Assigned case documents',
    CASE_DOCUMENT_SUMMARY_TEXT: 'Documents uploaded during case registration are grouped below by document type.',
    CASE_DOCUMENT_PREVIEW_HINT: 'Click any document to open the full preview.',
    VEHICLE_ANALYSIS_PHOTO_GATE_TITLE: 'Upload vehicle photos',
    VEHICLE_ANALYSIS_PHOTO_GATE_HINT: 'Upload at least one current vehicle photo to begin vehicle analysis.',
    VEHICLE_ANALYSIS_PHOTO_GATE_REQUIREMENT: 'Attach at least {{count}} allowed vehicle documents to begin vehicle analysis.',
    VEHICLE_ANALYSIS_PHOTO_GATE_MINIMUM: 'Add at least {{count}} photos ({{remaining}} more required).',
    VEHICLE_ANALYSIS_PHOTO_GATE_DROP: 'Drop photos here',
    VEHICLE_ANALYSIS_PHOTO_GATE_SELECT: 'Select photos',
    VEHICLE_ANALYSIS_PHOTO_GATE_IMAGE_ONLY: 'Only image files can be uploaded.',
    VEHICLE_ANALYSIS_PHOTO_GATE_COUNT: '{{count}} photos added',
    VEHICLE_ANALYSIS_PHOTO_GATE_CONTINUE: 'Upload and continue',
    VEHICLE_ANALYSIS_PHOTO_GATE_UPLOAD_ERROR: 'Vehicle analysis photos could not be uploaded.',
    VEHICLE_ANALYSIS_PHOTO_GATE_REQUIRED: 'Upload at least one vehicle analysis photo before continuing.',
    CASE_DOCUMENT_GROUP_DAMAGED_CAR: 'Vehicle Photo',
    CASE_DOCUMENT_GROUP_DRIVING_LICENSE: 'Driving License',
    CASE_DOCUMENT_GROUP_REGISTRATION: 'Registration',
    CASE_DOCUMENT_GROUP_POLICY: 'Traffic Insurance Policy',
    CASE_DOCUMENT_GROUP_KM_FUEL_GAUGE: 'KM / Fuel Gauge',
    CASE_DOCUMENT_GROUP_KASKO_POLICY: 'Casco Policy',
    CASE_DOCUMENT_GROUP_DECLARATION: 'Declaration Report',
    CASE_DOCUMENT_GROUP_MUTUAL_ACCIDENT_REPORT: 'Mutual Accident Report',
    CASE_DOCUMENT_GROUP_PRELIMINARY_EXPERTISE_FORM: 'Preliminary Expertise Form',
    CASE_DOCUMENT_GROUP_SCENE_PHOTOS: 'Scene Photos',
    CASE_DOCUMENT_GROUP_REPORT: 'Report',
    CASE_PHOTO_GROUP_DELIVERY_FINAL: 'Final Delivery Photos',
    CASE_DOCUMENT_EMPTY_DAMAGED_CAR: 'No vehicle photos uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_DRIVING_LICENSE: 'No driving license documents uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_REGISTRATION: 'No registration documents uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_POLICY: 'No traffic insurance policy documents uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_KM_FUEL_GAUGE: 'No KM / fuel gauge documents uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_KASKO_POLICY: 'No Casco policy documents uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_DECLARATION: 'No declaration reports uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_MUTUAL_ACCIDENT_REPORT: 'No mutual accident reports uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_PRELIMINARY_EXPERTISE_FORM: 'No preliminary expertise forms uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_SCENE_PHOTOS: 'No scene photos uploaded for this case yet.',
    CASE_DOCUMENT_EMPTY_REPORT: 'No accident reports uploaded for this case yet.',
    CASE_PHOTO_EMPTY_DELIVERY_FINAL: 'No final delivery photos uploaded for this case yet.',
    DOCUMENT_MISSING: 'Document Missing',
    NO_DOCUMENTS_UPLOADED: 'No documents uploaded',
    DOCUMENT_SOURCE_GROUP_READY: 'Documents available',
    UPLOADED: 'Uploaded',
    UPLOAD: 'Upload',
    PHOTO_REQUIRED_NOTE: 'Required photos (before, after, delivery) must be completed before the file can be marked ready for delivery.',
    DOCUMENT_PREVIEW_HINT: 'Document preview is not available in the browser. Click the download button to view.',
    DOCUMENT_MOBILE_PREVIEW_HINT: 'Document preview cannot be displayed in the mobile browser.',
    DOCUMENT_BROWSER_PREVIEW_HINT: 'This document can be previewed in the browser or downloaded.',
    DOCUMENT_PREVIEW: 'Preview',
    DOCUMENT_PREVIEW_PREVIOUS: 'Show previous document',
    DOCUMENT_PREVIEW_NEXT: 'Show next document',
    DOCUMENT_PRINT: 'Print',
    DOCUMENT_DOWNLOAD: 'Download',
    MISSING_REQUIRED_DOCS: 'Missing required documents',
    MISSING_DOCS_NOTE: '{{count}} documents must be uploaded before the file can be closed.',
    DOC_MANAGEMENT: 'Document Management',
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    PARTS_PENDING: 'Parts pending',
    PARTS_COMPLETED: 'Parts completed',
    TOTAL_PARTS_COST: 'Total parts cost',
    PART_NAME_PLACEHOLDER: 'Part name',
    PART_COUNT_INPUT: 'Part count',
    REQUESTED_FOR_WORK: 'Requested for: {{work}}',
    GO_TO_WORK_ORDER: 'Go to work order',
    WORK_ORDER_REQUESTS_AVAILABLE_AFTER_ANALYSIS: 'Additional work items and part requests become available after damage analysis is completed.',
    INTERNAL_CHAT: 'Internal File Chat',
    CHAT_SEND: 'Send message',
    CHAT_PLACEHOLDER: 'Write an internal team message...',
    PRE_DELIVERY_CHECK: 'Pre-delivery Missing Check',
    PRINTABLE_DOCUMENTS: 'Printable Documents',
    PRINT_WORK_ORDER: 'Print',
    WORK_ORDER_PRINT_TITLE: 'Work Order',
    PRINT_ALL_WORK_ORDERS: 'Print All Work Orders',
    WORK_ORDER_LIST_PRINT_TITLE: 'All Work Orders',
    DIGITAL_SIGNATURE: 'Digital Signature',
    SIGNATURE_TABLET_HINT: 'Capture customer signature on tablet:',
    SIGNATURE_LOCKED_HINT: 'A signature is already saved. Tap Clear to capture a new one.',
    SIGNATURE_META: 'Linked with signature date/time and user',
    SAVE_SIGNATURE: 'Save Signature',
    SAVING_SIGNATURE: 'Saving...',
    SIGNATURE_SAVED: 'Signature saved',
    SIGNATURE_EMPTY: 'Please draw a signature in the field',
    SIGNATURE_CLEAR_BEFORE_SAVE: 'Clear the existing signature before saving a new one',
    SIGNATURE_SAVE_ERROR: 'Signature could not be saved. Please try again.',
    SIGNATURE_META_SAVED: 'Saved on {{date}} by {{user}}',
    SIGNATURE_EXPAND: 'Expand signature',
    SIGNATURE_COLLAPSE: 'Exit full screen',
    CLEAR: 'Clear',
    DELIVERY_SATISFACTION: 'Delivery & Satisfaction',
    DELIVERY_COST_SUMMARY: 'Delivery Cost Summary',
    DELIVERY_TOTAL_WORKS: 'Completed work items',
    DELIVERY_TOTAL_PARTS: 'Used parts',
    DELIVERY_LABOR_TOTAL: 'Labor total',
    DELIVERY_GRAND_TOTAL: 'Grand total',
    ACCOUNTING_WORKLIST_READY: 'Accounting review is now active',
    ACCOUNTING_WORKLIST_READY_HINT: 'This file is visible to accounting and damage analysis with the final amount breakdown.',
    PAYMENT_RECEIVED: 'Payment received',
    FINAL_DELIVERY_PHOTOS: 'Final delivery documents',
    FINAL_DELIVERY_PHOTOS_HINT: '{{count}} final documents already attached. Add the latest allowed documents before delivery.',
    FINAL_DELIVERY_READY_HINT: 'Select and upload the latest vehicle photos before delivery.',
    FINAL_DELIVERY_PHOTO_REQUIREMENT: 'Attach enough allowed documents so the final delivery total reaches {{count}}.',
    COMPLETE_DELIVERY: 'Complete Delivery',
    DELIVERY_APPOINTMENT_WAITING: '{{hours}} hours {{minutes}} minutes until appointment',
    COMPLETE_DELIVERY_APPOINTMENT_MINUTES: 'Complete Delivery ({{count}} minutes until appointment)',
    COMPLETE_DELIVERY_APPOINTMENT_OVERDUE: 'Complete Delivery (Appointment time has passed)',
    UPDATE_DELIVERY_TIME: 'Update Delivery Time',
    COMPLETE_DELIVERY_ERROR: 'Delivery could not be completed. Please try again.',
    READINESS_READY: 'Ready',
    READINESS_PENDING: 'Pending',
    READINESS_EMPTY: 'No data',
    READINESS_DOCS: 'Official forms checked',
    READINESS_DOCS_DETAIL: '{{done}}/{{total}} forms uploaded · {{missing}} required forms missing',
    READINESS_NO_DOCUMENTS: 'No document records yet',
    READINESS_PHOTOS: 'Uploaded document groups completed',
    READINESS_DOCUMENTS: 'All required documents uploaded',
    READINESS_DOCUMENTS_DETAIL: '{{done}}/{{total}} mandatory document groups completed',
    READINESS_WORK_ORDERS: 'Work order items completed',
    READINESS_WORK_ORDERS_DETAIL: '{{done}}/{{total}} work items closed',
    READINESS_NO_WORK_ORDERS: 'No work order items yet',
    READINESS_DIGITAL_SIGNATURE: 'Digital signature saved',
    READINESS_DIGITAL_SIGNATURE_DETAIL: 'Signed on {{date}}',
    READINESS_DIGITAL_SIGNATURE_PENDING: 'A digital signature is required',
    READINESS_PARTS: 'Spare parts process closed',
    READINESS_PARTS_DETAIL: '{{open}} of {{total}} parts pending',
    READINESS_NO_PARTS: 'No spare parts records yet',
    READINESS_DELIVERY_FORM: 'Delivery form ready',
    READINESS_DELIVERY_FORM_DETAIL: 'Delivery form status: {{status}}',
    READINESS_NO_DELIVERY_FORM: 'Delivery form has not been created yet',
    OPTIONAL_LABEL: 'Optional',
    MANDATORY: 'Mandatory',
    DEPENDS_ON_JOB_TYPE: 'Depends on job type',
    REG_TYPE_MECHANICAL: 'Mechanical',
    REG_TYPE_DAMAGE: 'Damage',
    OWNER_INDIVIDUAL: 'Individual',
    OWNER_CORPORATE: 'Corporate',
    WORKSHOP_MECHANICAL: 'Mechanical',
    WORKSHOP_BODY: 'Bodywork',
    WORKSHOP_PAINT: 'Paint',
    WORKSHOP_DETAIL_WASH: 'Detail / Wash',
    WORKSHOP_ELECTRIC: 'Electrical',
    OUTPUT_DOC_VEHICLE_RECEIVING_FORM: 'Vehicle Acceptance Form',
    OUTPUT_DOC_ACCIDENT_EXPERTISE_REPORT: 'Accident Expertise Report',
    OUTPUT_DOC_FREE_WORK_ORDER_FORM: 'Work Order Report',
    OUTPUT_DOC_FINAL_CHECK_FORM: 'Final Check Form',
    OUTPUT_DOC_VEHICLE_DELIVERY_FORM: 'Vehicle Delivery Form',
    OUTPUT_DOC_INVOICE_SUMMARY: 'Invoice Summary',
    STATUS_STEP_REGISTERED: 'Vehicle registered',
    STATUS_STEP_QUEUE: 'Waiting in service queue',
    STATUS_STEP_IN_SERVICE: 'In service',
    STATUS_STEP_READY: 'Ready for delivery',
    STATUS_STEP_DELIVERED: 'Delivered',
    STATUS_HISTORY_TAG_REGISTRATION: 'Registration',
    STATUS_HISTORY_TAG_QUEUE: 'Queue',
    STATUS_HISTORY_TAG_ASSIGNMENT: 'Assignment',
    STATUS_HISTORY_TAG_SERVICE: 'Service',
    STATUS_HISTORY_TAG_APPROVAL: 'Approval',
    STATUS_HISTORY_TAG_DELIVERY: 'Delivery',
    STATUS_HISTORY_TAG_UPDATE: 'Update',
    STATUS_HISTORY_QUEUE_TITLE: 'Damage analysis approved',
    STATUS_HISTORY_WORK_STARTED_TITLE: 'Work started on the vehicle',
    STATUS_HISTORY_REGISTERED_DETAIL: 'The file was opened and the initial vehicle, customer and intake details were saved to the system.',
    STATUS_HISTORY_DAMAGE_ANALYSIS_COMPLETED: 'Damage analysis was approved for {{work}}; the work order is waiting for parts readiness and technician assignment.',
    STATUS_HISTORY_WORKSHOP_ASSIGNED: '{{work}} in {{workshop}} was approved as ready by the Workshop Manager.',
    STATUS_HISTORY_TECHNICIAN_ASSIGNED: '{{work}} was assigned to technician {{name}}.',
    STATUS_HISTORY_WORK_STARTED: 'Technician work started for {{work}}.',
    STATUS_HISTORY_WORK_COMPLETED: '{{work}} was completed and sent to the next approval step.',
    STATUS_HISTORY_WORKSHOP_MANAGER_APPROVED: '{{work}} was approved by the Workshop Manager and is waiting for the next planning step.',
    STATUS_HISTORY_SERVICE_FINAL_REVIEW_SENT: 'The case was sent to the service manager for review.',
    STATUS_HISTORY_WORK_ORDER_READY: 'All approvals are complete. The file has moved to delivery readiness stage.',
    STATUS_HISTORY_DELIVERED_DETAIL: 'The vehicle was delivered and the file moved into closing stage.',
    STATUS_HISTORY_GENERIC_UPDATE: 'A new update was recorded for {{work}}.',
    STATUS_HISTORY_ACTOR: '{{actor}} performed this action',
    STATUS_HISTORY_FALLBACK_WORK: '{{workshop}} work item',
    STATUS_HISTORY_GENERIC_WORK: 'this work item',
    STATUS_HISTORY_UNKNOWN_WORKSHOP: 'relevant',
    DAMAGE_MAP_TITLE: 'Vehicle Analysis',
    PART_CATALOG_TITLE: 'Parts Catalog',
    PART_CATALOG_SEARCH: 'Search parts',
    PART_CATALOG_LOADING: 'Loading parts...',
    CATALOG_MINIMUM_QUERY: 'Enter at least two characters to search.',
    CATALOG_SEARCH_ERROR: 'Parts could not be loaded. Please try again.',
    DAMAGE_COUNT: '{{count}} Damage',
    OPERATION_COUNT: '{{count}} Operation',
    SELECTED_REGION: 'Selected',
    SELECTED_REGIONS_COUNT: '{{count}} regions selected',
    REMOVE_REGION: 'Remove {{region}}',
    DAMAGE_REGION_REQUIRED: 'Select at least one damaged region.',
    HOVERED_REGION: 'Hover',
    CLICK_REGION: 'Click region',
    CAR_DIRECTION_HINT: 'FRONT ↑ · REAR ↓',
    LEGEND_HEALTHY: 'Healthy',
    LEGEND_DAMAGED: 'Damaged',
    LEGEND_SELECTED: 'Selected',
    LEGEND_GENERAL: 'General',
    GENERAL_COUNT: '{{count}} General',
    DAMAGE_DETECTION: 'Work Order Entry',
    EDIT_DAMAGE: 'Edit Work Order',
    CANCEL: 'Cancel',
    CREATE_WORK_ORDER: 'Create Work Order',
    CREATE_WORK_ORDER_HINT: 'Create a work order to add catalog or custom parts.',
    ADDITIONAL_WORK_ORDER: 'Additional Work Order',
    ADDITIONAL_WORK_ORDERS: 'Additional Work Orders',
    ADDITIONAL_WORK_ORDER_ADD_TO_LIST: 'Add to Additional Work Orders',
    ADDITIONAL_WORK_ORDERS_EMPTY: 'No additional work order has been added yet.',
    ADDITIONAL_WORK_ORDERS_CREATE: 'Create Additional Work Orders',
    ADDITIONAL_WORK_ORDER_CREATE: 'Create Additional Work Order',
    ADDITIONAL_WORK_ORDER_BADGE: 'Additional Work',
    EDIT_ADDITIONAL_WORK_ORDER: 'Edit Additional Work Order',
    UPDATE_ADDITIONAL_WORK_ORDER: 'Update Additional Work Order',
    ADDITIONAL_WORK_ORDER_APPROVE: 'Approve',
    ADDITIONAL_WORK_ORDER_CANCEL: 'Cancel',
    WORK_ORDER_NAME: 'Work Order Name',
    WORK_ORDER_NAME_PLACEHOLDER: 'e.g. Dent repair, detailed wash',
    MECHANICAL_WORK_ORDER_NAME_PLACEHOLDER: 'e.g. Oil maintenance, brake inspection',
    CAR_REGION_ON_TAMPON: 'Front bumper',
    CAR_REGION_SOL_FAR: 'Left headlight',
    CAR_REGION_SAG_FAR: 'Right headlight',
    CAR_REGION_KAPUT: 'Hood',
    CAR_REGION_SOL_ON_CAMURLUK: 'Left front fender',
    CAR_REGION_SAG_ON_CAMURLUK: 'Right front fender',
    CAR_REGION_ON_CAM: 'Windshield',
    CAR_REGION_TAVAN: 'Roof',
    CAR_REGION_SOL_ON_KAPI: 'Left front door',
    CAR_REGION_SAG_ON_KAPI: 'Right front door',
    CAR_REGION_SOL_ARKA_KAPI: 'Left rear door',
    CAR_REGION_SAG_ARKA_KAPI: 'Right rear door',
    CAR_REGION_ARKA_CAM: 'Rear window',
    CAR_REGION_BAGAJ: 'Trunk lid',
    CAR_REGION_SOL_ARKA_CAMURLUK: 'Left rear fender',
    CAR_REGION_SAG_ARKA_CAMURLUK: 'Right rear fender',
    CAR_REGION_ARKA_TAMPON: 'Rear bumper',
    CAR_REGION_SOL_STOP: 'Left taillight',
    CAR_REGION_SAG_STOP: 'Right taillight',
    CAR_REGION_SOL_AYNA: 'Left side mirror',
    CAR_REGION_SAG_AYNA: 'Right side mirror',
    DAMAGE_TYPE: 'Damage / Operation Type',
    DAMAGE_TYPE_PLACEHOLDER: 'e.g. Dent, scratch, detailed wash',
    DAMAGE_NAME: 'Damage Title',
    DAMAGE_NAME_PLACEHOLDER: 'e.g. Dent, scratch, cracked glass',
    OPERATION_NAME: 'Operation Name',
    OPERATION_NAME_PLACEHOLDER: 'e.g. Detailed wash, electrical check',
    RELATED_WORKSHOP: 'Select Workshop',
    DAMAGE_LEVEL: 'Damage Level',
    DAMAGE_LEVEL_PLACEHOLDER: 'Select damage level',
    DAMAGE_LEVEL_NONE: 'Not selected',
    DAMAGE_LEVEL_1: 'Light Damage',
    DAMAGE_LEVEL_2: 'Medium Damage',
    DAMAGE_LEVEL_3: 'Heavy Damage',
    REQUIRED_PARTS: 'Required Parts',
    EDIT_PART: 'Edit part',
    UPDATE_PART: 'Update part',
    REMOVE_PART: 'Remove part',
    LABOR_COST: 'Labor Cost',
    LABOR_COST_PLACEHOLDER: 'e.g. 1500 ₺',
    DAMAGE_NOTE: 'Description / Note',
    DAMAGE_NOTE_PLACEHOLDER: 'Damage details, customer notes...',
    MECHANICAL_WORK_ORDER_NOTE_PLACEHOLDER: 'Service operations and customer requests...',
    UPDATE_DAMAGE: 'Update Work Order',
    SAVE_DAMAGE: 'Save Work Order',
    COMPLETE_DAMAGE_ANALYSIS: 'Complete damage analysis',
    REVERT_DAMAGE_ANALYSIS_APPROVAL: 'Revert Approval',
    REVERT_DAMAGE_ANALYSIS_CONFIRM_TITLE: 'Revert damage analysis approval?',
    REVERT_DAMAGE_ANALYSIS_CONFIRM_MESSAGE: 'The damage analysis will become editable again and the case will return to the planning queue.',
    DAMAGE_ANALYSIS_COMPLETE_ERROR: 'Damage analysis could not be completed.',
    STATUS_HISTORY_DAMAGE_ANALYSIS_APPROVED: 'Damage analysis was approved and the work orders are waiting for parts readiness and technician assignment.',
    DAMAGE_ANALYSIS_REVERT_ERROR: 'Damage analysis approval could not be reverted.',
    ASSIGN_TECHNICIAN: 'Assign technician',
    NOT_ASSIGNED: '-',
    ASSIGNED_PERSON: 'Assigned person',
    COMPLETED_BY: 'Completed by',
    TECHNICIAN_ASSIGNMENT_REQUIRED: 'A technician must be assigned',
    PART_SUPPLY_REQUIRED: 'Spare parts must be supplied',
    SELECT_TECHNICIAN: 'Select technician',
    REASSIGN_TECHNICIAN: 'Assign another technician',
    UNASSIGN_TECHNICIAN: 'Unassign technician',
    CONFIRM_UNASSIGN_TECHNICIAN: 'Click again to confirm',
    LOADING_TECHNICIANS: 'Loading technicians...',
    NO_TECHNICIANS: 'No technician found for this unit.',
    CURRENT_TECHNICIAN_OPTION: '{{name}} (Current)',
    ASSIGN: 'Assign',
    REQUIRED_PARTS_SAVE_ERROR: 'Required part statuses could not be saved.',
    TECHNICIAN_ASSIGN_ERROR: 'Technician assignment could not be saved.',
    TECHNICIAN_UNASSIGN_ERROR: 'Technician assignment could not be removed.',
    TECHNICIAN_LOAD_ERROR: 'Technicians could not be loaded.',
    START_WORK: 'Start work',
    COMPLETE_WORK: 'Complete work',
    START_WORK_PHOTO_REQUIREMENT: 'Attach at least {{count}} allowed documents before starting this work.',
    COMPLETE_WORK_PHOTO_REQUIREMENT: 'Attach at least {{count}} allowed documents before completing this work.',
    PAUSE_WORK_PHOTO_REQUIREMENT: 'Attach at least {{count}} repair progress photos before pausing this work.',
    RESUME_WORK_PHOTO_REQUIREMENT: 'Attach at least {{count}} repair progress photos before resuming this work.',
    REPAIR_PROGRESS_PHOTO_REQUIREMENT: 'Attach at least {{count}} repair progress photo to document this work stage.',
    WORK_PHOTO_MINIMUM_REQUIREMENT: 'At least {{count}} documents',
    PHOTOS_ADDED: '{{count}} documents added',
    START_WORK_PHOTO_HINT: 'Add at least {{count}} before photos to start this work.',
    COMPLETE_WORK_PHOTO_HINT: 'Add at least {{count}} after photos to complete this work.',
    PHOTOS_REMAINING: '{{count}} more document(s) required.',
    DROP_WORK_PHOTOS: 'Drop photos here or click to select',
    WORK_PHOTO_MINIMUM: 'At least 2 photos',
    WORK_PHOTO_IMAGE_REQUIRED: 'Only image files can be added.',
    WORK_IN_PROGRESS: 'In progress',
    WORK_PAUSED: 'Paused',
    ACTIVE_TIME: 'Active time',
    PAUSE_WORK: 'Pause work',
    RESUME_WORK: 'Resume work',
    PAUSE_WORK_ERROR: 'Work could not be paused.',
    RESUME_WORK_ERROR: 'Work could not be resumed.',
    REPAIR_PROGRESS_PHOTOS_UPLOAD_ERROR: 'Repair progress photos could not be uploaded.',
    NEXT_RESUME_WORK: 'Resume the paused work when ready.',
    NEXT_ASSIGN_PAUSED_WORK: 'Assign a technician before resuming this paused work.',
    BEFORE_PHOTOS: 'Before photos',
    REPAIR_PROGRESS_PHOTOS: 'Repair progress photos',
    ADD_REPAIR_PROGRESS_PHOTOS: 'Add repair progress photos',
    AFTER_PHOTOS: 'After photos',
    REQUIRED_PART_COUNT: '{{count}} pcs',
    REQUIRED_PART_AVAILABLE: 'Available',
    REQUIRED_PART_ORDERED: 'Ordered',
    REQUIRED_PART_UNAVAILABLE: 'Unavailable',
    WORK_ORDER_STRUCTURE_SAVE_ERROR: 'Work order or part request could not be saved.',
    WORK_STARTED: 'Work started',
    MANAGER_ACTING_ON_BEHALF: 'You are acting on behalf of {{technician}}. KPI credit will belong to this technician.',
    START_WORK_ERROR: 'Work could not be started.',
    COMPLETE_WORK_ERROR: 'Work could not be completed.',
    APPROVE_WORK: 'Approve Work',
    REJECT_WORK: 'Do Not Approve Work',
    REJECT_WORK_MODAL_TITLE: 'Reject completed work',
    REJECT_WORK_REASON_LABEL: 'Rejection reason (optional)',
    REJECT_WORK_REASON_PLACEHOLDER: 'Work rejected because...',
    REJECT_WORK_SEND_BACK: 'Send Back',
    REJECTION_NUMBER: 'Rejection reason #{{number}}',
    REJECTION_NO_REASON: 'No explanation provided',
    WORK_REVIEW_ERROR: 'Work review could not be saved.',
    REVERT_WORKSHOP_MANAGER_APPROVAL: 'Revoke approval',
    REVERT_WORKSHOP_MANAGER_APPROVAL_CONFIRM_TITLE: 'Reopen this completed work?',
    REVERT_WORKSHOP_MANAGER_APPROVAL_CONFIRM_MESSAGE: 'The work will return to Completed and require Workshop Manager review again.',
    REVERT_WORKSHOP_MANAGER_APPROVAL_ERROR: 'The completion approval could not be reverted.',
    SERVICE_FINAL_REVIEW_SENT: 'Sent to service manager for review',
    ASSIGNED_TO_TECHNICIAN: 'Assigned to {{name}}',
    READY_FOR_WORK: 'Ready for work',
    STATUS_HISTORY_READY_FOR_WORK: '{{work}} is ready for work and has a technician assigned.',
    AWAITING_TECHNICIAN_ASSIGNMENT: 'Approved — awaiting technician assignment',
    WORK_COMPLETED: 'Completed',
    DETECTED_DAMAGES: 'Work Orders',
    DETECTED_DAMAGES_ONLY: 'Detected Damages',
    SERVICE_OPERATIONS: 'Service Operations',
    DAMAGE_PART_SUMMARY: '{{damage}} records · {{parts}} parts',
    NO_DAMAGE_YET: 'No work orders have been created yet. Use the Create Work Order action above to get started.',
    NO_DAMAGE_RECORD: 'No damage record yet.',
    NO_OPERATION_RECORD: 'No service operation record yet.',
    PART_COUNT: '{{count}} parts',
    LABOR_COST_VALUE: 'Labor {{cost}}',
    TOTAL: 'total',
    EDIT: 'Edit',
    DELETE_DAMAGE: 'Delete record',
    OPEN_REGISTRATION_SUMMARY: 'Open registration summary',
    REGISTRATION_SUMMARY_KICKER: 'INITIAL INTAKE',
    REGISTRATION_SUMMARY_TITLE: 'Registration details',
    CLOSE_SUMMARY: 'Close summary',
    SUMMARY_SECTION_RECORD: 'Record overview',
    SUMMARY_SECTION_INSURANCE: 'Insurance & file',
    SUMMARY_YES: 'Yes',
    SUMMARY_NO: 'No',
    SUMMARY_NOT_IN_CATALOG: 'Not in catalog',
    SUMMARY_DAMAGE_SUB_TYPE: 'Damage subtype',
    SUMMARY_MECHANICAL_SUB_TYPE: 'Mechanical subtype',
    SUMMARY_OPENED_AT: 'Record opened at',
    SUMMARY_BROUGHT_BY: 'Brought by',
    SUMMARY_VEHICLE_COLOR: 'Vehicle color',
    SUMMARY_AGENCY_EMAIL: 'Agency email',
    SUMMARY_CLAIM_FILE_NO: 'Claim file no',
    SUMMARY_POLICY_ISSUE_DATE: 'Policy issue date',
    SUMMARY_POLICY_START_DATE: 'Policy start date',
    SUMMARY_POLICY_END_DATE: 'Policy end date',
    SUMMARY_APPROVAL_REQUEST_DATE: 'Approval request date',
    SUMMARY_APPROVAL_NOTE: 'Approval note',
    SUMMARY_NOTIFICATION_DATE: 'Notification date',
    SUMMARY_NOTIFICATION_TIME: 'Notification time',
    SUMMARY_DAMAGE_DATE: 'Damage date',
    SUMMARY_DAMAGE_TIME: 'Damage time',
    SUMMARY_DAMAGE_SUBCAUSE: 'Damage subcause',
    SUMMARY_ESTIMATED_AMOUNT: 'Estimated damage amount',
    SUMMARY_ASSESSOR_ADDRESS: 'Assessor address',
    SUMMARY_DRIVER_NAME: 'Driver',
    SUMMARY_ARRIVAL_DATE: 'Arrival date',
    SUMMARY_ARRIVAL_METHOD: 'Arrival method',
  },
  CASE_REGISTRATION: {
    LABEL_USAGE_TYPE: 'Usage Type',
    USAGE_TYPE_PASSENGER_VEHICLE: 'Passenger Vehicle',
    USAGE_TYPE_COMBI: 'Combi',
    USAGE_TYPE_BUS: 'Bus',
    USAGE_TYPE_HEAVY_COMMERCIAL_TRUCK: 'Heavy Commercial Truck',
    USAGE_TYPE_MOTORCYCLE: 'Motorcycle',
    USAGE_TYPE_CONSTRUCTION_EQUIPMENT: 'Construction Equipment',
    USAGE_TYPE_LIGHT_COMMERCIAL_MINIBUS: 'Light Commercial Minibus',
    USAGE_TYPE_LIGHT_COMMERCIAL_PICKUP: 'Light Commercial Pickup',
    USAGE_TYPE_HEAVY_COMMERCIAL_TRACTOR: 'Heavy Commercial Tractor',
    LABEL_BODY_TYPE: 'Vehicle Body Type',
    BODY_TYPE_SEDAN_FOUR_DOOR: 'Four-door sedan',
    BODY_TYPE_SEDAN_TWO_DOOR: 'Two-door sedan',
    BODY_TYPE_HATCHBACK_FOUR_DOOR: 'Four-door hatchback',
    BODY_TYPE_HATCHBACK_TWO_DOOR: 'Two-door hatchback',
    BODY_TYPE_STATION_WAGON: 'Station wagon',
    BODY_TYPE_JEEP: 'Jeep',
    BODY_TYPE_COMBI_SINGLE_SLIDING_DOOR: 'Combi single sliding door',
    BODY_TYPE_COMBI_DUAL_SLIDING_DOOR: 'Combi dual sliding door',
    BODY_TYPE_COMBI_VAN_SINGLE_SLIDING_DOOR: 'Combi van single sliding door',
    BODY_TYPE_COMBI_VAN_DUAL_SLIDING_DOOR: 'Combi van dual sliding door',
    BODY_TYPE_BUS: 'Bus',
    BODY_TYPE_TRUCK: 'Truck',
    BODY_TYPE_CONVENTIONAL_TRUCK: 'Conventional truck',
    BODY_TYPE_MOTORCYCLE: 'Motorcycle',
    BODY_TYPE_CONSTRUCTION_EQUIPMENT: 'Construction equipment',
    BODY_TYPE_TRAILER_DORSE: 'Trailer/semitrailer',
    BODY_TYPE_MINIBUS_VAN: 'Minibus van',
    BODY_TYPE_MINIBUS_CARAVAN: 'Minibus caravan',
    BODY_TYPE_MINIBUS: 'Minibus',
    BODY_TYPE_PICKUP_SINGLE_CAB: 'Single-cab pickup',
    BODY_TYPE_PICKUP_DOUBLE_CAB: 'Double-cab pickup',
    BODY_TYPE_TRACTOR_UNIT: 'Tractor unit',
    HEADER_TITLE: 'Open Vehicle Registration',
    HEADER_TITLE_EDIT: 'Edit Vehicle Registration',
    PRINT_FORM: 'Print form',
    PRINT_FORM_TITLE: 'Vehicle intake form',
    SAVE: 'Save',
    SAVING: 'Saving...',
    SAVED: 'Saved',
    VEHICLE_PHOTOS_REQUIRED: 'Assign at least {{count}} vehicle arrival photos before saving ({{remaining}} more required).',
    VEHICLE_ARRIVAL_PHOTOS_STATUS: 'Vehicle arrival photos: {{current}} / {{count}}',
    BOOKING_LOADING: 'Loading booking information...',
    BOOKING_UNAVAILABLE: 'This booking is unavailable or has already been completed.',
    PROFILE_PREFILL_LOADING: 'Loading customer and vehicle details...',
    PROFILE_PREFILL_ERROR: 'Customer and vehicle details could not be loaded. Please try again.',
    PROFILE_PREFILL_RETRY: 'Try again',
    CUSTOMER_SEARCH_ACTION: 'Search Customers',
    CUSTOMER_SEARCH_TITLE: 'Search Customers',
    CUSTOMER_SEARCH_CLOSE: 'Close customer search',
    CUSTOMER_SEARCH_BACK: 'Go Back',
    CUSTOMER_SEARCH_CONFIRM: 'Confirm',
    CUSTOMER_SEARCH_DISCARD_DRAFT: 'Confirming will clear the unfinished registration, including visit details, document selections, and signature.',
    CUSTOMER_SEARCH_NO_DETAILS: 'No reusable details are available for this customer and vehicle.',
    CUSTOMER_SEARCH_YES: 'Yes',
    BOOKING_CONFLICT: 'This booking has already been used to create a case.',
    BOOKING_AUTOFILL_CONFIRM_TITLE: 'Use AI autofill?',
    BOOKING_AUTOFILL_CONFIRM_MESSAGE: 'Customer documents are ready ({{count}}). Would you like AI to analyze them and suggest registration details?',
    BOOKING_AUTOFILL_CONFIRM_ACTION: 'Use AI Autofill',
    BOOKING_AUTOFILL_CONFIRM_CANCEL: 'Continue Manually',
    BOOKING_AUTOFILL_CHOOSE_TITLE: 'AI Autofill',
    BOOKING_AUTOFILL_CHOOSE_MESSAGE: 'Include booking uploads with the selected documents?',
    BOOKING_AUTOFILL_INCLUDE_ALL: 'Include Booking Uploads',
    BOOKING_AUTOFILL_ONLY_ASSIGNED: 'Selected Documents Only',
    DOCUMENT_BULK_AI_SELECTION_HINT: 'Hold Control and click to select or deselect this document group for AI autofill',
    DOCUMENT_SLOT_PREVIOUS_PAGE: 'Show previous assigned documents',
    DOCUMENT_SLOT_NEXT_PAGE: 'Show next assigned documents',
    DOCUMENT_PREVIEW_PREVIOUS: 'Show previous assigned document',
    DOCUMENT_PREVIEW_NEXT: 'Show next assigned document',
    CUSTOMER_INFORMATION: 'Customer Information',
    OPEN_CUSTOMER_INFORMATION: 'Open customer information',
    CLOSE_CUSTOMER_INFORMATION: 'Close customer information',
    GET_SIGNATURE: 'Get Signature',
    SIGNATURE_TAKEN: 'Signature taken',
    SIGNATURE_TITLE: 'Customer Signature',
    SIGNATURE_DRAW_HINT: 'Please sign in the field below.',
    SIGNATURE_EXISTING_HINT: 'A signature is already saved. Remove it to capture a new one.',
    SIGNATURE_REMOVE: 'Remove',
    SIGNATURE_SAVE: 'Save',
    SIGNATURE_CANCEL: 'Cancel',
    SIGNATURE_CLOSE: 'Close signature dialog',
    CLOSE_CONFIRM_TITLE: 'Cancel registration?',
    CLOSE_CONFIRM_MESSAGE: 'The form will be completely cleared. Are you sure?',
    CLOSE_CONFIRM_ACTION: 'Cancel and Close',
    CLOSE_CONFIRM_CANCEL: 'Cancel',
    BOOKING_SUBMISSION_DATE: 'Submission date',
    CLOSE: 'Close',
    STEP_OWNER_USER: 'Customer & File Information',
    STEP_VEHICLE_DETAILS: 'Vehicle Information',
    STEP_VEHICLE_COUNTERPARTIES: 'Vehicle & Counterparty Information',
    STEP_VEHICLE_APPROVAL_INSURANCE: 'Vehicle & Approval/Insurance Information',
    STEP_DAMAGE_INSURANCE: 'Damage & Insurance Process',
    STEP_ACCIDENT_PARTIES: 'Counterparties',
    ACCIDENT_PARTIES_TITLE: 'Counterparties',
    ACCIDENT_PARTIES_HINT: 'Add the other vehicles involved in the accident.',
    ACCIDENT_PARTY_SUFFIX: 'counterparties',
    ACCIDENT_PARTY_COUNT: 'Accident size',
    ACCIDENT_SINGLE_VEHICLE: 'Single vehicle',
    ACCIDENT_TWO_VEHICLES: '2-vehicle accident',
    ACCIDENT_THREE_VEHICLES: '3-vehicle accident',
    ACCIDENT_FOUR_PLUS: '4-vehicle accident+',
    ACCIDENT_PARTY_LABEL: 'Counterparty {{index}}',
    ACCIDENT_PARTY_EMPTY: 'Information not entered',
    ACCIDENT_PARTY_PLATE_EMPTY: 'Plate not entered',
    ACCIDENT_PARTY_DOCUMENT_SUFFIX: 'documents',
    ACCIDENT_PARTY_NAME: 'Name',
    ACCIDENT_PARTY_SURNAME: 'Surname',
    ACCIDENT_PARTY_TCKN: 'Turkish ID number',
    ACCIDENT_PARTY_PHONE: 'Phone',
    ACCIDENT_PARTY_PLATE: 'Vehicle plate',
    ACCIDENT_LICENSE_DOCUMENTS: 'Driving license',
    ACCIDENT_REGISTRATION_DOCUMENTS: 'Registration',
    ACCIDENT_POLICY_DOCUMENTS: 'Insurance policy',
    ACCIDENT_ADD_PARTY: 'Add counterparty',
    ACCIDENT_REMOVE_TITLE: 'Remove counterparty?',
    ACCIDENT_REMOVE_ACTION: 'Remove',
    ACCIDENT_REMOVE_CONFIRM: 'Removing this counterparty may also remove its linked documents. Continue?',
    ACCIDENT_SUBTYPE_REMOVE_CONFIRM: 'Changing the damage subtype will remove the counterparties and their linked documents. Continue?',
    ACCIDENT_SINGLE_VEHICLE_HINT: 'This case is registered as a single-vehicle traffic accident.',
    DOCUMENT_UPLOAD_BUTTON_SHORT: 'Add document',
    STEP_DOCUMENTS: 'Customer Documents',
    DOCUMENT_DROP_UPLOADING: 'Uploading and assigning...',
    DOCUMENT_DROP_UPLOAD_ERROR: 'Files could not be uploaded. Please try again.',
    DOCUMENT_BROWSER_DROP_UPLOADING: 'Uploading files...',
    CONTINUE: 'Continue',
    BACK: 'Back',
    OWNER_INFO: 'Vehicle Owner Information',
    CUSTOMER_AND_VEHICLE_OWNER: 'Customer and Vehicle Owner',
    REGISTERED_OWNER: 'Registered Owner',
    REGISTERED_OWNER_TYPE: 'Registered Owner Type',
    REGISTERED_OWNER_DIFFERENT: 'Registered owner is different',
    OPTIONAL_FIELD: 'Optional',
    PERSON: 'Person',
    CUSTOMER_RELATED_PERSON_INFO: 'Customer and Related Persons',
    CUSTOMER_INFO: 'Customer',
    VEHICLE_USER: 'Vehicle User',
    BRINGER: 'Bringer',
    USER_INFO: 'Vehicle User Information',
    GENERAL_INFO: 'Case Information',
    VEHICLE_INFO: 'Vehicle Information',
    REPAIR_LIST_TITLE: 'Damage List',
    REPAIR_LIST_EMPTY: 'No repair item has been added yet.',
    REPAIR_PANEL: 'Repair Panel',
    MAINTENANCE_LIST_TITLE: 'Maintenance List',
    MAINTENANCE_LIST_EMPTY: 'No maintenance item has been added yet.',
    MAINTENANCE_ITEM: 'Planned Maintenance',
    REPAIR_TYPE: 'Repair Type',
    REPAIR_ACTIONS: 'Actions',
    REPAIR_TYPE_PAINT: 'Paint Repair',
    REPAIR_TYPE_BODY: 'Body Repair',
    ADD_REPAIR_ITEM: 'Add Row',
    REMOVE_REPAIR_ITEM: 'Remove',
    REPAIR_LIST_INVALID: 'Complete every damage-list row before saving.',
    DAMAGE_INFO: 'Damage Information',
    APPROVAL_INSURANCE_INFO: 'Approval and Insurance Information',
    DRIVER_ARRIVAL_INFO: 'Driver and Vehicle Arrival Information',
    ARRIVAL_INFO: 'Vehicle Arrival Information',
    INCOMING_DOCUMENTS: 'Incoming Documents',
    DOCUMENT_TABS: 'Document Assignments',
    DOCUMENT_ASSIGNMENT_SUMMARY_HINT: 'Choose a document type to view and assign its documents.',
    DOCUMENT_ASSIGNMENT_SLOT_HINT: 'Select a document from the search area, then assign it to a document group below or on the counterparty screen.',
    DOCUMENT_INTAKE_SEARCH_LABEL: 'Phone / uploader search',
    DOCUMENT_INTAKE_SEARCH_PLACEHOLDER: 'Type at least 3 phone digits',
    DOCUMENT_INTAKE_REFRESH: 'Refresh',
    DOCUMENT_INTAKE_UPLOAD: 'Upload documents',
    DOCUMENT_INTAKE_EMPTY: 'No incoming documents yet',
    DOCUMENT_INTAKE_EMPTY_HINT: 'Documents from WhatsApp or manual upload will be listed here.',
    DOCUMENT_INTAKE_LOADING: 'Loading documents',
    DOCUMENT_INTAKE_LOAD_ERROR: 'Documents could not be loaded. Please try again.',
    STALE_DOCUMENT_ASSIGNMENTS_REMOVED: 'Documents already assigned to another case were removed. Please select or upload available documents again.',
    DOCUMENT_COUNT_SUFFIX: 'documents',
    MANUAL_UPLOADS: 'Manual Uploads',
    BOOKING_DOCUMENTS: 'Customer Submissions',
    DOCUMENT_FIELD_DROP_HERE: 'Drop here',
    DOCUMENT_FIELD_EMPTY: 'Empty',
    DOCUMENT_MOBILE_SELECTED: 'Selected',
    DOCUMENT_MOBILE_SELECT_FIRST: 'Select a photo first',
    DOCUMENT_MOBILE_ASSIGN_PHOTO: 'Assign photo',
    DOCUMENT_READER_TITLE: 'Document reading panel',
    DOCUMENT_READER_OPEN: 'Open preview',
    DOCUMENT_READER_MINIMIZE: 'Minimize document dock',
    DOCUMENT_READER_EXPAND: 'Expand document dock',
    DOCUMENT_UPLOAD_TITLE: 'Upload Documents',
    DOCUMENT_UPLOAD_DROP_LABEL: 'Drag files here',
    DOCUMENT_UPLOAD_DROP_HINT: 'or click to browse',
    DOCUMENT_UPLOAD_SELECTED_FILES: 'Selected files ({{count}})',
    DOCUMENT_UPLOAD_BUTTON: 'Upload ({{count}})',
    UPLOADING: 'Uploading...',
    DOCUMENT_DELETE: 'Delete document',
    DOCUMENT_DELETE_CONFIRM_TITLE: 'Delete document',
    DOCUMENT_DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this document? This action cannot be undone.',
    DOCUMENT_DELETE_CONFIRM_ACTION: 'Delete',
    DOCUMENT_DELETE_ALL: 'Delete All ({{count}})',
    DOCUMENT_DELETE_ALL_CONFIRM_TITLE: 'Delete selected documents',
    DOCUMENT_DELETE_ALL_CONFIRM_MESSAGE: 'Are you sure you want to delete all {{count}} selected documents? This action cannot be undone.',
    DOCUMENT_DELETE_ALL_CONFIRM_ACTION: 'Delete All',
    DOCUMENT_DELETE_ALL_ERROR: 'The selected documents could not be deleted. Please try again.',
    OWNER_TYPE: 'Owner Type',
    INDIVIDUAL: 'Individual',
    CORPORATE: 'Corporate',
    RELATED_PERSON_OPTIONS: 'Additional person options',
    BRINGER_DIFFERENT: 'Brought by a different person',
    VEHICLE_USER_DIFFERENT: 'Vehicle user is different',
    REQUIRED_OPTION: 'Required',
    BRINGER_INFO: 'Brought By Information',
    REGISTRATION_TYPE: 'Registration Type',
    TYPE_DAMAGE: 'Damage',
    TYPE_MECHANICAL: 'Mechanical',
    SELECT_PLACEHOLDER: 'Select',
    VALIDATION_REQUIRED: 'This field is required.',
    VALIDATION_INVALID_TEXT: 'Enter a valid value.',
    VALIDATION_INVALID_NAME: 'Use only letters, spaces, apostrophes, hyphens, or dots.',
    VALIDATION_INVALID_TCKN: 'Enter a valid Turkish national ID number.',
    VALIDATION_INVALID_PLATE: 'Use letters, numbers, spaces, hyphens, periods, or slashes; the plate must start and end with a letter or number.',
    VALIDATION_INVALID_VKN: 'Enter a valid tax number.',
    VALIDATION_INVALID_PHONE: 'Enter a valid phone number with a country code.',
    VALIDATION_INVALID_EMAIL: 'Enter a valid email address.',
    VALIDATION_INVALID_DATE: 'Date cannot be in the future.',
    VALIDATION_INVALID_LICENSE_NO: 'Enter a valid driving license number.',
    VALIDATION_INVALID_SELECTION: 'Select a valid option.',
    VALIDATION_INVALID_CHASSIS: 'Enter a valid chassis number.',
    VALIDATION_INVALID_YEAR: 'Enter a valid model year.',
    VALIDATION_INVALID_NUMBER: 'Enter a valid non-negative number.',
    VALIDATION_INVALID_TIME: 'Enter a valid time (HH:MM).',
    LABEL_FIRST_NAME: 'First Name',
    LABEL_LAST_NAME: 'Last Name',
    LABEL_IDENTITY_NO: 'National ID No',
    LABEL_BIRTH_DATE: 'Date of Birth',
    LABEL_GENDER: 'Gender',
    MALE: 'Male',
    FEMALE: 'Female',
    LABEL_CITY: 'City',
    LABEL_DISTRICT: 'District',
    LABEL_MOBILE: 'Mobile Phone',
    LABEL_EMAIL: 'Email',
    LABEL_VKN: 'Tax Identification Number (VKN)',
    LABEL_TAX_NO: 'Tax No',
    LABEL_COMPANY_TITLE: 'Full Company Name',
    LABEL_COMMERCIAL_TITLE: 'Commercial Title',
    LABEL_TAX_OFFICE: 'Tax Office',
    LABEL_AUTHORIZED_PERSON: 'Authorized Person',
    PLACEHOLDER_IDENTITY_NO: '11-digit national ID',
    PLACEHOLDER_VKN: '10-digit tax number',
    PLACEHOLDER_TAX_NO: 'Tax No',
    PLACEHOLDER_COMPANY_TITLE: 'Full Company Name',
    PLACEHOLDER_AUTHORIZED_PERSON: 'Authorized person',
    LABEL_PLATE: 'Vehicle Plate',
    PLACEHOLDER_PLATE: '34 ABC 123',
    PLACEHOLDER_MILEAGE: 'e.g. 125,000',
    PLACEHOLDER_CHASSIS: '17-character VIN',
    PLACEHOLDER_MODEL_YEAR: 'e.g. 2024',
    PLACEHOLDER_EMAIL: 'name@example.com',
    LABEL_CHASSIS: 'Chassis No',
    LABEL_CUSTOMER_INSTITUTION: 'Customer Institution',
    LABEL_PROJECT: 'Project',
    INSURANCE_COMPANY_SEARCH_PLACEHOLDER: 'Search insurance company...',
    PROJECT_SEARCH_PLACEHOLDER: 'Search project...',
    INSURANCE_LOOKUP_LOADING: 'Loading options...',
    INSURANCE_PROJECT_COUNT: 'projects',
    PROJECT_REQUIRES_COMPANY: 'Select an insurance company first.',
    ADD_MISSING_PROJECT: 'Add missing project',
    MISSING_PROJECT_NAME: 'Project name',
    PLACEHOLDER_MISSING_PROJECT_NAME: 'Project name',
    MISSING_PROJECT_PRODUCT_CODE: 'Product code',
    MISSING_PROJECT_MAIN_TYPE: 'Main type',
    CREATE_MISSING_PROJECT: 'Create project',
    INSURANCE_PRODUCT_CASCO: 'Casco',
    INSURANCE_PRODUCT_TRAFFIC: 'Traffic Insurance',
    INSURANCE_PRODUCT_UNKNOWN: 'Other / Unknown',
    INSURANCE_MAIN_TYPE_ASSESSOR: 'Insured - Assessor',
    INSURANCE_MAIN_TYPE_MODULE: 'Insured - Module',
    INSURANCE_MAIN_TYPE_OTHER: 'Other',
    INSURANCE_COMPANY_REQUIRED: 'Select an insurance company before adding a project.',
    MISSING_PROJECT_FORM_REQUIRED: 'Fill in the missing project form completely.',
    MISSING_PROJECT_CREATE_FAILED: 'Project could not be created.',
    INSURANCE_LOOKUP_LOAD_FAILED: 'Insurance options could not be loaded.',
    LABEL_DAMAGE_SUB_TYPE: 'Damage Sub-Type',
    LABEL_MECHANICAL_SUB_TYPE: 'Mechanical Sub-Type',
    LABEL_ARRIVAL_DATE: 'Arrival Date',
    LABEL_EXPECTED_DELIVERY_DATE: 'Delivery Appointment Date',
    LABEL_EXPECTED_DELIVERY_TIME: 'Delivery Appointment Time',
    LABEL_DELIVERY_APPOINTMENT_DATE: 'Delivery Appointment Date',
    LABEL_DELIVERY_APPOINTMENT_TIME: 'Delivery Appointment Time',
    EXPECTED_DELIVERY_HOUR_PLACEHOLDER: 'Hour',
    EXPECTED_DELIVERY_MINUTE_PLACEHOLDER: 'Minute',
    EXPECTED_DELIVERY_HOUR_ARIA: 'Delivery appointment hour',
    EXPECTED_DELIVERY_MINUTE_ARIA: 'Delivery appointment minute',
    TIME_PICKER_HOUR_ARIA: 'Hour',
    TIME_PICKER_MINUTE_ARIA: 'Minute',
    LABEL_ARRIVAL_METHOD: 'Arrival Method',
    LABEL_RECEIVED_LOCATION: 'Vehicle Received At',
    LABEL_RECEIVED_LOCATION_OTHER: 'Other Received Location',
    LABEL_RECEIVED_ITEMS: 'Checked Items At Vehicle Intake',
    LABEL_OTHER_SPECIAL_ITEMS: 'Other Special Items',
    LABEL_CUSTOMER_REQUESTS: 'Customer Requests',
    LABEL_MILEAGE: 'Mileage',
    DAMAGE_SUB_TYPE_TRAFFIC_INSURANCE: 'Traffic Damage',
    DAMAGE_SUB_TYPE_CASCO_DECLARATION: 'Declaration Casco Damage',
    DAMAGE_SUB_TYPE_CASCO_AGREED: 'Agreed Casco Damage',
    DAMAGE_SUB_TYPE_RETAIL: 'Retail Operation',
    MECHANICAL_SUB_TYPE_PERIODIC_MAINTENANCE: 'Periodic Maintenance',
    MECHANICAL_SUB_TYPE_ENGINE: 'Engine',
    MECHANICAL_SUB_TYPE_TRANSMISSION_CLUTCH: 'Transmission / Clutch',
    MECHANICAL_SUB_TYPE_BRAKE_SYSTEM: 'Brake System',
    MECHANICAL_SUB_TYPE_SUSPENSION_RUNNING_GEAR: 'Suspension / Running Gear',
    MECHANICAL_SUB_TYPE_STEERING_SYSTEM: 'Steering System',
    MECHANICAL_SUB_TYPE_COOLING_SYSTEM: 'Cooling System',
    MECHANICAL_SUB_TYPE_FUEL_INJECTION_SYSTEM: 'Fuel / Injection System',
    MECHANICAL_SUB_TYPE_EXHAUST_EMISSION: 'Exhaust / Emission',
    MECHANICAL_SUB_TYPE_AIR_CONDITIONING_HEATING: 'Air Conditioning / Heating',
    MECHANICAL_SUB_TYPE_ELECTRICAL_ELECTRONIC: 'Electrical / Electronic',
    MECHANICAL_SUB_TYPE_BATTERY_STARTER_CHARGING: 'Battery / Starter / Charging',
    MECHANICAL_SUB_TYPE_DIAGNOSTIC_FAULT_DETECTION: 'Fault Detection / Diagnostic',
    MECHANICAL_SUB_TYPE_GENERAL_MECHANICAL: 'General Mechanical',
    ARRIVAL_METHOD_SELF: 'Self',
    ARRIVAL_METHOD_TOW: 'Tow Truck',
    LABEL_BRAND: 'Brand',
    LABEL_MODEL: 'Model',
    LABEL_MODEL_YEAR: 'Model Year',
    LABEL_DRIVING_LICENSE_CLASS: 'Driving License Class',
    LABEL_DRIVING_LICENSE: 'Driving License No',
    PLACEHOLDER_REPAIR_PANEL: 'e.g. Front bumper',
    PLACEHOLDER_MAINTENANCE_ITEM: 'e.g. Periodic maintenance',
    OPTION_AVAILABLE: 'Available',
    OPTION_NOT_AVAILABLE: 'Not Available',
    VEHICLE_SELECTION: 'Vehicle Selection',
    VEHICLE_SELECTION_ACTION: 'Vehicle Selection',
    VEHICLE_SELECTION_TITLE: 'Select Vehicle',
    CHANGE_SELECTION: 'Change Selection',
    SELECTED: 'Selected',
    SELECT_BRAND: 'Select Brand',
    SELECT_MODEL: 'Select Model',
    SELECT_VEHICLE: 'Select Vehicle',
    SEARCH_BRAND_PLACEHOLDER: 'Type a brand',
    SEARCH_MODEL_PLACEHOLDER: 'Type a model',
    SEARCHING: 'Searching...',
    NO_RESULTS: 'No results found',
    CONFIRM_SELECTION: 'Confirm Selection',
    CANCEL: 'Cancel',
    CATALOG_NOT_FOUND: 'Not in catalog',
    OTHER_ENGINE: 'Other',
    LABEL_DAMAGE_DESCRIPTION: 'Damage Description',
    LABEL_DAMAGE_CITY: 'Damage City',
    LABEL_DAMAGE_DISTRICT: 'Damage District',
    LABEL_INSURANCE_COMPANY: 'Insurance Company',
    LABEL_POLICY_NO: 'Policy No',
    LABEL_AGENCY_NAME: 'Agency Name',
    LABEL_AGENCY_CITY: 'Agency City',
    LABEL_AGENCY_PLATE_NO: 'Agency Plate No',
    CATALOG_HINT: 'Click the button to select a vehicle from the catalog',
    LABEL_AUTHORIZED_PLACEHOLDER: 'Authorized person',
    DOC_ASSIGN_DAMAGE_PHOTO: 'Vehicle Photo',
    DOC_ASSIGN_ARRIVAL_PHOTO: 'Vehicle Arrival Photos',
    DOC_ASSIGN_LICENSE: 'Driving License',
    DOC_ASSIGN_REGISTRATION: 'Registration',
    DOC_ASSIGN_POLICY: 'Traffic Insurance Policy',
    DOC_ASSIGN_FUEL_GAUGE: 'KM / Fuel Gauge',
    DOC_ASSIGN_KASKO_POLICY: 'Casco Policy',
    DOC_ASSIGN_DECLARATION: 'Declaration Report',
    DOC_ASSIGN_MUTUAL_ACCIDENT_REPORT: 'Mutual Accident Report',
    DOC_ASSIGN_PRELIMINARY_EXPERTISE_FORM: 'Preliminary Expertise Form',
    DOC_ASSIGN_SCENE_PHOTOS: 'Scene Photos',
    DOC_ASSIGN_REPORT: 'Report',
    DOC_ASSIGN_DUPLICATE: 'Duplicate',
    OPTION_RECEIVED_LOCATION_OTOMOTO: 'Otomoto Damage Repair Center',
    OPTION_OTHER: 'Other',
    ITEM_REGISTRATION_DOCUMENT: 'Registration',
    ITEM_FIRE_EXTINGUISHER: 'Fire Extinguisher',
    ITEM_TRAFFIC_SET: 'Traffic Set',
    ITEM_SPARE_KEY: 'Spare Key',
    ITEM_SPARE_TIRE: 'Spare Tire',
    ITEM_JACK: 'Jack',
    ITEM_CHAIN: 'Chain',
    ITEM_FLOOR_MATS: 'Floor Mats',
    LABEL_NOTIFICATION_DATE: 'Notification Date',
    LABEL_NOTIFICATION_TIME: 'Notification Time',
    LABEL_DAMAGE_DATE: 'Damage Date',
    LABEL_DAMAGE_TIME: 'Damage Time',
    LABEL_ESTIMATED_DAMAGE: 'Estimated Damage',
    LABEL_DAMAGE_REASON: 'Damage Cause',
    LABEL_APPROVAL_DATE: 'Approval Request Date',
    LABEL_DESCRIPTION: 'Description',
    LABEL_AGENCY_EMAIL: 'Agency Email',
    LABEL_FILE_NO: 'Claim File No',
    LABEL_POLICY_ISSUE_DATE: 'Policy Issue Date',
    LABEL_POLICY_START_DATE: 'Policy Start Date',
    LABEL_POLICY_END_DATE: 'Policy End Date',
    DAMAGE_REASON_BODILY_INJURY: 'Bodily Injury',
    DAMAGE_REASON_GLASS_BREAKAGE: 'Glass Breakage',
    DAMAGE_REASON_THEFT: 'Theft',
    DAMAGE_REASON_COLLISION: 'Collision',
    DAMAGE_REASON_EARTHQUAKE: 'Earthquake',
    DAMAGE_REASON_ROLLOVER: 'Rollover',
    DAMAGE_REASON_HEADLIGHT_SIGNAL_DAMAGE: 'Headlight / Signal Damage',
    DAMAGE_REASON_CIVIL_UNREST: 'Civil Unrest',
    DAMAGE_REASON_MALICIOUS_ACTS: 'Malicious Acts',
    DAMAGE_REASON_PROPERTY_DAMAGE: 'Property Damage',
    DAMAGE_REASON_DEATH: 'Death',
    DAMAGE_REASON_PARKED_COLLISION: 'Collision While Parked',
    DAMAGE_REASON_FLOOD: 'Flood',
    DAMAGE_REASON_CIGARETTE_BURN: 'Cigarette Burn',
    DAMAGE_REASON_TREATMENT: 'Treatment',
    DAMAGE_REASON_TERROR: 'Terror',
    DAMAGE_REASON_FIRE: 'Fire',
    AUTOFILL_BUTTON: 'AI Autofill',
    AUTOFILL_DUPLICATE_SUMMARY: 'Document-{{number}}, {{count}} copies',
    AUTOFILL_POPUP_TITLE: 'Fill with AI',
    AUTOFILL_PROGRESS_LABEL: 'Autofill progress',
    AUTOFILL_PROGRESS_STEPS: '{{completed}} of {{total}} steps',
    AUTOFILL_ELAPSED_TIME: '{{minutes}}m {{seconds}}s',
    AUTOFILL_QUEUE_POSITION: 'You are number {{position}} in the queue',
    AUTOFILL_PHASE_PREPARE_JOB: 'Preparing job',
    AUTOFILL_PHASE_PREPARE_JOB_COMPLETE: 'Job prepared',
    AUTOFILL_PHASE_SEND_DOCUMENTS: 'Sending documents',
    AUTOFILL_PHASE_SEND_DOCUMENTS_COMPLETE: 'Documents sent',
    AUTOFILL_PHASE_GENERATE_RECOMMENDATIONS: 'Generating recommendations',
    AUTOFILL_PHASE_GENERATE_RECOMMENDATIONS_COMPLETE: 'Recommendations generated',
    AUTOFILL_PHASE_REVIEW_RECOMMENDATIONS: 'Reviewing recommendations',
    AUTOFILL_PHASE_REVIEW_RECOMMENDATIONS_COMPLETE: 'Recommendations reviewed',
    AUTOFILL_PHASE_ADDITIONAL_CHECKS: 'Performing additional checks',
    AUTOFILL_PHASE_ADDITIONAL_CHECKS_COMPLETE: 'Additional checks complete',
    AUTOFILL_PROGRESS_AI: 'AI analysis',
    AUTOFILL_PROGRESS_REVIEW: 'Review',
    AUTOFILL_ANALYSIS_TITLE: 'AI Analysis',
    AUTOFILL_ANALYSIS_COMPLETE: 'Analysis complete',
    AUTOFILL_SUCCESS_ANIMATION_ALT: 'AI analysis complete',
    AUTOFILL_CONTINUING: 'Continuing... ({{seconds}})',
    AUTOFILL_REVIEW_TITLE: 'Review recommendations',
    AUTOFILL_REVIEW_DESCRIPTION: 'All recommendations are enabled. Turn off any you do not want to apply.',
    AUTOFILL_SECTION_OWNER: 'Customer',
    AUTOFILL_SECTION_REGISTERED_OWNER: 'Registered owner — {{type}}',
    AUTOFILL_SECTION_VEHICLE: 'Vehicle',
    AUTOFILL_SECTION_OTHER: 'Other Findings',
    AUTOFILL_SECTION_COUNTERPARTY: 'Counterparty {{number}}',
    AUTOFILL_SECTION_DOCUMENTS: 'Document Categorization',
    AUTOFILL_CATEGORY_UNKNOWN: 'Uncategorized',
    AUTOFILL_CATEGORY_COUNTERPARTY_DRIVING_LICENSE: 'Counterparty driving licence',
    AUTOFILL_CATEGORY_COUNTERPARTY_REGISTRATION: 'Counterparty vehicle registration',
    AUTOFILL_CATEGORY_COUNTERPARTY_INSURANCE_POLICY: 'Counterparty insurance policy',
    AUTOFILL_FIELD_COUNTERPARTY_NAME: 'Counterparty name',
    AUTOFILL_FIELD_COUNTERPARTY_SURNAME: 'Counterparty surname',
    AUTOFILL_FIELD_COUNTERPARTY_TCKN: 'Counterparty TCKN',
    AUTOFILL_FIELD_COUNTERPARTY_VEHICLE_PLATE: 'Counterparty vehicle plate',
    AUTOFILL_FIELD_OWNER_FIRST_NAME: 'Customer first name',
    AUTOFILL_FIELD_OWNER_LAST_NAME: 'Customer last name',
    AUTOFILL_FIELD_OWNER_TCKN: 'TCKN',
    AUTOFILL_FIELD_OWNER_BIRTH_DATE: 'Customer birth date',
    AUTOFILL_FIELD_LICENSE_CLASS: 'Driving licence class',
    AUTOFILL_FIELD_LICENSE_NO: 'Driving licence number',
    AUTOFILL_FIELD_VEHICLE_PLATE: 'Vehicle plate',
    AUTOFILL_FIELD_VEHICLE_BRAND: 'Vehicle brand',
    AUTOFILL_FIELD_VEHICLE_MODEL: 'Vehicle model',
    AUTOFILL_FIELD_MODEL_YEAR: 'Model year',
    AUTOFILL_FIELD_CHASSIS_NO: 'Chassis number',
    AUTOFILL_FIELD_USAGE_TYPE: 'Usage type',
    AUTOFILL_FIELD_MILEAGE: 'Mileage',
    AUTOFILL_FIELD_UNKNOWN: 'Suggested field',
    AUTOFILL_REVIEW_EMPTY: 'No details could be applied automatically from these documents.',
    AUTOFILL_NO_FIELDS_WARNING: 'No form fields could be suggested',
    AUTOFILL_PARTIAL_WARNING: 'Some document details could not be applied automatically.',
    AUTOFILL_UNRESOLVED_EVIDENCE: 'Unresolved evidence',
    AUTOFILL_UNRESOLVED_uncertainIdentity: 'Identity is uncertain',
    AUTOFILL_UNRESOLVED_conflictingEvidence: 'Documents conflict',
    AUTOFILL_UNRESOLVED_unclassifiedDocument: 'Document could not be classified',
    AUTOFILL_UNRESOLVED_unmatchedSide: 'Case side could not be matched',
    AUTOFILL_UNRESOLVED_unsupportedField: 'Value is not supported for this case',
    AUTOFILL_UNRESOLVED_documentUnreadable: 'Document could not be read',
    AUTOFILL_UNRESOLVED_uncertainReading: 'Document reading is uncertain',
    AUTOFILL_WARNING_DESCRIPTION: 'The analysis kept its verified suggestions, but some images could not be understood confidently. Review their assignments and fill any missing fields manually.',
    AUTOFILL_DOCUMENT_FAILED: 'analysis failed',
    AUTOFILL_PARTY_UNRESOLVED: 'person could not be matched to this case',
    AUTOFILL_DOCUMENT_UNKNOWN: 'unclassified',
    AUTOFILL_DOCUMENT_WEAK: 'low confidence',
    AUTOFILL_DOCUMENT_RETRIED: 'rechecked once',
    AUTOFILL_DOCUMENT_COUNTS: '{{extracted}} values read, {{valid}} format-valid, {{held}} held for person matching',
    AUTOFILL_CASE_CORROBORATED: 'Matched across documents in the whole-case review',
    AUTOFILL_CASE_AI_PREFERRED: 'AI suggests this value; verify it against the source documents',
    AUTOFILL_CASE_RECONCILIATION_UNAVAILABLE_TITLE: 'Case matching was incomplete',
    AUTOFILL_CASE_RECONCILIATION_UNAVAILABLE_HELP: 'Document-level suggestions remain available, but related people and vehicles may not have been matched. Check the source documents before applying.',
    AUTOFILL_CATEGORY_VIN_PHOTO: 'VIN photo',
    AUTOFILL_ERROR_AI_TITLE: 'AI analysis could not be completed',
    AUTOFILL_ERROR_AI_DESCRIPTION: 'Please retry AI analysis.',
    AUTOFILL_RETRY_AI: 'Retry AI Analysis',
    AUTOFILL_APPLY_SELECTED: 'Apply selected ({{count}})',
  },
  CASE_EVENTS: {
    BOOKING_CREATED: {
      TITLE: 'Booking created',
      DETAIL: 'The customer booking was created.',
    },
    VEHICLE_REGISTERED: {
      TITLE: 'Vehicle registered',
      DETAIL: 'The vehicle was registered and the case was created.',
    },
    CASE_DELIVERED: {
      TITLE: 'Case delivered',
      DETAIL: 'The vehicle was delivered and the case was completed.',
    },
    INVOICE_ISSUED: {
      TITLE: 'Invoice issued',
      DETAIL: 'The case was marked as invoice issued.',
    },
    INVOICE_COLLECTED: {
      TITLE: 'Invoice collected',
      DETAIL: 'The invoice was marked as collected.',
    },
    INVOICE_COLLECTION_REVERTED: {
      TITLE: 'Invoice collection removed',
      DETAIL: 'The invoice collection mark was removed from the case.',
    },
    INVOICE_UNISSUED: {
      TITLE: 'Invoice mark removed',
      DETAIL: 'The invoice-issued mark was removed from the case.',
    },
  },
  WORK_ORDER_WORK_EVENTS: {
    UNKNOWN_WORK: 'this work item',
    UNKNOWN_WORKSHOP: 'relevant',
    FALLBACK_TITLE: 'Status update',
    FALLBACK_DETAIL: 'A new work event was recorded.',
    ON_BEHALF_OF: 'Performed on behalf of {{technician}}; KPI credit belongs to that technician.',
    UNKNOWN: {
      TITLE: 'Status update',
      DETAIL: 'A new work event was recorded for {{work}}.',
    },
    DAMAGE_ANALYSIS_COMPLETED: {
      TITLE: 'Damage analysis approved',
      DETAIL: 'Damage analysis was approved and the work orders are waiting for parts readiness and technician assignment.',
    },
    DAMAGE_ANALYSIS_APPROVAL_REVERTED: {
      TITLE: 'Damage analysis approval reverted',
      DETAIL: 'The damage analysis approval was reverted and the analysis is editable again.',
    },
    DAMAGE_ANALYSIS_WORK_ADDED: {
      TITLE: 'Damage / operation added',
      DETAIL: '{{work}} was added to the damage analysis.',
    },
    DELETION_REQUESTED: {
      TITLE: 'Deletion requested',
      DETAIL: '{{requester}} requested deletion of this {{target}}.',
    },
    DELETION_REQUEST_WITHDRAWN: {
      TITLE: 'Deletion request withdrawn',
      DETAIL: '{{requester}} withdrew the deletion request for this {{target}}.',
    },
    DELETION_REQUEST_REJECTED: {
      TITLE: 'Deletion request rejected',
      DETAIL: '{{reviewer}} rejected the deletion request for this {{target}}.',
    },
    ADDITIONAL_WORK_ORDER_CREATED: {
      TITLE: 'Additional work order created',
      DETAIL: '{{work}} was added as additional work and awaits expertise approval.',
    },
    ADDITIONAL_WORK_ORDER_APPROVED: {
      TITLE: 'Additional work order approved',
      DETAIL: '{{work}} was approved and is ready for assignment.',
    },
    ADDITIONAL_WORK_ORDER_CANCELLED: {
      TITLE: 'Additional work order cancelled',
      DETAIL: '{{work}} was cancelled before expertise approval.',
    },
    DAMAGE_ANALYSIS_WORK_UPDATED: {
      TITLE: 'Damage / operation updated',
      DETAIL: '{{work}} was updated in the damage analysis.',
    },
    BILLING_WORK_ORDER_PRICE_UPDATED: {
      TITLE: 'Work-order price updated',
      DETAIL: '{{work}} labor price changed from {{previousPrice}} ₺ to {{newPrice}} ₺.',
    },
    BILLING_PART_PRICE_UPDATED: {
      TITLE: 'Spare-part price updated',
      DETAIL: '{{part}} unit price in {{work}} changed from {{previousPrice}} ₺ to {{newPrice}} ₺.',
    },
    BILLING_PART_SALE_PRICE_UPDATED: {
      TITLE: 'Spare-part sale price updated',
      DETAIL: '{{part}} sale price in {{work}} changed from {{previousPrice}} ₺ to {{newPrice}} ₺.',
    },
    ANALYST_NOTES_UPDATED: {
      TITLE: 'Analyst notes updated',
      DETAIL: 'Analyst notes were updated for {{work}}.',
    },
    ANALYST_NOTES_CLEARED: {
      TITLE: 'Analyst notes cleared',
      DETAIL: 'Analyst notes were cleared for {{work}}.',
    },
    DAMAGE_ANALYSIS_WORK_REMOVED: {
      TITLE: 'Damage / operation removed',
      DETAIL: '{{work}} was removed from the damage analysis.',
    },
    DAMAGE_ANALYSIS_PART_ADDED: {
      TITLE: 'Spare part added',
      DETAIL: '{{part}} was added to {{work}}.',
    },
    DAMAGE_ANALYSIS_PART_UPDATED: {
      TITLE: 'Spare part updated',
      DETAIL: '{{part}} was updated in {{work}}.',
    },
    DAMAGE_ANALYSIS_PART_REMOVED: {
      TITLE: 'Spare part removed',
      DETAIL: '{{part}} was removed from {{work}}.',
    },
    SERVICE_MANAGER_APPROVED: {
      TITLE: 'Service manager approved the file',
      DETAIL: 'Service manager approval was completed for {{work}}. Unit assignment is now expected.',
    },
    SERVICE_MANAGER_RETURNED: {
      TITLE: 'Service manager returned the file',
      DETAIL: '{{work}} was returned to the previous review step.',
    },
    WORKSHOP_ASSIGNED: {
      TITLE: 'Workshop readiness approved',
      DETAIL: '{{work}} in {{workshop}} was approved as ready by the Workshop Manager.',
    },
    TECHNICIAN_ASSIGNED: {
      TITLE: 'Technician assigned',
      DETAIL: '{{work}} was assigned to technician {{assignedUserDisplayName}}.',
    },
    TECHNICIAN_UNASSIGNED: {
      TITLE: 'Technician unassigned',
      DETAIL: '{{previousAssignedUserDisplayName}} is no longer assigned to {{work}}.',
    },
    READY_FOR_WORK: {
      TITLE: 'Ready for work',
      DETAIL: 'All work orders have ready parts and assigned technicians.',
    },
    WORK_STARTED: {
      TITLE: 'Work started',
      DETAIL: 'Technician work started for {{work}}.',
    },
    WORK_PAUSED: {
      TITLE: 'Work paused',
      DETAIL: '{{work}} was paused.',
    },
    WORK_RESUMED: {
      TITLE: 'Work resumed',
      DETAIL: 'Work resumed for {{work}}.',
    },
    WORK_COMPLETED: {
      TITLE: 'Work completed',
      DETAIL: '{{work}} was completed and sent to the next approval step.',
    },
    WORKSHOP_MANAGER_APPROVED: {
      TITLE: 'Workshop Manager approved the work',
      DETAIL: '{{work}} was approved by the Workshop Manager and is waiting for the next planning step.',
    },
    WORKSHOP_MANAGER_REJECTED: {
      TITLE: 'Workshop Manager returned the work',
      DETAIL: '{{work}} was returned to the technician for revision.',
    },
    REPEAT_WORK_ORDER_CREATED: {
      TITLE: 'Repeat work order created',
      DETAIL: 'A repeat work order was created.',
    },
    REPEAT_WORK_ORDER_CANCELLED: {
      TITLE: 'Repeat work order cancelled',
      DETAIL: 'The repeat work order was cancelled.',
    },
    REPEAT_WORK_ORDER_DELIVERED: {
      TITLE: 'Repeat work delivered',
      DETAIL: '{{work}} was delivered.',
    },
    WORKSHOP_MANAGER_APPROVAL_REVERTED: {
      TITLE: 'Completion approval reverted',
      DETAIL: 'The completion approval for {{work}} was reverted and the work is awaiting Workshop Manager review again.',
    },
    SERVICE_REVIEW_SENT: {
      TITLE: 'Sent to final service review',
      DETAIL: 'The case was sent to the service manager for final readiness review.',
    },
    WORK_ORDER_READY: {
      TITLE: 'Ready for delivery',
      DETAIL: 'All approvals are complete. The file has moved to delivery readiness stage.',
    },
    WORK_ORDER_STATUS_CHANGED: {
      TITLE: 'work order status changed',
      DETAIL: '{{work}} changed from {{fromCaseWorkStatus}} to {{toCaseWorkStatus}}.',
    },
  },
  REPEAT_WORK_ORDER: {
    LABEL: 'Repeat #{{number}}',
    CREATE: 'Create work repeat',
    SHOW: 'View work repeat',
    IS_REPEAT: 'This is a work repeat.',
    HAS_REPEAT: 'This work has been repeated.',
    OPEN_PARENT: 'Open Parent Case',
    OPEN_PREVIOUS: 'Open Previous Repeat',
    CANCEL: 'Cancel Repeat',
    PARENT_CASE: 'Parent case',
    LIST_TITLE: 'Repeat work orders',
    STATUS: 'Status',
    LOAD_ERROR: 'Repeat work order could not be loaded.',
    CANCEL_CONFIRM: 'Cancel this repeat work order? This cannot be undone.',
    WORK_ORDER_STATUS_1: 'Created',
    WORK_ORDER_STATUS_2: 'Ready for processing',
    WORK_ORDER_STATUS_4: 'Assigned to technician',
    WORK_ORDER_STATUS_5: 'Work started',
    WORK_ORDER_STATUS_6: 'Work completed',
    WORK_ORDER_STATUS_7: 'Ready for Delivery',
    WORK_ORDER_STATUS_8: 'Work paused',
    WORK_ORDER_STATUS_9: 'Cancelled',
    WORK_ORDER_STATUS_10: 'Delivered',
  },
};

export const caseI18nTr = {
  REPEAT_WORK_ORDER: {
    LABEL: 'Tekrar #{{number}}',
    CREATE: 'İş Tekrarı Oluştur',
    SHOW: 'İş Tekrarını Göster',
    IS_REPEAT: 'Bu bir iş tekrarıdır.',
    HAS_REPEAT: 'Bu iş tekrarlanmıştır.',
    OPEN_PARENT: 'Ana Dosyayı Aç',
    OPEN_PREVIOUS: 'Önceki Tekrarı Aç',
    CANCEL: 'İş Tekrarını İptal Et',
    PARENT_CASE: 'Ana dosya',
    LIST_TITLE: 'İş Tekrarı Emirleri',
    STATUS: 'Durum',
    WORK_ORDER_STATUS_1: 'Oluşturuldu',
    WORK_ORDER_STATUS_2: 'İşleme hazır',
    WORK_ORDER_STATUS_4: 'Teknisyene atandı',
    WORK_ORDER_STATUS_5: 'İş başlatıldı',
    WORK_ORDER_STATUS_6: 'İş tamamlandı',
    WORK_ORDER_STATUS_7: 'Teslime hazır',
    WORK_ORDER_STATUS_8: 'İş duraklatıldı',
    WORK_ORDER_STATUS_9: 'İptal edildi',
    WORK_ORDER_STATUS_10: 'Teslim edildi',
    LOAD_ERROR: 'İş tekrarı emri yüklenemedi.',
    CANCEL_CONFIRM: 'Bu iş tekrarı emri iptal edilsin mi? Bu işlem geri alınamaz.',
  },
  CASE_DOCUMENT: {
    ASSIGNED: 'Atandı',
  },
  CASE_LISTING: {
    FILTER: 'Filtrele',
    TITLE_WITH_CURRENT_VEHICLE_COUNT: 'Servisteki Araç Sayısı: {{count}}{{repeatWorkSuffix}}',
    TITLE_WITH_TOTAL_CASE_COUNT: 'Toplam Dosya Sayısı: {{count}}',
    ACTIVE_REPEAT_WORK_SUFFIX: ' ({{count}} iş tekrarı)',
    SUBTITLE: 'Servisteki araçları görüntüleyin, filtreleyin ve yönetin.',
    ENTRY_ALL: 'Tümü',
    ENTRY_MAIN: 'Ana dosyalar',
    ENTRY_REPEAT: 'Tekrarlar',
    ENTRY_TYPE: 'Kayıt türü',
    DAMAGE_TYPE: 'Hasar türü',
    CREATE_CASE: 'Araç Kaydı Oluştur',
    COLUMN_CASE: 'Dosya',
    COLUMN_PLATE: 'Plaka',
    COLUMN_VEHICLE: 'Ara\u00e7 bilgileri',
    COLUMN_SERVICE_DURATION: 'Serviste Kaldığı Süre',
    COLUMN_VEHICLE_SORT: 'Araca g\u00f6re s\u0131rala',
    COLUMN_CUSTOMER: 'Müşteri',
    COLUMN_RECORD_TYPE: 'Kayıt Türü',
    COLUMN_STATUS: 'Durum',
    COLUMN_CREATED_DATE: 'Araç Giriş Tarihi',
    VIEW_RECORD: 'Kaydı aç',
    EDIT: 'Düzenle',
    DELETE: 'Sil',
    DELETE_CONFIRM_TITLE: 'Dosyayı sil',
    DELETE_CONFIRM_MESSAGE: '{{caseNo}} dosyasını silmek istiyor musunuz? Bu işlem dosyayı listeden kaldırır.',
    DELETE_CONFIRM_ACTION: 'Sil',
    DELETE_CANCEL: 'Vazgeç',
    DELETE_FAILED: 'Dosya silinemedi.',
    DELETE_REQUEST_CONFIRM_TITLE: 'Dosya silme talebi oluştur',
    DELETE_REQUEST_CONFIRM_MESSAGE: '{{caseNo}} dosyasının silinmesi için yönetici onayı istiyor musunuz?',
    DELETE_REQUEST_ACTION: 'Silme talebi oluştur',
    DELETE_REQUEST_FAILED: 'Silme talebi işlemi tamamlanamadı.',
    DELETE_REQUEST_ALREADY_PENDING: 'Bu dosya için zaten bekleyen bir silme talebi var.',
    DELETE_REQUEST_PENDING: 'Silme talebi bekliyor',
    DELETE_REQUEST_REVIEW_REQUIRED: 'Silme onayı bekliyor',
    UNREAD_DELETION_REQUEST_ALERT: 'Okunmamış silme talepleri var.',
    DELETE_REQUEST_PENDING_TITLE: 'Silme talebi bekliyor',
    DELETE_REQUEST_PENDING_MESSAGE: '{{user}}, {{dateTime}} tarihinde silme talebi oluşturdu.',
    DELETE_REQUEST_WITHDRAW: 'Talebi geri çek',
    DELETE_REQUEST_REVIEW_TITLE: 'Silme talebini incele',
    DELETE_REQUEST_REVIEW_MESSAGE: '{{user}}, {{dateTime}} tarihinde silme talebi oluşturdu.',
    DELETE_REQUEST_REJECT: 'Reddet',
    DELETE_REQUEST_CONFIRM_ACTION: 'Silmeyi onayla',
    LOADING: 'Dosyalar yükleniyor...',
    LOAD_ERROR: 'Dosyalar yüklenemedi.',
    EMPTY_STATE: 'Dosya bulunamadı',
    STATUS_NEW: 'Kaydedildi',
    STATUS_ASSIGNED: 'Sırada Bekliyor',
    STATUS_WAITING: 'Bekleyen',
    STATUS_IN_PROGRESS: 'Devam Eden',
    STATUS_DONE: 'Tamamlanan',
    STATUS_IN_SERVICE: 'Serviste',
    STATUS_PARTS_PENDING: 'Parça Bekliyor',
    STATUS_READY: 'Teslime hazır',
    STATUS_DELIVERED: 'Teslim edildi',
    COLUMN_INVOICE_ISSUED: 'Geçmiş Fatura Kesildi',
    COLUMN_INVOICE_STATUS: 'Fatura Durumu',
    INVOICE_STATUS_NOT_ISSUED: 'Kesilmedi',
    INVOICE_STATUS_ISSUED: 'Fatura Kesildi',
    INVOICE_STATUS_COLLECTED: 'Fatura Tahsil Edildi',
    FILTER_INVOICE_ISSUED: 'Geçmiş fatura kesilenleri göster',
    INVOICE_ISSUED_YES: 'Evet',
    INVOICE_ISSUED_NO: 'Hayır',
    RECORD_TYPE_DAMAGE: 'Hasar',
    RECORD_TYPE_MECHANICAL: 'Mekanik',
    OWNER_INDIVIDUAL: 'Şahıs',
    OWNER_CORPORATE: 'Kurum',
    PROJECT_DAMAGE_OPS: 'Hasar Operasyonu',
    PROJECT_PERIODIC_MAINTENANCE: 'Periyodik Bakım',
    FILTER_APPLY: 'Uygula',
    FILTER_CLEAR: 'Temizle',
    FILTER_CANCEL: 'Vazgeç',
    FILTER_ALL: 'Tümü',
    PLATE_SEARCH_LABEL: 'Plaka Araması:',
    WORK_ORDER_SEARCH_LABEL: 'İş Emri Araması:',
    FILTER_PLATE_PLACEHOLDER: 'Plakaya göre filtrele',
    FILTER_CREATED_FROM: 'Araç giriş başlangıç',
    FILTER_CREATED_TO: 'Araç giriş bitiş',
    COLUMN_PLATE_SORT: 'Plakaya göre sırala',
    COLUMN_WORK_ORDER_NUMBERS: 'İş Emri Numaraları',
    COLUMN_CUSTOMER_SORT: 'Müşteriye göre sırala',
    COLUMN_CREATED_DATE_SORT: 'Araç giriş tarihine göre sırala',
    DISPLAY_DELIVERED: 'Teslim edilenleri göster',
    REPORT_DOWNLOAD: 'Listeyi Çıkart',
    REPORT_DOWNLOADING: 'Rapor hazırlanıyor...',
    REPORT_DOWNLOAD_ERROR: 'Rapor indirilemedi. Lütfen tekrar deneyin.',
  },
  CASE_DETAIL: {
    ACCIDENT_PARTIES_TITLE: 'Karşı Taraflar',
    ACCIDENT_SINGLE_VEHICLE: 'Tek araçlı trafik kazası',
    ACCIDENT_PARTY_DOCUMENT_COUNT: 'belge',
    ACCIDENT_PARTY_NO_DOCUMENTS: 'Belge yok',
    ACCIDENT_VEHICLES_SUFFIX: 'araç',
    BACK_TO_FILES: 'Dosyalara dön',
    CLOSE: 'Kapat',
    LOADING: 'Dosya yükleniyor...',
    LOAD_ERROR: 'Dosya yüklenemedi.',
    IN_SERVICE: 'Serviste',
    STATUS_PENDING: 'Beklemede',
    STATUS_REGISTERED: 'Araç kaydı yapıldı',
    STATUS_ASSIGNED: 'Serviste sıra bekliyor',
    STATUS_IN_SERVICE: 'Serviste',
    STATUS_READY: 'Teslime hazır',
    STATUS_DELIVERED: 'Teslim edildi',
    TAB_OVERVIEW: 'Genel Bakış',
    TAB_DAMAGE_INSURANCE: 'Hasar ve Sigorta Bilgileri',
    TAB_DAMAGE_MAP: 'Ekspertiz',
    TAB_WORK_ORDER: 'İş Emri',
    TAB_PHOTOS: 'Fotoğraflar',
    TAB_DOCUMENTS: 'Belgeler',
    TAB_OFFICIAL_FORMS: 'Resmi Formlar',
    TAB_BILLING: 'Fatura',
    BILLING_SAVE: 'Kaydet',
    BILLING_SAVING: 'Kaydediliyor...',
    BILLING_EXPORT_INVOICE: 'Fatura Çıkart',
    BILLING_BASE_LABOR: 'Temel İşçilik',
    BILLING_PART_TOTAL: 'Parça Toplamı',
    BILLING_EXTRA_SERVICES: 'Ek hizmetler',
    BILLING_ITEM_COUNT: '{{count}} kalem',
    BILLING_ACTIVE_ROWS: '{{count}} aktif satır',
    BILLING_ACTIVE: '{{count}} aktif',
    BILLING_REGISTERED_LABOR: 'Kayıtlı İşçilikler',
    BILLING_EMPTY_LABOR: 'Henüz kayıtlı işçilik tutarı yok.',
    BILLING_REGISTERED_PARTS: 'Kayıtlı Parçalar',
    BILLING_PART_LINE_DEFAULT: 'Parça kalemi',
    BILLING_EMPTY_PARTS: 'Henüz fiyatlı parça kalemi yok.',
    BILLING_SUMMARY_REGISTERED_LABOR: 'Kayıtlı işçilik',
    BILLING_SUMMARY_REGISTERED_PART: 'Kayıtlı parça',
    BILLING_SUMMARY_EXTRA_BILLABLE: 'Müşteriye yansıtılacak ek tutar',
    BILLING_SUBTOTAL: 'Ara toplam',
    BILLING_VAT_RATE: 'KDV Oranı',
    BILLING_VAT: 'KDV',
    BILLING_GRAND_TOTAL: 'Genel toplam',
    BILLING_DISCOUNT_RATE: 'İndirim %',
    BILLING_DISCOUNT_AMOUNT: 'İndirim tutarı',
    BILLING_NET_AMOUNT: 'Net tutar',
    BILLING_ITEM_DISCOUNTS: 'Kalem indirimleri',
    BILLING_FINAL_DISCOUNT: 'Genel indirim',
    BILLING_FINAL_DISCOUNT_AMOUNT: 'Genel indirim tutarı',
    BILLING_TAX_BASE: 'KDV matrahı',
    BILLING_NET_SUBTOTAL: 'Net ara toplam',
    BILLING_TOTAL_TITLE: 'TOPLAM',
    BILLING_SECTION_LABOR: 'İşçilikler',
    BILLING_SECTION_PARTS: 'Parçalar',
    BILLING_SECTION_EXTRA: 'Ek hizmet / ek işçilik',
    BILLING_COL_WORK_ORDER: 'İş emri',
    BILLING_COL_PART: 'Parça',
    BILLING_COL_GROSS: 'Brüt',
    BILLING_COL_DISCOUNT: 'İndirim',
    BILLING_COL_NET: 'Net',
    BILLING_EXTRA_SERVICE_ENTRIES: 'Ek hizmet ve ek işçilik girişleri',
    BILLING_COL_SERVICE: 'Hizmet',
    BILLING_COL_RESULT: 'Sonuç / Açıklama',
    BILLING_COL_AMOUNT: 'Tutar',
    BILLING_COL_BILLABLE: 'Müşteriye Yansıt',
    BILLING_COL_REASON: 'Sebep',
    BILLING_PLACEHOLDER_RESULT: 'İşlem sonucu veya not',
    BILLING_PLACEHOLDER_AMOUNT: 'Ücret: 0,00',
    BILLING_PLACEHOLDER_BILLABLE: 'Yansıtılacak: 0,00',
    BILLING_PLACEHOLDER_REASON: 'Fatura sebebi',
    BILLING_REMOVE_ROW: 'Satırı sil',
    BILLING_PLACEHOLDER_NEW_SERVICE: 'Yeni hizmet veya ek işçilik adı',
    BILLING_ADD_LINE: 'Kalem Ekle',
    BILLING_BASE_AMOUNT: 'Temel ücret',
    BILLING_CANCEL: 'İptal',
    BILLING_CONFIRM_ADD: 'Ekle',
    BILLING_SERVICE_DAMAGE_LABOR: 'Hasar işçiliği',
    BILLING_SERVICE_BREAKDOWN_REPAIR: 'Arıza onarımı',
    BILLING_SERVICE_RENTAL_CAR: 'Kiralık araç',
    BILLING_SERVICE_DAMAGE_PARTS: 'Hasar parça',
    BILLING_SAVE_SUCCESS: 'Fatura bilgileri kaydedildi.',
    BILLING_SAVE_ERROR: 'Fatura bilgileri kaydedilemedi.',
    BILLING_LOCKED: 'Ödeme veya teslim sonrasında muhasebe bilgileri kilitlenir.',
    INVOICE_ISSUED: 'Fatura Kesildi',
    INVOICE_NOT_ISSUED: 'Fatura Kesilmedi',
    INVOICE_ISSUED_AT: 'Fatura kesilme tarihi: {{value}}',
    INVOICE_ISSUED_UPDATING: 'Güncelleniyor',
    INVOICE_ISSUED_PREREQUISITE: 'Tüm iş emirleri tamamlanıp onaylandıktan sonra kullanılabilir.',
    INVOICE_ISSUED_PERMISSION_REQUIRED: 'Bu fatura durumunu güncelleme yetkiniz yok.',
    INVOICE_ISSUED_SAVE_ERROR: 'Fatura durumu güncellenemedi.',
    INVOICE_COLLECTED: 'Fatura Tahsil Edildi',
    INVOICE_NOT_COLLECTED: 'Fatura Tahsil Edilmedi',
    INVOICE_COLLECTED_AT: 'Tahsil tarihi: {{value}}',
    INVOICE_COLLECTED_UPDATING: 'Güncelleniyor',
    INVOICE_COLLECTED_PREREQUISITE: 'Fatura kesildikten sonra kullanılabilir.',
    INVOICE_COLLECTED_SAVE_ERROR: 'Fatura tahsil durumu güncellenemedi.',
    INVOICE_COLLECTION_METHOD_TITLE: 'Fatura Tahsilatını Kaydet',
    INVOICE_COLLECTION_METHOD_PROMPT: 'Tahsilat yöntemini seçin.',
    INVOICE_COLLECTION_PAYMENT_METHOD: 'Tahsilat yöntemi: {{value}}',
    INVOICE_COLLECTION_PAYMENT_METHOD_1: 'Kredi Kartı',
    INVOICE_COLLECTION_PAYMENT_METHOD_2: 'Nakit',
    INVOICE_COLLECTION_PAYMENT_METHOD_3: 'Havale',
    INVOICE_COLLECTION_CANCEL: 'İptal',
    INVOICE_COLLECTION_CONFIRM: 'Tahsilatı Onayla',
    INVOICE_COLLECTION_CLEAR_TITLE: 'Fatura tahsilatı kaldırılsın mı?',
    INVOICE_COLLECTION_CLEAR_MESSAGE: 'Fatura tahsil tarihi ve tahsilat yöntemi kaldırılacaktır.',
    INVOICE_COLLECTION_CLEAR_CONFIRM: 'Tahsilatı Kaldır',
    INVOICE_ISSUED_COLLECTION_MUST_BE_CLEARED: 'Fatura kesildi işaretini kaldırmadan önce tahsilatı kaldırın.',
    BILLING_INVOICE_ISSUED_LOCKED: 'Fatura kesildi olarak işaretliyken muhasebe kalemleri güncellenemez.',
    BILLING_LEGACY_TITLE: 'Eski muhasebe hesaplaması',
    BILLING_LEGACY_HINT: 'Bu kayıt, dinamik kalem fiyatlandırmasına açıkça dönüştürülene kadar mevcut toplamını korur.',
    BILLING_CONVERT_ACTION: 'Dinamik Fiyatlandırmaya Dönüştür',
    BILLING_CONVERT_TITLE: 'Muhasebe hesaplaması dönüştürülsün mü?',
    BILLING_CONVERT_MESSAGE: 'Mevcut toplam {{oldTotal}}. Kalem bazlı dönüştürülmüş toplam {{newTotal}} olacak (fark: {{difference}}). Bu işlem bu ekrandan geri alınamaz.',
    BILLING_CONVERT_CONFIRM: 'Dönüştür ve Kaydet',
    BILLING_ADJUSTMENT_COUNT: '{{count}} düzenleme',
    BILLING_ADJUSTMENT_LABEL: 'Düzenleme açıklaması',
    BILLING_TYPE_PERCENT_DISCOUNT: 'Yüzde indirim',
    BILLING_TYPE_PERCENT_TAX: 'Yüzde vergi',
    BILLING_ADD_ADJUSTMENT: 'Düzenleme ekle',
    BILLING_REMOVE_ADJUSTMENT: 'Düzenlemeyi kaldır',
    BILLING_MOVE_UP: 'Düzenlemeyi yukarı taşı',
    BILLING_MOVE_DOWN: 'Düzenlemeyi aşağı taşı',
    BILLING_TOTAL_DISCOUNTS: 'Toplam indirim',
    BILLING_TOTAL_TAXES: 'Toplam vergi',
    BILLING_DEFAULT_TAX_LABEL: 'KDV',
    BILLING_LEGACY_LINE_DISCOUNT: 'Eski kalem indirimi',
    BILLING_LEGACY_FINAL_DISCOUNT: 'Eski genel indirim',
    BILLING_ADJUSTMENT_VALIDATION_ERROR: 'Her düzenleme için açıklama ve sıfırdan küçük olmayan geçerli bir değer girin. Yüzde değerleri 100\'ü aşamaz.',
    DOCUMENT_LOAD_ERROR: 'Belge yüklenemedi.',
    DOCUMENT_UPLOAD_ERROR: 'Yükleme başarısız oldu. Lütfen tekrar deneyin.',
    TAB_DELIVERY: 'Teslim & İmza',
    TAB_TIMESTAMPS: 'Zamanları Güncelle',
    TIMESTAMPS_TITLE: 'Zamanları Güncelle',
    TIMESTAMPS_HINT: 'Tüm saatler Türkiye saatiyle düzenlenir.',
    TIMESTAMPS_LOADING: 'Zamanlar yükleniyor...',
    TIMESTAMPS_LOAD_ERROR: 'Zamanlar yüklenemedi.',
    TIMESTAMPS_SAVE: 'Zamanları kaydet',
    TIMESTAMPS_SAVING: 'Kaydediliyor...',
    TIMESTAMPS_SAVE_ERROR: 'Zamanlar kaydedilemedi.',
    TIMESTAMPS_CONFLICT_ERROR: 'Kayıt değişmiş. Yeniden kaydetmeden önce zamanları tekrar yükleyin.',
    TIMESTAMPS_VALIDATION_ERROR: 'Girilen tarih ve saatleri kontrol edin. Tahsil tarihi kaldırılamaz veya fatura kesilme tarihinden önce olamaz.',
    TIMESTAMPS_COLLECTION_DATE_REQUIRED: 'Tahsil tarihi ve saatini birlikte girin. Mevcut tahsil tarihi kaldırılamaz.',
    TIMESTAMPS_COLLECTION_BEFORE_ISSUE: 'Tahsil tarihi ve saati, fatura kesilme tarihi ve saatinden önce olamaz.',
    TIMESTAMPS_CASE: 'Dosya',
    TIMESTAMPS_CASE_CREATED: 'Oluşturulma Tarihi',
    TIMESTAMPS_CASE_AND_VEHICLE_REGISTERED: 'Dosya ve Araç Kayıt Tarihi',
    TIMESTAMPS_INVOICE_ISSUED: 'Geçmiş Fatura Kesilme Tarihi',
    TIMESTAMPS_INVOICE_COLLECTED: 'Geçmiş Fatura Tahsil Tarihi',
    TIMESTAMPS_CASE_DELIVERED: 'Dosya Teslim Tarihi',
    TIMESTAMPS_SIGNATURE: 'Teslim İmzası',
    TIMESTAMPS_SIGNATURE_SIGNED: 'İmza Tarihi',
    TIMESTAMPS_STATUS_HISTORY: 'Statü Geçmişi',
    TIMESTAMPS_EMPTY_EVENTS: 'Zaman damgalı etkinlik bulunamadı.',
    TIMESTAMPS_EVENTS: 'Olaylar',
    TIMESTAMPS_WORK_ORDERS: 'İş Emirleri',
    TIMESTAMPS_WORK_ORDER_CREATED: 'Oluşturulma Tarihi',
    TIMESTAMPS_ADDITIONAL_WORK_ORDER_CREATED: 'Ek İş Emri Oluşturulma Tarihi',
    TIMESTAMPS_REPEAT_WORK_ORDER_CREATED: 'Tekrar İş Emri Oluşturulma Tarihi',
    TIMESTAMPS_ADDITIONAL_APPROVED: 'Ek İş Onay Tarihi',
    TIMESTAMPS_EXPECTED_DELIVERY: 'Teslim Randevusu',
    TIMESTAMPS_WORK_ORDER_DELIVERED: 'Teslim Tarihi',
    TIMESTAMPS_REPEAT_WORK_ORDER_DELIVERED: 'Tekrar İş Emri Teslim Tarihi',
    EXPECTED_DELIVERY_STATUS: 'Teslim randevusu',
    EXPECTED_DELIVERY_DAYS_LEFT: '{{count}} gün kaldı',
    EXPECTED_DELIVERY_DAYS_AGO: '{{count}} gün önce',
    EXPECTED_DELIVERY_TODAY: 'Bugün',
    VEHICLE_CUSTOMER_INFO: 'Araç, Müşteri ve Ruhsat Sahibi',
    REGISTERED_OWNER_SAME_AS_CUSTOMER: 'Müşteri ile aynı',
    LABEL_BRAND_MODEL: 'Marka / Model',
    LABEL_MODEL_YEAR: 'Model Yılı',
    LABEL_MILEAGE: 'Kilometre',
    REGISTRATION_SIGNATURE_TITLE: 'Kayıt İmzası',
    REGISTRATION_SIGNATURE_META: '{{date}} tarihinde {{user}} tarafından alındı',
    VIEW_SIGNATURE: 'İmzayı görüntüle',
    LABEL_PLATE: 'Plaka',
    LABEL_CUSTOMER_TYPE: 'Müşteri Tipi',
    LABEL_CUSTOMER: 'Müşteri',
    LABEL_PHONE: 'Telefon',
    ACCIDENT_PARTY_NAME: 'Ad soyad',
    STATUS_HISTORY: 'Statü Geçmişi',
    SHOW_MORE: 'Daha fazla göster',
    SHOW_LESS: 'Daha az göster',
    DELIVERY_READINESS: 'Teslim Hazırlık Kontrolü',
    READINESS_READY: 'Hazır',
    READINESS_PENDING: 'Bekliyor',
    READINESS_EMPTY: 'Veri yok',
    READINESS_DOCS: 'Belgeler kontrol edildi',
    READINESS_DOCS_DETAIL: '{{done}}/{{total}} belge yüklü · {{missing}} zorunlu belge eksik',
    READINESS_NO_DOCUMENTS: 'Henüz belge kaydı bulunmuyor',
    READINESS_PHOTOS: 'Yüklenen belge grupları tamamlandı',
    READINESS_DOCUMENTS: 'Tüm belgeler yüklendi',
    READINESS_DOCUMENTS_DETAIL: '{{done}}/{{total}} zorunlu belge grubu tamam',
    READINESS_WORK_ORDERS: 'İş emri kalemleri tamamlandı',
    READINESS_WORK_ORDERS_DETAIL: '{{done}}/{{total}} iş kalemi kapatıldı',
    READINESS_NO_WORK_ORDERS: 'Henüz iş emri kalemi bulunmuyor',
    READINESS_DIGITAL_SIGNATURE: 'Dijital imza kaydedildi',
    READINESS_DIGITAL_SIGNATURE_DETAIL: '{{date}} tarihinde imzalandı',
    READINESS_DIGITAL_SIGNATURE_PENDING: 'Dijital imza zorunludur',
    READINESS_PARTS: 'Yedek parça süreci kapandı',
    READINESS_PARTS_DETAIL: '{{total}} parçadan {{open}} tanesi beklemede',
    READINESS_NO_PARTS: 'Henüz yedek parça kaydı bulunmuyor',
    READINESS_DELIVERY_FORM: 'Teslim formu hazır',
    READINESS_DELIVERY_FORM_DETAIL: 'Teslim formu durumu: {{status}}',
    READINESS_NO_DELIVERY_FORM: 'Teslim formu kaydı henüz oluşturulmadı',
    QUICK_ACCESS: 'Hızlı Erişim',
    PHOTOS: 'Fotoğraflar',
    PHOTO_COUNT: '{{count}} fotoğraf',
    DOCUMENTS_MISSING: 'Eksik belgeler: {{groups}}',
    DOCUMENT_SET_COMPLETE: 'Belge seti tam',
    DOCUMENTS: 'Belgeler',
    DOCUMENT_COUNT: '{{count}} belge',
    FILE_CHAT: 'Dosya Chat',
    MESSAGE_COUNT: '{{count}} mesaj',
    CHAT_LOADING: 'Mesajlar yükleniyor...',
    CHAT_EMPTY: 'Henüz mesaj yok.',
    CHAT_LOAD_ERROR: 'Mesajlar yüklenemedi.',
    CHAT_SEND_ERROR: 'Mesaj gönderilemedi.',
    CHAT_PARTICIPANT: 'Katılımcı',
    WORK_ORDER_TODO: 'İş emri',
    WORK_ORDER: 'İş emri',
    ANALYST_NOTES: 'Analiz notları',
    REPEAT_WORK_ORDER_NOTES: 'İş Tekrarı Notları',
    ADD_ANALYST_NOTES: 'Not ekle',
    EDIT_ANALYST_NOTES: 'Notu düzenle',
    ANALYST_NOTES_PLACEHOLDER: 'Analist notu ekleyin',
    ANALYST_NOTES_SAVE: 'Kaydet',
    ANALYST_NOTES_SAVING: 'Kaydediliyor...',
    ANALYST_NOTES_SAVE_ERROR: 'Analist notları kaydedilemedi. Lütfen tekrar deneyin.',
    WORK_PROCESS: 'Süreç',
    RESPONSIBILITY: 'Sorumluluk',
    WORKSHOP: 'Atölye',
    NEXT_STEP: 'Sonraki adım:',
    SPARE_PARTS: 'Yedek parçalar',
    PARTS_READY_COUNT: '{{total}} parçadan {{ready}} tanesi hazır',
    PART_STATUS_0: 'Yok',
    PART_STATUS_1: 'Var',
    PART_STATUS_2: 'Sipariş edildi',
    ADD_SPARE_PART: 'Yedek parça ekle',
    DELETE_SPARE_PART: 'Yedek parçayı sil',
    DELETE_SPARE_PART_CONFIRM_TITLE: 'Yedek parça silinsin mi?',
    DELETE_SPARE_PART_CONFIRM_MESSAGE: '{{part}}, {{workOrder}} iş emrinden silinsin mi? Bu işlem geri alınamaz.',
    DELETE_SPARE_PART_ERROR: 'Yedek parça silinemedi. Lütfen tekrar deneyin.',
    SAVE_PART_CHANGES: 'Değişiklikleri kaydet',
    WORK_PHOTOS: 'İş fotoğrafları',
    REMOVE_PHOTO: 'Fotoğrafı kaldır',
    NO_WORK_ORDERS: 'Henüz iş emri oluşturulmadı.',
    WORKFLOW_PARTS: 'Yedek Parçalar',
    WORKFLOW_WORK_STARTED: 'İşlem Başladı',
    WORKFLOW_WORK_COMPLETED: 'İşlem Tamamlandı',
    WORKFLOW_WORK_APPROVED: 'İşlem Onaylandı',
    WORKFLOW_COMPLETE: 'İş tamamlandı.',
    NEXT_REVIEW_PARTS: 'Gerekli yedek parçaları inceleyin.',
    NEXT_AWAIT_PARTS: 'Sipariş edilen parçaların gelmesini bekleyin.',
    NEXT_ASSIGN_TECHNICIAN: 'Uygun bir teknisyen atayın.',
    NEXT_START_WORK: 'Atanan işi başlatın.',
    NEXT_COMPLETE_WORK: 'İşi tamamlayıp sonrası fotoğraflarını ekleyin.',
    NEXT_REVIEW_WORK: 'Teknisyenin tamamladığı işi inceleyin.',
    PART_NAME: 'Parça adı',
    PART_QUANTITY: 'Adet',
    PART_UNIT_COST: 'Birim maliyet',
    PART_SALE_PRICE: 'Satış fiyatı',
    PART_NAME_REQUIRED: 'Parça adı girin.',
    PART_QUANTITY_INVALID: 'Adet en az 1 olan bir tam sayı olmalıdır.',
    ADD: 'Parçayı Ekle',
    DOCUMENT_MANAGEMENT: 'Belge Yönetimi',
    MANDATORY_DOCUMENTS_TITLE: 'Zorunlu Belgeler',
    MANDATORY_DOCUMENTS_COMPLETION: 'belge grubu tamamlandı',
    UPDATE_MANDATORY_DOCUMENTS: 'Zorunlu Belgeleri Güncelle',
    EDIT_DELIVERY_REQUIREMENTS: 'Teslim gereksinimlerini düzenle',
    DELIVERY_REQUIREMENTS_TITLE: 'Nihai teslim için zorunlu',
    REQUIREMENT_MODAL_CANCEL: 'Vazgeç',
    REQUIREMENT_MODAL_SAVE: 'Kaydet',
    DELIVERY_DOCUMENT_14: 'Alkol raporu',
    DELIVERY_DOCUMENT_19: 'İmza sirküleri',
    DELIVERY_DOCUMENT_25: 'Fatura',
    DELIVERY_DOCUMENT_38: 'Sürücü kimlik fotokopisi',
    DELIVERY_DOCUMENT_39: 'Araç sahibi kimlik fotokopisi',
    DELIVERY_DOCUMENT_40: 'Meslek kimliği fotokopisi',
    DELIVERY_DOCUMENT_41: 'Engelli / vasi belgesi',
    DELIVERY_DOCUMENT_42: 'Görgü ve ifade belgesi',
    DELIVERY_DOCUMENT_43: 'MASAK belgesi',
    DELIVERY_DOCUMENT_44: 'Taahhüt belgesi',
    DELIVERY_DOCUMENT_45: 'İbra belgesi',
    DELIVERY_DOCUMENT_46: 'KDV ödemesi / yansıtma faturası',
    DELIVERY_DOCUMENT_47: 'Diğer belgeler',
    ASSOCIATED_DOCUMENTS_TITLE: 'Ek Belgeler',
    UPDATE_ADDITIONAL_DOCUMENTS: 'Ek Belgeleri Güncelle',
    ASSOCIATED_DOCUMENTS_EMPTY: 'Henüz dosya eklenmedi.',
    DAMAGE_ANALYSIS_PHOTOS_TITLE: 'Hasar Analizi Fotoğrafları',
    WORK_ORDER_PHOTOS_TITLE: 'İş Emri Fotoğrafları',
    DELIVERY_PHOTOS_TITLE: 'Teslim Fotoğrafları',
    DOCUMENT_ASSIGNMENT_EDIT: 'Belgeleri düzenle',
    DOCUMENT_ASSIGNMENT_EXIT_EDIT: 'Düzenlemeyi kapat',
    DOCUMENT_ASSIGNMENT_SEARCH_TITLE: 'Medya dosyası ara / seç',
    DOCUMENT_ASSIGNMENT_SEARCH_HINT: 'Gelen WhatsApp veya manuel yüklenen medya dosyalarını bulun, ardından dosya belge gruplarına atayın.',
    DOCUMENT_ASSIGNMENT_SEARCH_LABEL: 'Telefon / yükleyen arama',
    DOCUMENT_ASSIGNMENT_SEARCH_PLACEHOLDER: 'En az 3 telefon rakamı yazın',
    DOCUMENT_ASSIGNMENT_REFRESH: 'Yenile',
    DOCUMENT_ASSIGNMENT_UPLOAD: 'Medya yükle',
    DOCUMENT_ASSIGNMENT_LOADING: 'Belgeler yükleniyor',
    DOCUMENT_ASSIGNMENT_LOAD_ERROR: 'Belgeler yüklenemedi. Lütfen tekrar deneyin.',
    DOCUMENT_ASSIGNMENT_EMPTY: 'Henüz gelen belge yok',
    DOCUMENT_ASSIGNMENT_EMPTY_HINT: 'WhatsApp veya manuel yükleme belgeleri burada listelenecek.',
    DOCUMENT_ASSIGNMENT_COUNT_SUFFIX: 'belge',
    DOCUMENT_ASSIGNMENT_MANUAL_UPLOADS: 'Manuel Yüklemeler',
    DOCUMENT_ASSIGNMENT_SELECTED: 'Seçildi',
    DOCUMENT_ASSIGNMENT_ASSIGNED: 'Atandı',
    DOCUMENT_ASSIGNMENT_SLOT_TITLE: 'Belgeleri ata',
    DOCUMENT_ASSIGNMENT_SLOT_HINT: 'Arama alanından bir belge seçin, ardından aşağıdan veya karşı taraf ekranından belge grubuna atayın.',
    DOCUMENT_DROP_UPLOADING: 'Yükleniyor ve atanıyor...',
    DOCUMENT_DROP_UPLOAD_ERROR: 'Dosyalar yüklenemedi. Lütfen tekrar deneyin.',
    DOCUMENT_BROWSER_DROP_UPLOADING: 'Dosyalar yükleniyor...',
    DOCUMENT_ASSIGNMENT_EMPTY_SLOT: 'Boş',
    DOCUMENT_ASSIGNMENT_DROP_HERE: 'Bir belge seçip buraya atayın',
    DOCUMENT_ASSIGNMENT_SELECT_FIRST: 'Önce bir fotoğraf seçin',
    DOCUMENT_ASSIGNMENT_ASSIGN_SELECTED: 'Seçileni ata',
    DOCUMENT_ASSIGNMENT_REMOVE: 'Atanan belgeyi kaldır',
    DOCUMENT_ASSIGNMENT_SAVE: 'Değişiklikleri kaydet',
    DOCUMENT_ASSIGNMENT_SAVING: 'Kaydediliyor...',
    DOCUMENT_ASSIGNMENT_SAVE_SUCCESS: 'Belge atamaları kaydedildi.',
    DOCUMENT_ASSIGNMENT_SAVE_ERROR: 'Belge atamaları kaydedilemedi.',
    ADDITIONAL_DOCUMENTS_TITLE: 'Ek Belgeler',
    ADDITIONAL_DOCUMENTS_HINT: 'Bu dosya için yüklenen destekleyici belgeler.',
    ADDITIONAL_DOCUMENTS_EMPTY: 'Henüz ek belge yüklenmedi.',
    ADDITIONAL_DOCUMENT_EDIT: 'Ek belgeleri düzenle',
    ADDITIONAL_DOCUMENT_EXIT_EDIT: 'Ek belge düzenlemeyi kapat',
    ADDITIONAL_DOCUMENT_EXISTING_TITLE: 'Mevcut belgeler',
    ADDITIONAL_DOCUMENT_ADD_TITLE: 'Belge ekle',
    ADDITIONAL_DOCUMENT_TYPE_LABEL: 'Belge türü',
    ADDITIONAL_DOCUMENT_TYPE_PLACEHOLDER: 'Belge türü seçin',
    ADDITIONAL_DOCUMENT_TYPE_NO_RESULTS: 'Eşleşen belge türü bulunamadı',
    ADDITIONAL_DOCUMENT_DROP_TITLE: 'Dosyaları buraya sürükleyin veya seçmek için tıklayın',
    ADDITIONAL_DOCUMENT_DROP_HINT: 'Görsel, video (MP4, MOV, WebM), PDF, DOC, DOCX veya TXT',
    ADDITIONAL_DOCUMENT_PENDING_TITLE: 'Bekleyen yüklemeler',
    ADDITIONAL_DOCUMENT_PENDING_DELETION: 'Silinmeyi bekliyor',
    ADDITIONAL_DOCUMENT_DELETE: 'Belgeyi sil',
    ADDITIONAL_DOCUMENT_UNDO_DELETE: 'Silmeyi geri al',
    ADDITIONAL_DOCUMENT_REMOVE_PENDING: 'Bekleyen yüklemeyi kaldır',
    ADDITIONAL_DOCUMENT_SAVE: 'Değişiklikleri kaydet',
    ADDITIONAL_DOCUMENT_SAVING: 'Kaydediliyor...',
    ADDITIONAL_DOCUMENT_ACCIDENT_REPORT: 'Kaza Zaptı',
    ADDITIONAL_DOCUMENT_STATEMENT_REPORT: 'İfade Tutanağı',
    ADDITIONAL_DOCUMENT_WITNESS_ASSESSMENT_REPORT: 'Görgü Tespit Tutanağı',
    ADDITIONAL_DOCUMENT_ALCOHOL_REPORT: 'Alkol Raporu',
    ADDITIONAL_DOCUMENT_METEOROLOGY_REPORT: 'Meteoroloji Raporu',
    ADDITIONAL_DOCUMENT_IDENTITY_DOCUMENT: 'Kimlik',
    ADDITIONAL_DOCUMENT_TAX_CERTIFICATE: 'Vergi Levhası',
    ADDITIONAL_DOCUMENT_SIGNATURE_CIRCULAR: 'İmza Sirküleri',
    ADDITIONAL_DOCUMENT_ENDORSEMENT: 'Zeyilname',
    ADDITIONAL_DOCUMENT_TRADE_REGISTRY_GAZETTE: 'Ticaret Sicil Gazetesi',
    ADDITIONAL_DOCUMENT_RETURNED_PART_DELIVERY_FORM: 'İade Parça Teslim Formu',
    ADDITIONAL_DOCUMENT_AUTO_KING_ASSESSMENT_FORM: 'Auto King Tampon Tamir ve Hasar Tespit Formu',
    ADDITIONAL_DOCUMENT_CHASSIS_NUMBER_PHOTO: 'Şasi Fotoğrafı',
    ADDITIONAL_DOCUMENT_INVOICE: 'Fatura',
    ADDITIONAL_DOCUMENT_TOWING_INVOICE: 'Çekici Faturası',
    ADDITIONAL_DOCUMENT_HOMER_WARRANTY_CERTIFICATE: 'Homer Garanti Belgesi',
    ADDITIONAL_DOCUMENT_PART_OFFER_FORM: 'Parça Teklif Formu',
    ADDITIONAL_DOCUMENT_HLD_INVOICE: 'HLD Faturası',
    ADDITIONAL_DOCUMENT_HOMER_REFLECTION_INVOICE: 'Homer Yansıtma Faturası',
    ADDITIONAL_DOCUMENT_SERVICE_INVOICE: 'Servis Faturası',
    ADDITIONAL_DOCUMENT_SERVICE_CUSTOMER_INVOICE: 'Servis Müşteri Faturası',
    ADDITIONAL_DOCUMENT_ACTUAL_SERVICE_INVOICE: 'Gerçek Servis Faturası',
    CASE_DOCUMENT_SUMMARY_TITLE: 'Atanmış dosya belgeleri',
    CASE_DOCUMENT_SUMMARY_TEXT: 'Dosya açılışında yüklenen belgeler aşağıda belge türüne göre gruplanır.',
    CASE_DOCUMENT_PREVIEW_HINT: 'Tam önizlemeyi açmak için herhangi bir belgeye tıklayın.',
    VEHICLE_ANALYSIS_PHOTO_GATE_TITLE: 'Araç analizine başlamak için fotoğraf yüklemeniz gerekiyor',
    VEHICLE_ANALYSIS_PHOTO_GATE_HINT: 'En az 2 fotoğraf',
    VEHICLE_ANALYSIS_PHOTO_GATE_DROP: 'Fotoğrafları buraya sürükleyin veya tıklayın',
    VEHICLE_ANALYSIS_PHOTO_GATE_SELECT: 'Fotoğraf seç',
    VEHICLE_ANALYSIS_PHOTO_GATE_IMAGE_ONLY: 'Yalnızca görsel dosyaları yüklenebilir.',
    VEHICLE_ANALYSIS_PHOTO_GATE_COUNT: '{{count}} fotoğraf eklendi',
    VEHICLE_ANALYSIS_PHOTO_GATE_CONTINUE: 'Yükle ve devam et',
    VEHICLE_ANALYSIS_PHOTO_GATE_UPLOAD_ERROR: 'Araç analizi fotoğrafları yüklenemedi.',
    VEHICLE_ANALYSIS_PHOTO_GATE_REQUIRED: 'Devam etmeden önce en az bir araç analizi fotoğrafı yükleyin.',
    CASE_DOCUMENT_GROUP_DAMAGED_CAR: 'Araç Fotoğrafı',
    CASE_DOCUMENT_GROUP_DRIVING_LICENSE: 'Ehliyet',
    CASE_DOCUMENT_GROUP_REGISTRATION: 'Ruhsat',
    CASE_DOCUMENT_GROUP_POLICY: 'Trafik Sigortası Poliçesi',
    CASE_DOCUMENT_GROUP_KM_FUEL_GAUGE: 'KM / Yakıt Göstergesi',
    CASE_DOCUMENT_GROUP_KASKO_POLICY: 'Kasko Poliçesi',
    CASE_DOCUMENT_GROUP_DECLARATION: 'Beyan Tutanağı',
    CASE_DOCUMENT_GROUP_MUTUAL_ACCIDENT_REPORT: 'Anlaşmalı Tutanak',
    CASE_DOCUMENT_GROUP_PRELIMINARY_EXPERTISE_FORM: 'Ön Ekspertiz Formu',
    CASE_DOCUMENT_GROUP_SCENE_PHOTOS: 'Olay Yeri Fotoğrafları',
    CASE_DOCUMENT_GROUP_REPORT: 'Tutanak',
    CASE_PHOTO_GROUP_DELIVERY_FINAL: 'Teslim Öncesi Son Fotoğraflar',
    CASE_DOCUMENT_EMPTY_DAMAGED_CAR: 'Bu dosya için henüz araç fotoğrafı yüklenmedi.',
    CASE_DOCUMENT_EMPTY_DRIVING_LICENSE: 'Bu dosya için henüz ehliyet belgesi yüklenmedi.',
    CASE_DOCUMENT_EMPTY_REGISTRATION: 'Bu dosya için henüz ruhsat belgesi yüklenmedi.',
    CASE_DOCUMENT_EMPTY_POLICY: 'Bu dosya için henüz trafik sigortası poliçesi yüklenmedi.',
    CASE_DOCUMENT_EMPTY_KM_FUEL_GAUGE: 'Bu dosya için henüz KM / yakıt göstergesi belgesi yüklenmedi.',
    CASE_DOCUMENT_EMPTY_KASKO_POLICY: 'Bu dosya için henüz kasko poliçesi yüklenmedi.',
    CASE_DOCUMENT_EMPTY_DECLARATION: 'Bu dosya için henüz beyan tutanağı yüklenmedi.',
    CASE_DOCUMENT_EMPTY_MUTUAL_ACCIDENT_REPORT: 'Bu dosya için henüz anlaşmalı tutanak yüklenmedi.',
    CASE_DOCUMENT_EMPTY_PRELIMINARY_EXPERTISE_FORM: 'Bu dosya için henüz ön ekspertiz formu yüklenmedi.',
    CASE_DOCUMENT_EMPTY_SCENE_PHOTOS: 'Bu dosya için henüz olay yeri fotoğrafı yüklenmedi.',
    CASE_DOCUMENT_EMPTY_REPORT: 'Bu dosya için henüz tutanak yüklenmedi.',
    CASE_PHOTO_EMPTY_DELIVERY_FINAL: 'Bu dosya için henüz teslim öncesi son fotoğraflar yüklenmedi.',
    DOCUMENT_MISSING: 'Belge Eksik',
    NO_DOCUMENTS_UPLOADED: 'Bu grupta belge yok',
    DOCUMENT_SOURCE_GROUP_READY: 'Belgeler mevcut',
    UPLOADED: 'Yüklendi',
    UPLOAD: 'Yükle',
    PHOTO_REQUIRED_NOTE: 'Zorunlu fotoğraflar (işlem öncesi, sonrası, teslim) tamamlanmadan dosya teslime hazır hale getirilemez.',
    DOCUMENT_PREVIEW_HINT: 'Belge önizlemesi tarayıcıda görüntülenemez. Görüntülemek için indirme düğmesine tıklayın.',
    DOCUMENT_MOBILE_PREVIEW_HINT: 'Belge önizlemesi mobil tarayıcıda görüntülenemez.',
    DOCUMENT_BROWSER_PREVIEW_HINT: 'Bu belge tarayıcıda önizlenebilir veya indirilebilir.',
    DOCUMENT_PREVIEW: 'Önizle',
    DOCUMENT_PREVIEW_PREVIOUS: 'Önceki belgeyi göster',
    DOCUMENT_PREVIEW_NEXT: 'Sonraki belgeyi göster',
    DOCUMENT_PRINT: 'Yazdır',
    DOCUMENT_DOWNLOAD: 'İndir',
    MISSING_REQUIRED_DOCS: 'Eksik zorunlu belgeler',
    MISSING_DOCS_NOTE: '{{count}} belge yüklenmeden dosya kapatılamaz.',
    DOC_MANAGEMENT: 'Belge Yönetimi',
    REQUIRED: 'Zorunlu',
    OPTIONAL: 'Opsiyonel',
    PARTS_PENDING: 'Parça bekleniyor',
    PARTS_COMPLETED: 'Parçalar tamamlandı',
    TOTAL_PARTS_COST: 'Toplam parça maliyeti',
    PART_NAME_PLACEHOLDER: 'Parça adı',
    PART_COUNT_INPUT: 'Parça Sayısı',
    REQUESTED_FOR_WORK: 'Bağlı iş: {{work}}',
    GO_TO_WORK_ORDER: 'İş emrine git',
    WORK_ORDER_REQUESTS_AVAILABLE_AFTER_ANALYSIS: 'Ek iş ve parça talepleri hasar analizi tamamlandıktan sonra açılabilir.',
    INTERNAL_CHAT: 'Dosya İçi Chat',
    CHAT_SEND: 'Mesaj gönder',
    CHAT_PLACEHOLDER: 'Ekip içi mesaj yaz...',
    PRE_DELIVERY_CHECK: 'Teslim Öncesi Eksik Kontrolü',
    PRINTABLE_DOCUMENTS: 'Çıktı Alınabilecek Belgeler',
    PRINT_WORK_ORDER: 'Yazdır',
    WORK_ORDER_PRINT_TITLE: 'İş Emri',
    PRINT_ALL_WORK_ORDERS: 'Tüm İş Emirlerini Yazdır',
    WORK_ORDER_LIST_PRINT_TITLE: 'Tüm İş Emirleri',
    DIGITAL_SIGNATURE: 'Dijital İmza',
    SIGNATURE_TABLET_HINT: 'Tablet üzerinden müşteri imzası alın:',
    SIGNATURE_LOCKED_HINT: 'İmza kayıtlı. Yeni imza almak için Temizle butonuna basın.',
    SIGNATURE_META: 'İmza tarih/saat ve kullanıcı ile bağlanır',
    SAVE_SIGNATURE: 'İmzayı Kaydet',
    SAVING_SIGNATURE: 'Kaydediliyor...',
    SIGNATURE_SAVED: 'İmza kaydedildi',
    SIGNATURE_EMPTY: 'Lütfen imza alanına imza atın',
    SIGNATURE_CLEAR_BEFORE_SAVE: 'Yeni imza kaydetmek için önce mevcut imzayı temizleyin',
    SIGNATURE_SAVE_ERROR: 'İmza kaydedilemedi. Lütfen tekrar deneyin.',
    SIGNATURE_META_SAVED: '{{date}} tarihinde {{user}} tarafından kaydedildi',
    SIGNATURE_EXPAND: 'İmzayı büyüt',
    SIGNATURE_COLLAPSE: 'Tam ekrandan çık',
    CLEAR: 'Temizle',
    DELIVERY_SATISFACTION: 'Teslim & Memnuniyet',
    DELIVERY_COST_SUMMARY: 'Teslim Maliyet Özeti',
    DELIVERY_TOTAL_WORKS: 'Tamamlanan iş kalemi',
    DELIVERY_TOTAL_PARTS: 'Kullanılan parça',
    DELIVERY_LABOR_TOTAL: 'İşçilik toplamı',
    DELIVERY_GRAND_TOTAL: 'Genel toplam',
    ACCOUNTING_WORKLIST_READY: 'Muhasebe incelemesi aktif',
    ACCOUNTING_WORKLIST_READY_HINT: 'Bu dosya artık muhasebe ve hasar analizi iş listesine son tutar özetiyle birlikte düştü.',
    PAYMENT_RECEIVED: 'Ödeme alındı',
    FINAL_DELIVERY_PHOTOS: 'Teslim öncesi son fotoğraflar',
    FINAL_DELIVERY_PHOTOS_HINT: '{{count}} adet son fotoğraf yüklü. Teslimden önce aracın güncel son fotoğraflarını ekleyin.',
    FINAL_DELIVERY_READY_HINT: 'Teslimden önce aracın güncel fotoğraflarını seçip yükleyin.',
    COMPLETE_DELIVERY: 'Teslimi Tamamla',
    DELIVERY_APPOINTMENT_WAITING: 'Randevuya {{hours}} saat {{minutes}} dakika kaldı',
    COMPLETE_DELIVERY_APPOINTMENT_MINUTES: 'Teslimi Tamamla (Randevuya {{count}} dakika)',
    COMPLETE_DELIVERY_APPOINTMENT_OVERDUE: 'Teslimi Tamamla (Randevu saati geçti)',
    UPDATE_DELIVERY_TIME: 'Teslim Zamanını Güncelle',
    COMPLETE_DELIVERY_ERROR: 'Teslim işlemi tamamlanamadı. Lütfen tekrar deneyin.',
    OPTIONAL_LABEL: 'Opsiyonel',
    MANDATORY: 'Zorunlu',
    DEPENDS_ON_JOB_TYPE: 'İş tipine bağlı',
    REG_TYPE_MECHANICAL: 'Mekanik',
    REG_TYPE_DAMAGE: 'Hasar',
    OWNER_INDIVIDUAL: 'Şahıs',
    OWNER_CORPORATE: 'Kurum',
    WORKSHOP_MECHANICAL: 'Mekanik',
    WORKSHOP_BODY: 'Kaporta',
    WORKSHOP_PAINT: 'Boya',
    WORKSHOP_DETAIL_WASH: 'Detay / Yıkama',
    WORKSHOP_ELECTRIC: 'Elektrik',
    OUTPUT_DOC_VEHICLE_RECEIVING_FORM: 'Araç Kabul Formu',
    OUTPUT_DOC_ACCIDENT_EXPERTISE_REPORT: 'Kaza Ekspertiz Raporu',
    OUTPUT_DOC_FREE_WORK_ORDER_FORM: 'İş Emri Raporu',
    OUTPUT_DOC_FINAL_CHECK_FORM: 'Son Kontrol Formu',
    OUTPUT_DOC_VEHICLE_DELIVERY_FORM: 'Araç Teslim Formu',
    OUTPUT_DOC_INVOICE_SUMMARY: 'Fatura Özeti',
    STATUS_STEP_REGISTERED: 'Araç kaydı yapıldı',
    STATUS_STEP_QUEUE: 'Serviste sıra bekliyor',
    STATUS_STEP_IN_SERVICE: 'Serviste',
    STATUS_STEP_READY: 'Teslime hazır',
    STATUS_STEP_DELIVERED: 'Teslim edildi',
    STATUS_HISTORY_TAG_REGISTRATION: 'Kayıt',
    STATUS_HISTORY_TAG_QUEUE: 'Sıra',
    STATUS_HISTORY_TAG_ASSIGNMENT: 'Atama',
    STATUS_HISTORY_TAG_SERVICE: 'Servis',
    STATUS_HISTORY_TAG_APPROVAL: 'Onay',
    STATUS_HISTORY_TAG_DELIVERY: 'Teslim',
    STATUS_HISTORY_TAG_UPDATE: 'Güncelleme',
    STATUS_HISTORY_QUEUE_TITLE: 'Hasar analizi onaylandı',
    STATUS_HISTORY_WORK_STARTED_TITLE: 'Araç üzerinde işlem başlatıldı',
    STATUS_HISTORY_REGISTERED_DETAIL: 'Dosya açıldı, araç, müşteri ve kabul bilgileri sisteme işlendi.',
    STATUS_HISTORY_DAMAGE_ANALYSIS_COMPLETED: '{{work}} için hasar analizi onaylandı; iş emri parça hazırlığı ve teknisyen atamasını bekliyor.',
    STATUS_HISTORY_WORKSHOP_ASSIGNED: '{{work}} işi için {{workshop}} atölye hazırlığı Atölye Yöneticisi tarafından onaylandı.',
    STATUS_HISTORY_TECHNICIAN_ASSIGNED: '{{work}} işi {{name}} adlı teknisyene atandı.',
    STATUS_HISTORY_WORK_STARTED: '{{work}} için araç üzerinde işlem başlatıldı.',
    STATUS_HISTORY_WORK_COMPLETED: '{{work}} işlemi tamamlandı ve onay adımına gönderildi.',
    STATUS_HISTORY_WORKSHOP_MANAGER_APPROVED: '{{work}} Atölye Yöneticisi tarafından onaylandı ve sonraki planlama adımına geçti.',
    STATUS_HISTORY_SERVICE_FINAL_REVIEW_SENT: 'Dosya kontrol için servis şefine gönderildi.',
    STATUS_HISTORY_WORK_ORDER_READY: 'Tüm onaylar tamamlandı. Dosya teslim hazırlık aşamasına geçti.',
    STATUS_HISTORY_DELIVERED_DETAIL: 'Araç teslim edildi ve dosya tamamlandı.',
    STATUS_HISTORY_GENERIC_UPDATE: '{{work}} için yeni bir güncelleme kaydedildi.',
    STATUS_HISTORY_ACTOR: 'İşlemi yapan: {{actor}}',
    STATUS_HISTORY_FALLBACK_WORK: '{{workshop}} iş kalemi',
    STATUS_HISTORY_GENERIC_WORK: 'ilgili iş kalemi',
    STATUS_HISTORY_UNKNOWN_WORKSHOP: 'ilgili',
    DAMAGE_MAP_TITLE: 'Araç Analizi',
    PART_CATALOG_TITLE: 'Parça Kataloğu',
    PART_CATALOG_SEARCH: 'Parça ara',
    PART_CATALOG_LOADING: 'Parçalar yükleniyor...',
    CATALOG_MINIMUM_QUERY: 'Aramak için en az iki karakter girin.',
    CATALOG_SEARCH_ERROR: 'Parçalar yüklenemedi. Lütfen tekrar deneyin.',
    DAMAGE_COUNT: '{{count}} Hasar',
    OPERATION_COUNT: '{{count}} İşlem',
    SELECTED_REGION: 'Seçili',
    SELECTED_REGIONS_COUNT: '{{count}} bölge seçildi',
    REMOVE_REGION: '{{region}} bölgesini kaldır',
    DAMAGE_REGION_REQUIRED: 'En az bir hasarlı bölge seçin.',
    HOVERED_REGION: 'İmleç',
    CLICK_REGION: 'Bölgeye tıklayın',
    CAR_DIRECTION_HINT: 'ÖN ↑ · ARKA ↓',
    LEGEND_HEALTHY: 'Sağlam',
    LEGEND_DAMAGED: 'Hasarlı',
    LEGEND_SELECTED: 'Seçili',
    LEGEND_GENERAL: 'Genel',
    GENERAL_COUNT: '{{count}} Genel',
    DAMAGE_DETECTION: 'İş Emri Girişi',
    EDIT_DAMAGE: 'İş Emrini Düzenle',
    CANCEL: 'Vazgeç',
    CREATE_WORK_ORDER: 'İş Emri Oluştur',
    CREATE_WORK_ORDER_HINT: 'Katalog veya özel parça eklemek için iş emri oluşturun.',
    ADDITIONAL_WORK_ORDER: 'Ek İş Emri',
    ADDITIONAL_WORK_ORDERS: 'Ek İş Emirleri',
    ADDITIONAL_WORK_ORDER_ADD_TO_LIST: 'Ek İş Emirlerine Ekle',
    ADDITIONAL_WORK_ORDERS_EMPTY: 'Henüz ek iş emri eklenmedi.',
    ADDITIONAL_WORK_ORDERS_CREATE: 'Ek İş Emirlerini Oluştur',
    ADDITIONAL_WORK_ORDER_CREATE: 'Ek İş Emri Oluştur',
    ADDITIONAL_WORK_ORDER_BADGE: 'Ek İş',
    EDIT_ADDITIONAL_WORK_ORDER: 'Ek İş Emrini Düzenle',
    UPDATE_ADDITIONAL_WORK_ORDER: 'Ek İş Emrini Güncelle',
    ADDITIONAL_WORK_ORDER_APPROVE: 'Onayla',
    ADDITIONAL_WORK_ORDER_CANCEL: 'İptal',
    WORK_ORDER_NAME: 'İş Emri Adı',
    WORK_ORDER_NAME_PLACEHOLDER: 'örn. Ezik onarımı, detaylı yıkama',
    MECHANICAL_WORK_ORDER_NAME_PLACEHOLDER: 'örn. Yağ bakımı, fren kontrolü',
    CAR_REGION_ON_TAMPON: 'Ön tampon',
    CAR_REGION_SOL_FAR: 'Sol far',
    CAR_REGION_SAG_FAR: 'Sağ far',
    CAR_REGION_KAPUT: 'Kaput',
    CAR_REGION_SOL_ON_CAMURLUK: 'Sol ön çamurluk',
    CAR_REGION_SAG_ON_CAMURLUK: 'Sağ ön çamurluk',
    CAR_REGION_ON_CAM: 'Ön cam',
    CAR_REGION_TAVAN: 'Tavan',
    CAR_REGION_SOL_ON_KAPI: 'Sol ön kapı',
    CAR_REGION_SAG_ON_KAPI: 'Sağ ön kapı',
    CAR_REGION_SOL_ARKA_KAPI: 'Sol arka kapı',
    CAR_REGION_SAG_ARKA_KAPI: 'Sağ arka kapı',
    CAR_REGION_ARKA_CAM: 'Arka cam',
    CAR_REGION_BAGAJ: 'Bagaj kapağı',
    CAR_REGION_SOL_ARKA_CAMURLUK: 'Sol arka çamurluk',
    CAR_REGION_SAG_ARKA_CAMURLUK: 'Sağ arka çamurluk',
    CAR_REGION_ARKA_TAMPON: 'Arka tampon',
    CAR_REGION_SOL_STOP: 'Sol stop',
    CAR_REGION_SAG_STOP: 'Sağ stop',
    CAR_REGION_SOL_AYNA: 'Sol yan ayna',
    CAR_REGION_SAG_AYNA: 'Sağ yan ayna',
    DAMAGE_TYPE: 'Hasar / İşlem Tipi',
    DAMAGE_TYPE_PLACEHOLDER: 'örn. Ezik, çizik, detaylı yıkama',
    DAMAGE_NAME: 'Hasar Başlığı',
    DAMAGE_NAME_PLACEHOLDER: 'örn. Ezik, çizik, cam kırığı',
    OPERATION_NAME: 'İşlem Adı',
    OPERATION_NAME_PLACEHOLDER: 'örn. Detaylı yıkama, elektrik kontrolü',
    RELATED_WORKSHOP: 'Atölye Seç',
    DAMAGE_LEVEL: 'Hasar Seviyesi',
    DAMAGE_LEVEL_PLACEHOLDER: 'Hasar seviyesi seçin',
    DAMAGE_LEVEL_NONE: 'Seçilmedi',
    DAMAGE_LEVEL_1: 'Hafif Hasar',
    DAMAGE_LEVEL_2: 'Orta Hasar',
    DAMAGE_LEVEL_3: 'Ağır Hasar',
    REQUIRED_PARTS: 'Gerekli Parçalar',
    EDIT_PART: 'Parçayı düzenle',
    UPDATE_PART: 'Parçayı güncelle',
    REMOVE_PART: 'Parçayı kaldır',
    LABOR_COST: 'İşçilik Maliyeti',
    LABOR_COST_PLACEHOLDER: 'örn. 1500 ₺',
    DAMAGE_NOTE: 'Açıklama / Not',
    DAMAGE_NOTE_PLACEHOLDER: 'Hasarın detayları, müşteri açıklamaları...',
    MECHANICAL_WORK_ORDER_NOTE_PLACEHOLDER: 'Servis işlemleri ve müşteri talepleri...',
    UPDATE_DAMAGE: 'İş Emrini Güncelle',
    SAVE_DAMAGE: 'İş Emrini Kaydet',
    COMPLETE_DAMAGE_ANALYSIS: 'Hasar analizini bitir',
    REVERT_DAMAGE_ANALYSIS_APPROVAL: 'Onayı Geri Çek',
    REVERT_DAMAGE_ANALYSIS_CONFIRM_TITLE: 'Hasar analizi onayı geri çekilsin mi?',
    REVERT_DAMAGE_ANALYSIS_CONFIRM_MESSAGE: 'Hasar analizi tekrar düzenlenebilir olacak ve dosya planlama sırasına dönecek.',
    DAMAGE_ANALYSIS_COMPLETE_ERROR: 'Hasar analizi tamamlanamadı.',
    STATUS_HISTORY_DAMAGE_ANALYSIS_APPROVED: 'Hasar analizi onaylandı; iş emirleri parça hazırlığı ve teknisyen atamasını bekliyor.',
    DAMAGE_ANALYSIS_REVERT_ERROR: 'Hasar analizi onayı geri çekilemedi.',
    ASSIGN_TECHNICIAN: 'Teknisyen ata',
    NOT_ASSIGNED: '-',
    ASSIGNED_PERSON: 'Atanan Kişi',
    COMPLETED_BY: 'Tamamlayan',
    TECHNICIAN_ASSIGNMENT_REQUIRED: 'Teknisyen atanması gerekiyor',
    PART_SUPPLY_REQUIRED: 'Parça temini gerekiyor',
    SELECT_TECHNICIAN: 'Teknisyen seçin',
    REASSIGN_TECHNICIAN: 'Başka teknisyen ata',
    UNASSIGN_TECHNICIAN: 'Teknisyen atamasını kaldır',
    CONFIRM_UNASSIGN_TECHNICIAN: 'Onaylamak için tekrar tıklayın',
    LOADING_TECHNICIANS: 'Teknisyenler yükleniyor...',
    NO_TECHNICIANS: 'Bu birim için teknisyen bulunamadı.',
    CURRENT_TECHNICIAN_OPTION: '{{name}} (Mevcut)',
    ASSIGN: 'Ata',
    FINAL_DELIVERY_PHOTO_REQUIREMENT: 'Teslim öncesi toplam en az {{count}} araç fotoğrafı olacak şekilde güncel fotoğrafları ekleyin.',
    VEHICLE_ANALYSIS_PHOTO_GATE_REQUIREMENT: 'Araç analizine başlamak için en az {{count}} güncel araç fotoğrafı yükleyin.',
    START_WORK_PHOTO_REQUIREMENT: 'Bu işi başlatmak için en az {{count}} öncesi fotoğrafı ekleyin.',
    COMPLETE_WORK_PHOTO_REQUIREMENT: 'Bu işi tamamlamak için en az {{count}} sonrası fotoğrafı ekleyin.',
    PAUSE_WORK_PHOTO_REQUIREMENT: 'Bu işi duraklatmadan önce en az {{count}} onarım aşaması fotoğrafı ekleyin.',
    RESUME_WORK_PHOTO_REQUIREMENT: 'Bu işe devam etmeden önce en az {{count}} onarım aşaması fotoğrafı ekleyin.',
    REPAIR_PROGRESS_PHOTO_REQUIREMENT: 'Bu iş aşamasını belgelemek için en az {{count}} onarım aşaması fotoğrafı ekleyin.',
    WORK_PHOTO_MINIMUM_REQUIREMENT: 'En az {{count}} fotoğraf',
    PHOTOS_REMAINING: '{{count}} fotoğraf daha gerekli.',
    REQUIRED_PARTS_SAVE_ERROR: 'Gerekli parça durumları kaydedilemedi.',
    TECHNICIAN_ASSIGN_ERROR: 'Teknisyen ataması kaydedilemedi.',
    TECHNICIAN_UNASSIGN_ERROR: 'Teknisyen ataması kaldırılamadı.',
    TECHNICIAN_LOAD_ERROR: 'Ustalar yüklenemedi.',
    START_WORK: 'İşi başlat',
    COMPLETE_WORK: 'İşi tamamla',
    PHOTOS_ADDED: '{{count}} fotoğraf eklendi',
    START_WORK_PHOTO_HINT: 'Bu işi başlatmak için en az {{count}} öncesi fotoğrafı ekleyin.',
    COMPLETE_WORK_PHOTO_HINT: 'Bu işi tamamlamak için en az {{count}} sonrası fotoğrafı ekleyin.',
    DROP_WORK_PHOTOS: 'Fotoğrafları buraya sürükleyin veya seçmek için tıklayın',
    WORK_PHOTO_MINIMUM: 'En az 2 fotoğraf',
    WORK_PHOTO_IMAGE_REQUIRED: 'Yalnızca görsel dosyaları eklenebilir.',
    WORK_IN_PROGRESS: 'Devam ediyor',
    WORK_PAUSED: 'Duraklatıldı',
    ACTIVE_TIME: 'Aktif süre',
    PAUSE_WORK: 'İşi duraklat',
    RESUME_WORK: 'İşe devam et',
    PAUSE_WORK_ERROR: 'İş duraklatılamadı.',
    RESUME_WORK_ERROR: 'İşe devam edilemedi.',
    REPAIR_PROGRESS_PHOTOS_UPLOAD_ERROR: 'Onarım aşaması fotoğrafları yüklenemedi.',
    NEXT_RESUME_WORK: 'Hazır olduğunuzda duraklatılmış işe devam edin.',
    NEXT_ASSIGN_PAUSED_WORK: 'Duraklatılmış işe devam etmeden önce teknisyen atayın.',
    BEFORE_PHOTOS: 'Öncesi fotoğrafları',
    REPAIR_PROGRESS_PHOTOS: 'Onarım aşaması fotoğrafları',
    ADD_REPAIR_PROGRESS_PHOTOS: 'Onarım aşaması fotoğrafı ekle',
    AFTER_PHOTOS: 'Sonrası fotoğrafları',
    REQUIRED_PART_COUNT: '{{count}} adet',
    REQUIRED_PART_AVAILABLE: 'Var',
    REQUIRED_PART_ORDERED: 'Sipariş edildi',
    REQUIRED_PART_UNAVAILABLE: 'Yok',
    WORK_ORDER_STRUCTURE_SAVE_ERROR: 'İş emri veya parça talebi kaydedilemedi.',
    WORK_STARTED: 'İşlem başladı',
    MANAGER_ACTING_ON_BEHALF: '{{technician}} adına işlem yapıyorsunuz. KPI katkısı bu teknisyene ait olacaktır.',
    START_WORK_ERROR: 'İş başlatılamadı.',
    COMPLETE_WORK_ERROR: 'İş tamamlanamadı.',
    APPROVE_WORK: 'İşi Onayla',
    REJECT_WORK: 'İşi Onaylama',
    REJECT_WORK_MODAL_TITLE: 'Tamamlanan işi reddet',
    REJECT_WORK_REASON_LABEL: 'Red sebebi (isteğe bağlı)',
    REJECT_WORK_REASON_PLACEHOLDER: 'İş reddedilme sebebi...',
    REJECT_WORK_SEND_BACK: 'Geri Gönder',
    REJECTION_NUMBER: 'Ret Sebebi #{{number}}',
    REJECTION_NO_REASON: 'Açıklama belirtilmedi',
    WORK_REVIEW_ERROR: 'İş onayı kaydedilemedi.',
    REVERT_WORKSHOP_MANAGER_APPROVAL: 'Onayı geri çek',
    REVERT_WORKSHOP_MANAGER_APPROVAL_CONFIRM_TITLE: 'Atölye Yöneticisi tamamlanma onayı geri çekilsin mi?',
    REVERT_WORKSHOP_MANAGER_APPROVAL_CONFIRM_MESSAGE: 'Bu iş tamamlandı durumuna dönecek ve yeniden Atölye Yöneticisi kontrolü bekleyecek.',
    REVERT_WORKSHOP_MANAGER_APPROVAL_ERROR: 'Atölye Yöneticisi tamamlanma onayı geri çekilemedi.',
    SERVICE_FINAL_REVIEW_SENT: 'Kontrol için servis şefine gönderildi',
    ASSIGNED_TO_TECHNICIAN: '{{name}} adlı teknisyene atandı',
    READY_FOR_WORK: 'Çalışmaya hazır',
    STATUS_HISTORY_READY_FOR_WORK: '{{work}} işine teknisyen atandı ve iş çalışmaya hazır.',
    AWAITING_TECHNICIAN_ASSIGNMENT: 'Onaylandı — teknisyen ataması bekleniyor',
    WORK_COMPLETED: 'Tamamlandı',
    DETECTED_DAMAGES: 'İş Emirleri',
    DETECTED_DAMAGES_ONLY: 'Tespit Edilen Hasarlar',
    SERVICE_OPERATIONS: 'Servis İşlemleri',
    DAMAGE_PART_SUMMARY: '{{damage}} kayıt · {{parts}} parça',
    NO_DAMAGE_YET: 'Henüz iş emri oluşturulmadı. Başlamak için yukarıdaki İş Emri Oluştur seçeneğini kullanın.',
    NO_DAMAGE_RECORD: 'Henüz hasar kaydı yok.',
    NO_OPERATION_RECORD: 'Henüz servis işlemi kaydı yok.',
    PART_COUNT: '{{count}} parça',
    LABOR_COST_VALUE: 'İşçilik {{cost}}',
    TOTAL: 'toplam',
    EDIT: 'Düzenle',
    DELETE_DAMAGE: 'Kaydı sil',
    OPEN_REGISTRATION_SUMMARY: 'Kayıt özetini aç',
    REGISTRATION_SUMMARY_KICKER: 'İLK KAYIT BİLGİLERİ',
    REGISTRATION_SUMMARY_TITLE: 'Kayıt detayları',
    CLOSE_SUMMARY: 'Özeti kapat',
    SUMMARY_SECTION_RECORD: 'Kayıt özeti',
    SUMMARY_SECTION_INSURANCE: 'Sigorta & dosya',
    SUMMARY_YES: 'Evet',
    SUMMARY_NO: 'Hayır',
    SUMMARY_NOT_IN_CATALOG: 'Katalogda yok',
    SUMMARY_DAMAGE_SUB_TYPE: 'Hasar alt tipi',
    SUMMARY_MECHANICAL_SUB_TYPE: 'Mekanik alt tipi',
    SUMMARY_OPENED_AT: 'Kayıt açılış zamanı',
    SUMMARY_BROUGHT_BY: 'Getiren kişi',
    SUMMARY_VEHICLE_COLOR: 'Araç rengi',
    SUMMARY_AGENCY_EMAIL: 'Acente e-postası',
    SUMMARY_CLAIM_FILE_NO: 'Hasar dosya no',
    SUMMARY_POLICY_ISSUE_DATE: 'Poliçe düzenleme tarihi',
    SUMMARY_POLICY_START_DATE: 'Poliçe başlangıç tarihi',
    SUMMARY_POLICY_END_DATE: 'Poliçe bitiş tarihi',
    SUMMARY_APPROVAL_REQUEST_DATE: 'Onay talep tarihi',
    SUMMARY_APPROVAL_NOTE: 'Onay açıklaması',
    SUMMARY_NOTIFICATION_DATE: 'İhbar tarihi',
    SUMMARY_NOTIFICATION_TIME: 'İhbar saati',
    SUMMARY_DAMAGE_DATE: 'Hasar tarihi',
    SUMMARY_DAMAGE_TIME: 'Hasar saati',
    SUMMARY_DAMAGE_SUBCAUSE: 'Hasar alt sebebi',
    SUMMARY_ESTIMATED_AMOUNT: 'Tahmini hasar tutarı',
    SUMMARY_ASSESSOR_ADDRESS: 'Eksper adresi',
    SUMMARY_DRIVER_NAME: 'Sürücü',
    SUMMARY_ARRIVAL_DATE: 'Geliş tarihi',
    SUMMARY_ARRIVAL_METHOD: 'Geliş şekli',
  },
  CASE_REGISTRATION: {
    LABEL_USAGE_TYPE: 'Kullanım Türü',
    USAGE_TYPE_PASSENGER_VEHICLE: 'Binek Araç',
    USAGE_TYPE_COMBI: 'Combi',
    USAGE_TYPE_BUS: 'Otobüs',
    USAGE_TYPE_HEAVY_COMMERCIAL_TRUCK: 'Ağır Ticari Kamyon',
    USAGE_TYPE_MOTORCYCLE: 'Motosiklet',
    USAGE_TYPE_CONSTRUCTION_EQUIPMENT: 'İş Makinesi',
    USAGE_TYPE_LIGHT_COMMERCIAL_MINIBUS: 'Hafif Ticari Minibüs',
    USAGE_TYPE_LIGHT_COMMERCIAL_PICKUP: 'Hafif Ticari Pickup',
    USAGE_TYPE_HEAVY_COMMERCIAL_TRACTOR: 'Ağır Ticari Çekici',
    LABEL_BODY_TYPE: 'Kasa Tipi',
    BODY_TYPE_SEDAN_FOUR_DOOR: 'Sedan dört kapı',
    BODY_TYPE_SEDAN_TWO_DOOR: 'Sedan iki kapı',
    BODY_TYPE_HATCHBACK_FOUR_DOOR: 'HB dört kapı',
    BODY_TYPE_HATCHBACK_TWO_DOOR: 'HB iki kapı',
    BODY_TYPE_STATION_WAGON: 'Station',
    BODY_TYPE_JEEP: 'Jeep',
    BODY_TYPE_COMBI_SINGLE_SLIDING_DOOR: 'Combi tek sürgülü',
    BODY_TYPE_COMBI_DUAL_SLIDING_DOOR: 'Combi çift sürgülü',
    BODY_TYPE_COMBI_VAN_SINGLE_SLIDING_DOOR: 'Combi van tek sürgülü',
    BODY_TYPE_COMBI_VAN_DUAL_SLIDING_DOOR: 'Combi van çift sürgülü',
    BODY_TYPE_BUS: 'Otobüs',
    BODY_TYPE_TRUCK: 'Kamyon',
    BODY_TYPE_CONVENTIONAL_TRUCK: 'Burunlu kamyon',
    BODY_TYPE_MOTORCYCLE: 'Motosiklet',
    BODY_TYPE_CONSTRUCTION_EQUIPMENT: 'İş makinesi',
    BODY_TYPE_TRAILER_DORSE: 'Römork/dorse',
    BODY_TYPE_MINIBUS_VAN: 'Minibüs van',
    BODY_TYPE_MINIBUS_CARAVAN: 'Minibüs karavan',
    BODY_TYPE_MINIBUS: 'Minibüs',
    BODY_TYPE_PICKUP_SINGLE_CAB: 'Kamyonet tek kabin',
    BODY_TYPE_PICKUP_DOUBLE_CAB: 'Kamyonet çift kabin',
    BODY_TYPE_TRACTOR_UNIT: 'Çekici',
    STEP_ACCIDENT_PARTIES: 'Karşı Taraflar',
    ACCIDENT_PARTIES_TITLE: 'Karşı Taraflar',
    ACCIDENT_PARTIES_HINT: 'Karşı tarafların araç ve kişi bilgilerini ekleyin.',
    ACCIDENT_PARTY_SUFFIX: 'karşı taraf',
    ACCIDENT_PARTY_COUNT: 'Kaza boyutu',
    ACCIDENT_SINGLE_VEHICLE: 'Tek araçlı',
    ACCIDENT_TWO_VEHICLES: '2’li kaza',
    ACCIDENT_THREE_VEHICLES: '3’lü kaza',
    ACCIDENT_FOUR_PLUS: '4’lü kaza+',
    ACCIDENT_PARTY_LABEL: 'Karşı Taraf {{index}}',
    ACCIDENT_PARTY_EMPTY: 'Bilgi girilmedi',
    ACCIDENT_PARTY_PLATE_EMPTY: 'Plaka girilmedi',
    ACCIDENT_PARTY_DOCUMENT_SUFFIX: 'belge',
    ACCIDENT_PARTY_NAME: 'Ad',
    ACCIDENT_PARTY_SURNAME: 'Soyad',
    ACCIDENT_PARTY_TCKN: 'T.C. Kimlik No',
    ACCIDENT_PARTY_PHONE: 'Telefon',
    ACCIDENT_PARTY_PLATE: 'Araç plakası',
    ACCIDENT_LICENSE_DOCUMENTS: 'Ehliyet',
    ACCIDENT_REGISTRATION_DOCUMENTS: 'Ruhsat',
    ACCIDENT_POLICY_DOCUMENTS: 'Sigorta poliçesi',
    ACCIDENT_ADD_PARTY: 'Karşı taraf ekle',
    ACCIDENT_REMOVE_TITLE: 'Karşı taraf kaldırılsın mı?',
    ACCIDENT_REMOVE_ACTION: 'Kaldır',
    ACCIDENT_REMOVE_CONFIRM: 'Bu karşı tarafın bağlı belgeleri de kaldırılabilir. Devam edilsin mi?',
    ACCIDENT_SUBTYPE_REMOVE_CONFIRM: 'Hasar alt türünü değiştirmek karşı tarafları ve bağlı belgelerini kaldıracaktır. Devam edilsin mi?',
    ACCIDENT_SINGLE_VEHICLE_HINT: 'Bu kayıt tek araçlı trafik kazası olarak oluşturulacaktır.',
    DOCUMENT_UPLOAD_BUTTON_SHORT: 'Belge ekle',
    HEADER_TITLE: 'Araç Kaydı Açma',
    HEADER_TITLE_EDIT: 'Araç Kaydı Düzenleme',
    PRINT_FORM: 'Formu yazdır',
    PRINT_FORM_TITLE: 'Araç Kabul Formu',
    SAVE: 'Kaydet',
    SAVING: 'Kaydediliyor...',
    SAVED: 'Kaydedildi',
    VEHICLE_PHOTOS_REQUIRED: 'Kaydetmeden önce en az {{count}} araç geliş fotoğrafı atayın ({{remaining}} fotoğraf daha gerekli).',
    VEHICLE_ARRIVAL_PHOTOS_STATUS: 'Araç geliş fotoğrafları: {{current}} / {{count}}',
    BOOKING_LOADING: 'Randevu bilgileri yükleniyor...',
    BOOKING_UNAVAILABLE: 'Bu randevu kullanılamıyor veya daha önce tamamlanmış.',
    PROFILE_PREFILL_LOADING: 'Müşteri ve araç bilgileri yükleniyor...',
    PROFILE_PREFILL_ERROR: 'Müşteri ve araç bilgileri yüklenemedi. Lütfen tekrar deneyin.',
    PROFILE_PREFILL_RETRY: 'Tekrar dene',
    CUSTOMER_SEARCH_ACTION: 'Müşteri Ara',
    CUSTOMER_SEARCH_TITLE: 'Müşteri Ara',
    CUSTOMER_SEARCH_CLOSE: 'Müşteri aramasını kapat',
    CUSTOMER_SEARCH_BACK: 'Geri Dön',
    CUSTOMER_SEARCH_CONFIRM: 'Onayla',
    CUSTOMER_SEARCH_DISCARD_DRAFT: 'Onaylarsanız tamamlanmamış kayıt bilgileri, belge seçimleri ve imza temizlenecektir.',
    CUSTOMER_SEARCH_NO_DETAILS: 'Bu müşteri ve araç için yeniden kullanılabilecek bilgi bulunmuyor.',
    CUSTOMER_SEARCH_YES: 'Evet',
    BOOKING_CONFLICT: 'Bu randevu daha önce bir kayıt oluşturmak için kullanılmış.',
    BOOKING_AUTOFILL_CONFIRM_TITLE: 'Yapay zeka ile doldurulsun mu?',
    BOOKING_AUTOFILL_CONFIRM_MESSAGE: '{{count}} müşteri belgesi hazır. Yapay zekanın belgeleri analiz ederek kayıt bilgileri önermesini ister misiniz?',
    BOOKING_AUTOFILL_CONFIRM_ACTION: 'Yapay Zeka ile Doldur',
    BOOKING_AUTOFILL_CONFIRM_CANCEL: 'Manuel Devam Et',
    BOOKING_AUTOFILL_CHOOSE_TITLE: 'Yapay Zeka ile Doldur',
    BOOKING_AUTOFILL_CHOOSE_MESSAGE: 'Seçili belgelere randevu yüklemeleri de dahil edilsin mi?',
    BOOKING_AUTOFILL_INCLUDE_ALL: 'Randevu Yüklemelerini Dahil Et',
    BOOKING_AUTOFILL_ONLY_ASSIGNED: 'Sadece Seçili Belgeler',
    DOCUMENT_BULK_AI_SELECTION_HINT: 'Bu belge grubunu yapay zeka ile doldurma için seçmek veya kaldırmak üzere Control tuşuna basılı tutup tıklayın',
    DOCUMENT_SLOT_PREVIOUS_PAGE: 'Önceki atanmış belgeleri göster',
    DOCUMENT_SLOT_NEXT_PAGE: 'Sonraki atanmış belgeleri göster',
    DOCUMENT_PREVIEW_PREVIOUS: 'Önceki atanmış belgeyi göster',
    DOCUMENT_PREVIEW_NEXT: 'Sonraki atanmış belgeyi göster',
    CUSTOMER_INFORMATION: 'Müşteri Bilgileri',
    OPEN_CUSTOMER_INFORMATION: 'Müşteri bilgilerini aç',
    CLOSE_CUSTOMER_INFORMATION: 'Müşteri bilgilerini kapat',
    GET_SIGNATURE: 'İmza Al',
    SIGNATURE_TAKEN: 'İmza alındı',
    SIGNATURE_TITLE: 'Müşteri İmzası',
    SIGNATURE_DRAW_HINT: 'Lütfen aşağıdaki alana imzanızı atın.',
    SIGNATURE_EXISTING_HINT: 'Bir imza zaten kayıtlı. Yeni imza almak için önce kaldırın.',
    SIGNATURE_REMOVE: 'Kaldır',
    SIGNATURE_SAVE: 'Kaydet',
    SIGNATURE_CANCEL: 'İptal',
    SIGNATURE_CLOSE: 'İmza penceresini kapat',
    CLOSE_CONFIRM_TITLE: 'Kaydı iptal et?',
    CLOSE_CONFIRM_MESSAGE: 'Form tamamen temizlenecek, emin misiniz?',
    CLOSE_CONFIRM_ACTION: 'İptal Et ve Kapat',
    CLOSE_CONFIRM_CANCEL: 'Vazgeç',
    BOOKING_SUBMISSION_DATE: 'Gönderim tarihi',
    CLOSE: 'Kapat',
    STEP_OWNER_USER: 'Müşteri ve Dosya Bilgileri',
    STEP_VEHICLE_DETAILS: 'Araç Bilgileri',
    STEP_VEHICLE_COUNTERPARTIES: 'Araç ve Karşı Taraf Bilgileri',
    STEP_VEHICLE_APPROVAL_INSURANCE: 'Araç ve Onay/Sigorta Bilgileri',
    STEP_DAMAGE_INSURANCE: 'Hasar & Sigorta Süreci',
    STEP_DOCUMENTS: 'Müşteri Belgeleri',
    DOCUMENT_DROP_UPLOADING: 'Yükleniyor ve atanıyor...',
    DOCUMENT_DROP_UPLOAD_ERROR: 'Dosyalar yüklenemedi. Lütfen tekrar deneyin.',
    DOCUMENT_BROWSER_DROP_UPLOADING: 'Dosyalar yükleniyor...',
    CONTINUE: 'Devam Et',
    BACK: 'Geri',
    OWNER_INFO: 'Araç Sahibi Bilgileri',
    CUSTOMER_AND_VEHICLE_OWNER: 'Müşteri ve Araç Sahibi',
    REGISTERED_OWNER: 'Ruhsat Sahibi',
    REGISTERED_OWNER_TYPE: 'Ruhsat Sahibi Türü',
    REGISTERED_OWNER_DIFFERENT: 'Ruhsat sahibi farklı',
    OPTIONAL_FIELD: 'Opsiyonel',
    PERSON: 'Kişi',
    CUSTOMER_RELATED_PERSON_INFO: 'Müşteri ve İlgili Kişiler',
    CUSTOMER_INFO: 'Müşteri',
    VEHICLE_USER: 'Araç Kullanıcısı',
    BRINGER: 'Getiren Kişi',
    USER_INFO: 'Araç Kullanıcısı Bilgileri',
    GENERAL_INFO: 'Dosya Bilgileri',
    VEHICLE_INFO: 'Araç Bilgileri',
    REPAIR_LIST_TITLE: 'Hasar Listesi',
    REPAIR_LIST_EMPTY: 'Henüz hasar kalemi eklenmedi.',
    REPAIR_PANEL: 'Onarılacak Panel',
    MAINTENANCE_LIST_TITLE: 'Bakım Listesi',
    MAINTENANCE_LIST_EMPTY: 'Henüz bakım kalemi eklenmedi.',
    MAINTENANCE_ITEM: 'Yapılacak Bakım',
    REPAIR_TYPE: 'Onarım Türü',
    REPAIR_ACTIONS: 'İşlemler',
    REPAIR_TYPE_PAINT: 'Boya Tamiri',
    REPAIR_TYPE_BODY: 'Kaporta Tamiri',
    ADD_REPAIR_ITEM: 'Satır Ekle',
    REMOVE_REPAIR_ITEM: 'Kaldır',
    REPAIR_LIST_INVALID: 'Kaydetmeden önce tüm hasar listesi satırlarını tamamlayın.',
    DAMAGE_INFO: 'Hasar Bilgileri',
    APPROVAL_INSURANCE_INFO: 'Onay Ve Sigorta Bilgileri',
    DRIVER_ARRIVAL_INFO: 'Sürücü ve Araç Geliş Bilgileri',
    ARRIVAL_INFO: 'Araç Geliş Bilgileri',
    INCOMING_DOCUMENTS: 'Gelen Belgeler',
    DOCUMENT_TABS: 'Belge Atamaları',
    DOCUMENT_ASSIGNMENT_SUMMARY_HINT: 'Belgelerini görmek ve atamak için bir belge türü seçin.',
    DOCUMENT_ASSIGNMENT_SLOT_HINT: 'Arama alanından bir belge seçin, ardından aşağıdan veya karşı taraf ekranından belge grubuna atayın.',
    DOCUMENT_INTAKE_SEARCH_LABEL: 'Telefon / Yükleyen Arama',
    DOCUMENT_INTAKE_SEARCH_PLACEHOLDER: 'En az 3 telefon rakamı yazın',
    DOCUMENT_INTAKE_REFRESH: 'Yenile',
    DOCUMENT_INTAKE_UPLOAD: 'Belge yükle',
    DOCUMENT_INTAKE_EMPTY: 'Henüz gelen belge yok',
    DOCUMENT_INTAKE_EMPTY_HINT: 'WhatsApp veya manuel yükleme belgeleri burada listelenecek.',
    DOCUMENT_INTAKE_LOADING: 'Belgeler yükleniyor',
    DOCUMENT_INTAKE_LOAD_ERROR: 'Belgeler yüklenemedi. Lütfen tekrar deneyin.',
    STALE_DOCUMENT_ASSIGNMENTS_REMOVED: 'Başka bir dosyaya atanmış belgeler kaldırıldı. Lütfen kullanılabilir belgeleri yeniden seçin veya yükleyin.',
    DOCUMENT_COUNT_SUFFIX: 'belge',
    MANUAL_UPLOADS: 'Manuel Yüklemeler',
    BOOKING_DOCUMENTS: 'Müşterinin Gönderdikleri',
    DOCUMENT_FIELD_DROP_HERE: 'Buraya bırak',
    DOCUMENT_FIELD_EMPTY: 'Boş',
    DOCUMENT_MOBILE_SELECTED: 'Seçildi',
    DOCUMENT_MOBILE_SELECT_FIRST: 'Önce bir fotoğraf seçin',
    DOCUMENT_MOBILE_ASSIGN_PHOTO: 'Fotoğrafı ata',
    DOCUMENT_READER_TITLE: 'Belge okuma paneli',
    DOCUMENT_READER_HINT: 'Form alanlarını doldururken atanan fotoğrafları açın.',
    DOCUMENT_READER_OPEN: 'Önizlemeyi aç',
    DOCUMENT_READER_MINIMIZE: 'Belge panelini küçült',
    DOCUMENT_READER_EXPAND: 'Belge panelini genişlet',
    DOCUMENT_UPLOAD_TITLE: 'Belge Yükle',
    DOCUMENT_UPLOAD_DROP_LABEL: 'Dosyaları buraya sürükleyin',
    DOCUMENT_UPLOAD_DROP_HINT: 'veya seçmek için tıklayın',
    DOCUMENT_UPLOAD_SELECTED_FILES: 'Seçilen dosyalar ({{count}})',
    DOCUMENT_UPLOAD_BUTTON: 'Yükle ({{count}})',
    UPLOADING: 'Yükleniyor...',
    DOCUMENT_DELETE: 'Belgeyi sil',
    DOCUMENT_DELETE_CONFIRM_TITLE: 'Belgeyi sil',
    DOCUMENT_DELETE_CONFIRM_MESSAGE: 'Bu belgeyi silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    DOCUMENT_DELETE_CONFIRM_ACTION: 'Sil',
    DOCUMENT_DELETE_ALL: 'Tümü sil ({{count}})',
    DOCUMENT_DELETE_ALL_CONFIRM_TITLE: 'Seçili belgeleri sil',
    DOCUMENT_DELETE_ALL_CONFIRM_MESSAGE: 'Seçili {{count}} belgenin tamamını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    DOCUMENT_DELETE_ALL_CONFIRM_ACTION: 'Tümünü sil',
    DOCUMENT_DELETE_ALL_ERROR: 'Seçili belgeler silinemedi. Lütfen tekrar deneyin.',
    OWNER_TYPE: 'Sahip Tipi',
    INDIVIDUAL: 'Şahıs',
    CORPORATE: 'Kurum',
    RELATED_PERSON_OPTIONS: 'Ek Kişi Seçenekleri',
    BRINGER_DIFFERENT: 'Getiren kişi farklı',
    VEHICLE_USER_DIFFERENT: 'Araç kullanıcısı farklı',
    REQUIRED_OPTION: 'Zorunlu',
    BRINGER_INFO: 'Getiren Kişi Bilgileri',
    REGISTRATION_TYPE: 'Kayıt Türü',
    TYPE_DAMAGE: 'Hasar',
    TYPE_MECHANICAL: 'Mekanik',
    SELECT_PLACEHOLDER: 'Seçiniz',
    VALIDATION_REQUIRED: 'Bu alan zorunludur.',
    VALIDATION_INVALID_TEXT: 'Geçerli bir değer girin.',
    VALIDATION_INVALID_NAME: 'Yalnızca harf, boşluk, apostrof, tire veya nokta kullanın.',
    VALIDATION_INVALID_TCKN: 'Geçerli bir T.C. kimlik numarası girin.',
    VALIDATION_INVALID_PLATE: 'Harf, rakam, boşluk, tire, nokta veya eğik çizgi kullanın; plaka harf ya da rakamla başlamalı ve bitmelidir.',
    VALIDATION_INVALID_VKN: 'Geçerli bir vergi numarası girin.',
    VALIDATION_INVALID_PHONE: 'Ülke koduyla birlikte geçerli bir telefon numarası girin.',
    VALIDATION_INVALID_EMAIL: 'Geçerli bir e-posta adresi girin.',
    VALIDATION_INVALID_DATE: 'Tarih gelecek tarihli olamaz.',
    VALIDATION_INVALID_LICENSE_NO: 'Geçerli bir ehliyet numarası girin.',
    VALIDATION_INVALID_SELECTION: 'Geçerli bir seçenek seçin.',
    VALIDATION_INVALID_CHASSIS: 'Geçerli bir şasi numarası girin.',
    VALIDATION_INVALID_YEAR: 'Geçerli bir model yılı girin.',
    VALIDATION_INVALID_NUMBER: 'Geçerli bir negatif olmayan sayı girin.',
    VALIDATION_INVALID_TIME: 'Geçerli bir saat girin (SS:DD).',
    LABEL_FIRST_NAME: 'Ad',
    LABEL_LAST_NAME: 'Soyad',
    LABEL_IDENTITY_NO: 'T.C. Kimlik No',
    LABEL_BIRTH_DATE: 'Doğum Tarihi',
    LABEL_GENDER: 'Cinsiyet',
    MALE: 'Erkek',
    FEMALE: 'Kadın',
    LABEL_CITY: 'İl',
    LABEL_DISTRICT: 'İlçe',
    LABEL_MOBILE: 'Cep Telefonu',
    LABEL_EMAIL: 'E-Posta',
    LABEL_VKN: 'Vergi Kimlik Numarası (VKN)',
    LABEL_TAX_NO: 'Vergi No',
    LABEL_COMPANY_TITLE: 'Kurum Tam Adı',
    LABEL_COMMERCIAL_TITLE: 'Ticari unvan',
    LABEL_TAX_OFFICE: 'Vergi dairesi',
    LABEL_AUTHORIZED_PERSON: 'Yetkili Adı Soyadı',
    PLACEHOLDER_IDENTITY_NO: '11 haneli T.C. kimlik no',
    PLACEHOLDER_VKN: '10 haneli vergi no',
    PLACEHOLDER_TAX_NO: 'Vergi No',
    PLACEHOLDER_COMPANY_TITLE: 'Kurum Tam Adı',
    PLACEHOLDER_AUTHORIZED_PERSON: 'Yetkili kişi',
    LABEL_PLATE: 'Araç Plaka',
    PLACEHOLDER_PLATE: '34 ABC 123',
    PLACEHOLDER_MILEAGE: 'Örn. 125.000',
    PLACEHOLDER_CHASSIS: '17 haneli şasi no',
    PLACEHOLDER_MODEL_YEAR: 'Örn. 2024',
    PLACEHOLDER_EMAIL: 'ornek@firma.com',
    LABEL_CHASSIS: 'Şasi No',
    LABEL_CUSTOMER_INSTITUTION: 'Müşteri Kurum',
    LABEL_PROJECT: 'Proje',
    INSURANCE_COMPANY_SEARCH_PLACEHOLDER: 'Sigorta şirketi ara...',
    PROJECT_SEARCH_PLACEHOLDER: 'Proje ara...',
    INSURANCE_LOOKUP_LOADING: 'Seçenekler yükleniyor...',
    INSURANCE_PROJECT_COUNT: 'proje',
    PROJECT_REQUIRES_COMPANY: 'Önce bir sigorta şirketi seçin.',
    ADD_MISSING_PROJECT: 'Eksik projeyi ekle',
    MISSING_PROJECT_NAME: 'Proje Adı',
    PLACEHOLDER_MISSING_PROJECT_NAME: 'Proje adı',
    MISSING_PROJECT_PRODUCT_CODE: 'Ürün Kodu',
    MISSING_PROJECT_MAIN_TYPE: 'Ana Tip',
    CREATE_MISSING_PROJECT: 'Projeyi oluştur',
    INSURANCE_PRODUCT_CASCO: 'Kasko',
    INSURANCE_PRODUCT_TRAFFIC: 'Trafik Sigortası',
    INSURANCE_PRODUCT_UNKNOWN: 'Diğer / Bilinmiyor',
    INSURANCE_MAIN_TYPE_ASSESSOR: 'Sigortalı - Eksperli',
    INSURANCE_MAIN_TYPE_MODULE: 'Sigortalı - Modül',
    INSURANCE_MAIN_TYPE_OTHER: 'Diğer',
    INSURANCE_COMPANY_REQUIRED: 'Proje eklemeden önce bir sigorta şirketi seçin.',
    MISSING_PROJECT_FORM_REQUIRED: 'Eksik proje formunu tamamen doldurun.',
    MISSING_PROJECT_CREATE_FAILED: 'Proje oluşturulamadı.',
    INSURANCE_LOOKUP_LOAD_FAILED: 'Sigorta seçenekleri yüklenemedi.',
    LABEL_DAMAGE_SUB_TYPE: 'Hasar Alt Türü',
    LABEL_MECHANICAL_SUB_TYPE: 'Mekanik Alt Türü',
    LABEL_ARRIVAL_DATE: 'Geliş Tarihi',
    LABEL_EXPECTED_DELIVERY_DATE: 'Teslim Randevusu Tarihi',
    LABEL_EXPECTED_DELIVERY_TIME: 'Teslim Randevusu Saati',
    LABEL_DELIVERY_APPOINTMENT_DATE: 'Teslim Randevusu Tarihi',
    LABEL_DELIVERY_APPOINTMENT_TIME: 'Teslim Randevusu Saati',
    EXPECTED_DELIVERY_HOUR_PLACEHOLDER: 'Saat',
    EXPECTED_DELIVERY_MINUTE_PLACEHOLDER: 'Dakika',
    EXPECTED_DELIVERY_HOUR_ARIA: 'Teslim randevusu saati',
    EXPECTED_DELIVERY_MINUTE_ARIA: 'Teslim randevusu dakikası',
    TIME_PICKER_HOUR_ARIA: 'Saat',
    TIME_PICKER_MINUTE_ARIA: 'Dakika',
    LABEL_BROUGHT_BY: 'Getiren Kişi',
    LABEL_ARRIVAL_METHOD: 'Geliş Şekli',
    LABEL_RECEIVED_LOCATION: 'Aracın Teslim Alındığı Yer',
    LABEL_RECEIVED_LOCATION_OTHER: 'Diğer Teslim Alma Yeri',
    LABEL_RECEIVED_ITEMS: 'Araç Teslim Alınırken Kontrol Edilenler',
    LABEL_OTHER_SPECIAL_ITEMS: 'Diğer Özel Eşyalar',
    LABEL_CUSTOMER_REQUESTS: 'Müşteri İstekleri',
    LABEL_MILEAGE: 'Kilometre',
    DAMAGE_SUB_TYPE_TRAFFIC_INSURANCE: 'Trafik Hasarı',
    DAMAGE_SUB_TYPE_CASCO_DECLARATION: 'Beyan Kasko Hasarı',
    DAMAGE_SUB_TYPE_CASCO_AGREED: 'Anlaşmalı Kasko Hasarı',
    DAMAGE_SUB_TYPE_RETAIL: 'Perakende İşlem',
    MECHANICAL_SUB_TYPE_PERIODIC_MAINTENANCE: 'Periyodik Bakım',
    MECHANICAL_SUB_TYPE_ENGINE: 'Motor',
    MECHANICAL_SUB_TYPE_TRANSMISSION_CLUTCH: 'Şanzıman / Debriyaj',
    MECHANICAL_SUB_TYPE_BRAKE_SYSTEM: 'Fren Sistemi',
    MECHANICAL_SUB_TYPE_SUSPENSION_RUNNING_GEAR: 'Süspansiyon / Yürüyen Aksam',
    MECHANICAL_SUB_TYPE_STEERING_SYSTEM: 'Direksiyon Sistemi',
    MECHANICAL_SUB_TYPE_COOLING_SYSTEM: 'Soğutma Sistemi',
    MECHANICAL_SUB_TYPE_FUEL_INJECTION_SYSTEM: 'Yakıt / Enjeksiyon Sistemi',
    MECHANICAL_SUB_TYPE_EXHAUST_EMISSION: 'Egzoz / Emisyon',
    MECHANICAL_SUB_TYPE_AIR_CONDITIONING_HEATING: 'Klima / Isıtma',
    MECHANICAL_SUB_TYPE_ELECTRICAL_ELECTRONIC: 'Elektrik / Elektronik',
    MECHANICAL_SUB_TYPE_BATTERY_STARTER_CHARGING: 'Akü / Marş / Şarj',
    MECHANICAL_SUB_TYPE_DIAGNOSTIC_FAULT_DETECTION: 'Arıza Tespit / Diagnostik',
    MECHANICAL_SUB_TYPE_GENERAL_MECHANICAL: 'Genel Mekanik',
    ARRIVAL_METHOD_SELF: 'Kendisi',
    ARRIVAL_METHOD_TOW: 'Çekici',
    LABEL_BRAND: 'Marka',
    LABEL_MODEL: 'Model',
    LABEL_MODEL_YEAR: 'Model Yılı',
    LABEL_DRIVING_LICENSE_CLASS: 'Ehliyet Sınıfı',
    LABEL_DRIVING_LICENSE: 'Ehliyet No',
    PLACEHOLDER_REPAIR_PANEL: 'Örn. Ön tampon',
    PLACEHOLDER_MAINTENANCE_ITEM: 'Örn. Periyodik bakım',
    OPTION_AVAILABLE: 'Var',
    OPTION_NOT_AVAILABLE: 'Yok',
    VEHICLE_SELECTION: 'Araç Seçimi',
    VEHICLE_SELECTION_ACTION: 'Araç Seçimi',
    VEHICLE_SELECTION_TITLE: 'Araç Seç',
    CHANGE_SELECTION: 'Seçimi Değiştir',
    SELECTED: 'Seçilen',
    SELECT_BRAND: 'Marka Seçin',
    SELECT_MODEL: 'Model Seçin',
    SELECT_VEHICLE: 'Araç Seçin',
    SEARCH_BRAND_PLACEHOLDER: 'Marka yazın',
    SEARCH_MODEL_PLACEHOLDER: 'Model yazın',
    SEARCHING: 'Aranıyor...',
    NO_RESULTS: 'Sonuç bulunamadı',
    CONFIRM_SELECTION: 'Seçimi Onayla',
    CANCEL: 'İptal',
    CATALOG_NOT_FOUND: 'Katalogda Yok',
    OTHER_ENGINE: 'Diğer',
    LABEL_DAMAGE_DESCRIPTION: 'Hasarın Tanımı',
    LABEL_DAMAGE_CITY: 'Hasar İli',
    LABEL_DAMAGE_DISTRICT: 'Hasar İlçesi',
    LABEL_INSURANCE_COMPANY: 'Sigorta Şirketi',
    LABEL_POLICY_NO: 'Poliçe No',
    LABEL_AGENCY_NAME: 'Acente Adı',
    LABEL_AGENCY_CITY: 'Acente İli',
    LABEL_AGENCY_PLATE_NO: 'Acente Levha No',
    CATALOG_HINT: 'Katalogdan araç seçmek için butona tıklayın',
    DOC_ASSIGN_DAMAGE_PHOTO: 'Araç Fotoğrafı',
    DOC_ASSIGN_ARRIVAL_PHOTO: 'Araç Geliş Fotoğrafları',
    DOC_ASSIGN_LICENSE: 'Ehliyet',
    DOC_ASSIGN_REGISTRATION: 'Ruhsat',
    DOC_ASSIGN_POLICY: 'Trafik Sigortası Poliçesi',
    DOC_ASSIGN_FUEL_GAUGE: 'KM / Yakıt Göstergesi',
    DOC_ASSIGN_KASKO_POLICY: 'Kasko Poliçesi',
    DOC_ASSIGN_DECLARATION: 'Beyan Tutanağı',
    DOC_ASSIGN_MUTUAL_ACCIDENT_REPORT: 'Anlaşmalı Tutanak',
    DOC_ASSIGN_PRELIMINARY_EXPERTISE_FORM: 'Ön Ekspertiz Formu',
    DOC_ASSIGN_SCENE_PHOTOS: 'Olay Yeri Fotoğrafları',
    DOC_ASSIGN_REPORT: 'Tutanak',
    DOC_ASSIGN_DUPLICATE: 'Tekrarlanan Belge',
    OPTION_RECEIVED_LOCATION_OTOMOTO: 'Otomoto Hasar Onarım Merkezi',
    OPTION_OTHER: 'Diğer',
    ITEM_REGISTRATION_DOCUMENT: 'Ruhsat',
    ITEM_FIRE_EXTINGUISHER: 'Yangın Tüpü',
    ITEM_TRAFFIC_SET: 'Trafik Seti',
    ITEM_SPARE_KEY: 'Yedek Anahtar',
    ITEM_SPARE_TIRE: 'Stepne',
    ITEM_JACK: 'Kriko',
    ITEM_CHAIN: 'Zincir',
    ITEM_FLOOR_MATS: 'Paspas',
    LABEL_NOTIFICATION_DATE: 'İhbar Tarihi',
    LABEL_NOTIFICATION_TIME: 'İhbar Saati',
    LABEL_DAMAGE_DATE: 'Hasar Tarihi',
    LABEL_DAMAGE_TIME: 'Hasar Saati',
    LABEL_ESTIMATED_DAMAGE: 'Tahmini Hasar',
    LABEL_DAMAGE_REASON: 'Hasar Sebebi',
    LABEL_APPROVAL_DATE: 'Onay Talep Tarihi',
    LABEL_DESCRIPTION: 'Açıklama',
    LABEL_AGENCY_EMAIL: 'Acente E-Postası',
    LABEL_FILE_NO: 'Hasar Dosya No',
    LABEL_POLICY_ISSUE_DATE: 'Poliçe Tanzim Tarihi',
    LABEL_POLICY_START_DATE: 'Poliçe Başlangıç Tarihi',
    LABEL_POLICY_END_DATE: 'Poliçe Bitiş Tarihi',
    DAMAGE_REASON_BODILY_INJURY: 'Bedeni Zarar',
    DAMAGE_REASON_GLASS_BREAKAGE: 'Cam Kırılması',
    DAMAGE_REASON_THEFT: 'Çalınma',
    DAMAGE_REASON_COLLISION: 'Çarpma',
    DAMAGE_REASON_EARTHQUAKE: 'Deprem',
    DAMAGE_REASON_ROLLOVER: 'Devrilme',
    DAMAGE_REASON_HEADLIGHT_SIGNAL_DAMAGE: 'Far Stop Sinyal Kırılması',
    DAMAGE_REASON_CIVIL_UNREST: 'Halk Hareketleri',
    DAMAGE_REASON_MALICIOUS_ACTS: 'Kötü Niyetli Hareketler',
    DAMAGE_REASON_PROPERTY_DAMAGE: 'Maddi Zarar',
    DAMAGE_REASON_DEATH: 'Ölüm',
    DAMAGE_REASON_PARKED_COLLISION: 'Park Halinde Çarpma',
    DAMAGE_REASON_FLOOD: 'Sel-Seylap',
    DAMAGE_REASON_CIGARETTE_BURN: 'Sigara Yangı',
    DAMAGE_REASON_TREATMENT: 'Tedavi',
    DAMAGE_REASON_TERROR: 'Terör',
    DAMAGE_REASON_FIRE: 'Yangın',
    AUTOFILL_BUTTON: 'Yapay Zeka ile Doldur',
    AUTOFILL_DUPLICATE_SUMMARY: 'Belge-{{number}}, {{count}} kopya',
    AUTOFILL_POPUP_TITLE: 'Yapay Zeka ile Doldur',
    AUTOFILL_PROGRESS_LABEL: 'Otomatik doldurma ilerlemesi',
    AUTOFILL_PROGRESS_STEPS: '{{total}} adımdan {{completed}} adım',
    AUTOFILL_ELAPSED_TIME: '{{minutes}} dk {{seconds}} sn',
    AUTOFILL_QUEUE_POSITION: 'Kuyruktaki sıranız: {{position}}',
    AUTOFILL_PHASE_PREPARE_JOB: 'İş hazırlanıyor',
    AUTOFILL_PHASE_PREPARE_JOB_COMPLETE: 'İş hazırlandı',
    AUTOFILL_PHASE_SEND_DOCUMENTS: 'Belgeler gönderiliyor',
    AUTOFILL_PHASE_SEND_DOCUMENTS_COMPLETE: 'Belgeler gönderildi',
    AUTOFILL_PHASE_GENERATE_RECOMMENDATIONS: 'Öneriler oluşturuluyor',
    AUTOFILL_PHASE_GENERATE_RECOMMENDATIONS_COMPLETE: 'Öneriler oluşturuldu',
    AUTOFILL_PHASE_REVIEW_RECOMMENDATIONS: 'Öneriler inceleniyor',
    AUTOFILL_PHASE_REVIEW_RECOMMENDATIONS_COMPLETE: 'Öneriler incelendi',
    AUTOFILL_PHASE_ADDITIONAL_CHECKS: 'Ek kontroller yapılıyor',
    AUTOFILL_PHASE_ADDITIONAL_CHECKS_COMPLETE: 'Ek kontroller tamamlandı',
    AUTOFILL_PROGRESS_AI: 'YZ analizi',
    AUTOFILL_PROGRESS_REVIEW: 'İnceleme',
    AUTOFILL_ANALYSIS_TITLE: 'Yapay Zeka Analizi',
    AUTOFILL_ANALYSIS_COMPLETE: 'Analiz tamamlandı',
    AUTOFILL_SUCCESS_ANIMATION_ALT: 'Yapay zeka analizi tamamlandı',
    AUTOFILL_CONTINUING: 'Devam Ediliyor... ({{seconds}})',
    AUTOFILL_REVIEW_TITLE: 'Önerileri inceleyin',
    AUTOFILL_REVIEW_DESCRIPTION: 'Tüm öneriler etkin. Uygulamak istemediklerinizi kapatabilirsiniz.',
    AUTOFILL_SECTION_OWNER: 'Müşteri',
    AUTOFILL_SECTION_REGISTERED_OWNER: 'Ruhsat Sahibi — {{type}}',
    AUTOFILL_SECTION_VEHICLE: 'Araç',
    AUTOFILL_SECTION_OTHER: 'Diğer Bulgular',
    AUTOFILL_SECTION_COUNTERPARTY: 'Karşı Taraf {{number}}',
    AUTOFILL_SECTION_DOCUMENTS: 'Belge Kategorileri',
    AUTOFILL_CATEGORY_UNKNOWN: 'Kategorisiz',
    AUTOFILL_CATEGORY_COUNTERPARTY_DRIVING_LICENSE: 'Karşı taraf sürücü belgesi',
    AUTOFILL_CATEGORY_COUNTERPARTY_REGISTRATION: 'Karşı taraf araç ruhsatı',
    AUTOFILL_CATEGORY_COUNTERPARTY_INSURANCE_POLICY: 'Karşı taraf trafik sigortası',
    AUTOFILL_FIELD_COUNTERPARTY_NAME: 'Karşı taraf adı',
    AUTOFILL_FIELD_COUNTERPARTY_SURNAME: 'Karşı taraf soyadı',
    AUTOFILL_FIELD_COUNTERPARTY_TCKN: 'Karşı taraf TCKN',
    AUTOFILL_FIELD_COUNTERPARTY_VEHICLE_PLATE: 'Karşı taraf araç plakası',
    AUTOFILL_FIELD_OWNER_FIRST_NAME: 'Müşteri adı',
    AUTOFILL_FIELD_OWNER_LAST_NAME: 'Müşteri soyadı',
    AUTOFILL_FIELD_OWNER_TCKN: 'TCKN',
    AUTOFILL_FIELD_OWNER_BIRTH_DATE: 'Müşteri doğum tarihi',
    AUTOFILL_FIELD_LICENSE_CLASS: 'Ehliyet sınıfı',
    AUTOFILL_FIELD_LICENSE_NO: 'Ehliyet numarası',
    AUTOFILL_FIELD_VEHICLE_PLATE: 'Araç plakası',
    AUTOFILL_FIELD_VEHICLE_BRAND: 'Araç markası',
    AUTOFILL_FIELD_VEHICLE_MODEL: 'Araç modeli',
    AUTOFILL_FIELD_MODEL_YEAR: 'Model yılı',
    AUTOFILL_FIELD_CHASSIS_NO: 'Şasi numarası',
    AUTOFILL_FIELD_USAGE_TYPE: 'Kullanım tarzı',
    AUTOFILL_FIELD_MILEAGE: 'Kilometre',
    AUTOFILL_FIELD_UNKNOWN: 'Önerilen alan',
    AUTOFILL_REVIEW_EMPTY: 'Bu belgelerden otomatik olarak uygulanabilecek bilgi bulunamadı.',
    AUTOFILL_NO_FIELDS_WARNING: 'Form alanları için öneri oluşturulamadı',
    AUTOFILL_PARTIAL_WARNING: 'Bazı belge bilgileri otomatik olarak uygulanamadı.',
    AUTOFILL_UNRESOLVED_EVIDENCE: 'Çözümlenemeyen kanıtlar',
    AUTOFILL_UNRESOLVED_uncertainIdentity: 'Kişi kimliği belirsiz',
    AUTOFILL_UNRESOLVED_conflictingEvidence: 'Belgeler çelişiyor',
    AUTOFILL_UNRESOLVED_unclassifiedDocument: 'Belge sınıflandırılamadı',
    AUTOFILL_UNRESOLVED_unmatchedSide: 'Kazadaki taraf belirlenemedi',
    AUTOFILL_UNRESOLVED_unsupportedField: 'Değer bu dosya türünde desteklenmiyor',
    AUTOFILL_UNRESOLVED_documentUnreadable: 'Belge okunamadı',
    AUTOFILL_UNRESOLVED_uncertainReading: 'Belge okuması belirsiz',
    AUTOFILL_WARNING_DESCRIPTION: 'Doğrulanan öneriler korundu, ancak bazı görseller güvenle anlaşılamadı. Belge atamalarını kontrol edin ve eksik alanları elle doldurun.',
    AUTOFILL_DOCUMENT_FAILED: 'analiz başarısız',
    AUTOFILL_PARTY_UNRESOLVED: 'kişi bu dosyayla eşleştirilemedi',
    AUTOFILL_DOCUMENT_UNKNOWN: 'sınıflandırılamadı',
    AUTOFILL_DOCUMENT_WEAK: 'düşük güven',
    AUTOFILL_DOCUMENT_RETRIED: 'bir kez yeniden incelendi',
    AUTOFILL_DOCUMENT_COUNTS: '{{extracted}} değer okundu, {{valid}} tanesi biçimce geçerli, {{held}} tanesi kişi eşleşmesi için bekletildi',
    AUTOFILL_CASE_CORROBORATED: 'Dosya genelindeki incelemede belgeler arasında eşleşti',
    AUTOFILL_CASE_AI_PREFERRED: 'YZ bu değeri öneriyor; kaynak belgelerden doğrulayın',
    AUTOFILL_CASE_RECONCILIATION_UNAVAILABLE_TITLE: 'Dosya eşleştirmesi tamamlanamadı',
    AUTOFILL_CASE_RECONCILIATION_UNAVAILABLE_HELP: 'Belge bazındaki öneriler kullanılabilir; ancak ilişkili kişiler ve araçlar eşleştirilmemiş olabilir. Uygulamadan önce kaynak belgeleri kontrol edin.',
    AUTOFILL_CATEGORY_VIN_PHOTO: 'Şasi numarası fotoğrafı',
    AUTOFILL_ERROR_AI_TITLE: 'Yapay zeka analizi tamamlanamadı',
    AUTOFILL_ERROR_AI_DESCRIPTION: 'YZ analizini tekrar deneyin.',
    AUTOFILL_RETRY_AI: 'YZ Analizini Tekrarla',
    AUTOFILL_APPLY_SELECTED: 'Seçilenleri uygula ({{count}})',
  },
  CASE_EVENTS: {
    BOOKING_CREATED: {
      TITLE: 'Randevu oluşturuldu',
      DETAIL: 'Web sitesi randevusu oluşturuldu.',
    },
    VEHICLE_REGISTERED: {
      TITLE: 'Araç kaydı oluşturuldu',
      DETAIL: 'Araç kaydedildi ve vaka oluşturuldu.',
    },
    CASE_DELIVERED: {
      TITLE: 'Vaka teslim edildi',
      DETAIL: 'Araç teslim edildi ve vaka tamamlandı.',
    },
    INVOICE_ISSUED: {
      TITLE: 'Fatura kesildi',
      DETAIL: 'Vaka fatura kesildi olarak işaretlendi.',
    },
    INVOICE_COLLECTED: {
      TITLE: 'Fatura tahsil edildi',
      DETAIL: 'Fatura tahsil edildi olarak işaretlendi.',
    },
    INVOICE_COLLECTION_REVERTED: {
      TITLE: 'Fatura tahsil işareti kaldırıldı',
      DETAIL: 'Vakanın fatura tahsil edildi işareti kaldırıldı.',
    },
    INVOICE_UNISSUED: {
      TITLE: 'Fatura işareti kaldırıldı',
      DETAIL: 'Vakanın fatura kesildi işareti kaldırıldı.',
    },
  },
  WORK_ORDER_WORK_EVENTS: {
    UNKNOWN_WORK: 'ilgili iş kalemi',
    UNKNOWN_WORKSHOP: 'ilgili',
    FALLBACK_TITLE: 'Statü güncellemesi',
    FALLBACK_DETAIL: 'Yeni bir iş hareketi kaydedildi.',
    ON_BEHALF_OF: '{{technician}} adına gerçekleştirildi; KPI katkısı bu teknisyene aittir.',
    UNKNOWN: {
      TITLE: 'Statü güncellemesi',
      DETAIL: '{{work}} için yeni bir iş hareketi kaydedildi.',
    },
    DAMAGE_ANALYSIS_COMPLETED: {
      TITLE: 'Hasar analizi onaylandı',
      DETAIL: 'Hasar analizi onaylandı; iş emirleri parça hazırlığı ve teknisyen atamasını bekliyor.',
    },
    DAMAGE_ANALYSIS_APPROVAL_REVERTED: {
      TITLE: 'Hasar analizi onayı geri çekildi',
      DETAIL: 'Hasar analizi onayı geri çekildi ve analiz tekrar düzenlenebilir hale geldi.',
    },
    DAMAGE_ANALYSIS_WORK_ADDED: {
      TITLE: 'Hasar / işlem eklendi',
      DETAIL: '{{work}} hasar analizine eklendi.',
    },
    DELETION_REQUESTED: {
      TITLE: 'Silme talebi oluşturuldu',
      DETAIL: '{{requester}}, bu {{target}} için silme talebi oluşturdu.',
    },
    DELETION_REQUEST_WITHDRAWN: {
      TITLE: 'Silme talebi geri çekildi',
      DETAIL: '{{requester}}, bu {{target}} için silme talebini geri çekti.',
    },
    DELETION_REQUEST_REJECTED: {
      TITLE: 'Silme talebi reddedildi',
      DETAIL: '{{reviewer}}, bu {{target}} için silme talebini reddetti.',
    },
    ADDITIONAL_WORK_ORDER_CREATED: {
      TITLE: 'Ek iş emri oluşturuldu',
      DETAIL: '{{work}} ek iş olarak oluşturuldu ve hasar analizi onayı bekliyor.',
    },
    ADDITIONAL_WORK_ORDER_APPROVED: {
      TITLE: 'Ek iş emri onaylandı',
      DETAIL: '{{work}} onaylandı ve atama için hazır.',
    },
    ADDITIONAL_WORK_ORDER_CANCELLED: {
      TITLE: 'Ek iş emri iptal edildi',
      DETAIL: '{{work}} hasar analizi onayından önce iptal edildi.',
    },
    DAMAGE_ANALYSIS_WORK_UPDATED: {
      TITLE: 'Hasar / işlem güncellendi',
      DETAIL: '{{work}} hasar analizinde güncellendi.',
    },
    BILLING_WORK_ORDER_PRICE_UPDATED: {
      TITLE: 'İş emri fiyatı güncellendi',
      DETAIL: '{{work}} işçilik fiyatı {{previousPrice}} ₺ tutarından {{newPrice}} ₺ tutarına güncellendi.',
    },
    BILLING_PART_PRICE_UPDATED: {
      TITLE: 'Yedek parça fiyatı güncellendi',
      DETAIL: '{{work}} işindeki {{part}} birim fiyatı {{previousPrice}} ₺ tutarından {{newPrice}} ₺ tutarına güncellendi.',
    },
    BILLING_PART_SALE_PRICE_UPDATED: {
      TITLE: 'Yedek parça satış fiyatı güncellendi',
      DETAIL: '{{work}} işindeki {{part}} satış fiyatı {{previousPrice}} ₺ tutarından {{newPrice}} ₺ tutarına güncellendi.',
    },
    ANALYST_NOTES_UPDATED: {
      TITLE: 'Analist notları güncellendi',
      DETAIL: '{{work}} için analist notları güncellendi.',
    },
    ANALYST_NOTES_CLEARED: {
      TITLE: 'Analist notları kaldırıldı',
      DETAIL: '{{work}} için analist notları kaldırıldı.',
    },
    DAMAGE_ANALYSIS_WORK_REMOVED: {
      TITLE: 'Hasar / işlem kaldırıldı',
      DETAIL: '{{work}} hasar analizinden kaldırıldı.',
    },
    DAMAGE_ANALYSIS_PART_ADDED: {
      TITLE: 'Yedek parça eklendi',
      DETAIL: '{{part}}, {{work}} işlemine eklendi.',
    },
    DAMAGE_ANALYSIS_PART_UPDATED: {
      TITLE: 'Yedek parça güncellendi',
      DETAIL: '{{part}}, {{work}} işleminde güncellendi.',
    },
    DAMAGE_ANALYSIS_PART_REMOVED: {
      TITLE: 'Yedek parça kaldırıldı',
      DETAIL: '{{part}}, {{work}} işleminden kaldırıldı.',
    },
    SERVICE_MANAGER_APPROVED: {
      TITLE: 'Dosya servis şefi tarafından onaylandı',
      DETAIL: '{{work}} için servis şefi onayı tamamlandı. Sıradaki adım birim ataması.',
    },
    SERVICE_MANAGER_RETURNED: {
      TITLE: 'Servis şefi dosyayı iade etti',
      DETAIL: '{{work}} bir önceki kontrol adımına geri gönderildi.',
    },
    WORKSHOP_ASSIGNED: {
      TITLE: 'Atölye hazırlığı onaylandı',
      DETAIL: '{{work}} işi için {{workshop}} atölye hazırlığı Atölye Yöneticisi tarafından onaylandı.',
    },
    TECHNICIAN_ASSIGNED: {
      TITLE: 'Teknisyen atandı',
      DETAIL: '{{work}} işi {{assignedUserDisplayName}} adlı teknisyene atandı.',
    },
    TECHNICIAN_UNASSIGNED: {
      TITLE: 'Teknisyen ataması kaldırıldı',
      DETAIL: '{{previousAssignedUserDisplayName}}, {{work}} işinden çıkarıldı.',
    },
    READY_FOR_WORK: {
      TITLE: 'Çalışmaya hazır',
      DETAIL: 'Tüm iş emirlerinin parçaları hazır ve teknisyen atamaları tamamlandı.',
    },
    WORK_STARTED: {
      TITLE: 'İş başlatıldı',
      DETAIL: '{{work}} için araç üzerinde işlem başlatıldı.',
    },
    WORK_PAUSED: {
      TITLE: 'İş duraklatıldı',
      DETAIL: '{{work}} işi duraklatıldı.',
    },
    WORK_RESUMED: {
      TITLE: 'İşe devam edildi',
      DETAIL: '{{work}} işi yeniden başlatıldı.',
    },
    WORK_COMPLETED: {
      TITLE: 'İş tamamlandı',
      DETAIL: '{{work}} işlemi tamamlandı ve onay adımına gönderildi.',
    },
    WORKSHOP_MANAGER_APPROVED: {
      TITLE: 'Atölye Yöneticisi işi onayladı',
      DETAIL: '{{work}} Atölye Yöneticisi tarafından onaylandı ve sonraki planlama adımına geçti.',
    },
    WORKSHOP_MANAGER_REJECTED: {
      TITLE: 'Atölye Yöneticisi işi iade etti',
      DETAIL: '{{work}} revizyon için ustaya geri gönderildi.',
    },
    REPEAT_WORK_ORDER_CREATED: {
      TITLE: 'İş tekrarı emri oluşturuldu',
      DETAIL: 'İş tekrarı emri oluşturuldu.',
    },
    REPEAT_WORK_ORDER_CANCELLED: {
      TITLE: 'İş tekrarı emri iptal edildi',
      DETAIL: 'İş tekrarı emri iptal edildi.',
    },
    REPEAT_WORK_ORDER_DELIVERED: {
      TITLE: 'İş tekrarı teslim edildi',
      DETAIL: '{{work}} teslim edildi.',
    },
    WORKSHOP_MANAGER_APPROVAL_REVERTED: {
      TITLE: 'Atölye Yöneticisi tamamlanma onayı geri çekildi',
      DETAIL: '{{work}} için verilen tamamlanma onayı geri çekildi ve iş yeniden Atölye Yöneticisi kontrolü bekliyor.',
    },
    SERVICE_REVIEW_SENT: {
      TITLE: 'Final servis kontrolüne gönderildi',
      DETAIL: 'Dosya servis şefi final kontrolüne gönderildi.',
    },
    WORK_ORDER_READY: {
      TITLE: 'Teslime hazır',
      DETAIL: 'Tüm onaylar tamamlandı. Dosya teslim hazırlık aşamasine geçti.',
    },
    WORK_ORDER_STATUS_CHANGED: {
      TITLE: 'İş emri durumu değişti',
      DETAIL: '{{work}} statüsü {{fromCaseWorkStatus}} -> {{toCaseWorkStatus}} olarak değişti.',
    },
  },
};
